export const CATEGORIES = [
    {
        value: "",
        label: "All",
        name_slug: "all",
        children: [],
    },
    {
        value: "601450",
        label: "Beauty & Personal Care",
        name_slug: "beauty-personal-care",
        children: [
            {
                value: "981128",
                label: "Special Personal Care",
                name_slug: "special-personal-care",
                children: [
                    {
                        value: "981384",
                        label: "Insect Repellents",
                        name_slug: "insect-repellents",
                    },
                    {
                        value: "1005064",
                        label: "Incontinence Bed Pads",
                        name_slug: "incontinence-bed-pads",
                    },
                    {
                        value: "856328",
                        label: "Ice Packs",
                        name_slug: "ice-packs",
                    },
                    {
                        value: "700662",
                        label: "Heat Patches",
                        name_slug: "heat-patches",
                    },
                    {
                        value: "981256",
                        label: "Adult Diapers",
                        name_slug: "adult-diapers",
                    },
                ],
            },
            {
                value: "848776",
                label: "Skincare",
                name_slug: "skincare",
                children: [
                    {
                        value: "601608",
                        label: "Toners",
                        name_slug: "toners",
                    },
                    {
                        value: "601733",
                        label: "Skincare Tools",
                        name_slug: "skincare-tools",
                    },
                    {
                        value: "601611",
                        label: "Skin Care Kits",
                        name_slug: "skin-care-kits",
                    },
                    {
                        value: "601619",
                        label: "Serums & Essences",
                        name_slug: "serums-essences",
                    },
                    {
                        value: "601653",
                        label: "Nasal Treatment",
                        name_slug: "nasal-treatment",
                    },
                    {
                        value: "601615",
                        label: "Moisturizers & Mists",
                        name_slug: "moisturizers-mists",
                    },
                    {
                        value: "601595",
                        label: "Lip Treatments",
                        name_slug: "lip-treatments",
                    },
                    {
                        value: "601602",
                        label: "Facial Sunscreen & Sun Care",
                        name_slug: "facial-sunscreen-sun-care",
                    },
                    {
                        value: "601610",
                        label: "Facial Massage Cream",
                        name_slug: "facial-massage-cream",
                    },
                    {
                        value: "601609",
                        label: "Facial Cleansers",
                        name_slug: "facial-cleansers",
                    },
                    {
                        value: "601613",
                        label: "Face Scrubs & Peels",
                        name_slug: "face-scrubs-peels",
                    },
                    {
                        value: "601616",
                        label: "Face Masks",
                        name_slug: "face-masks",
                    },
                    {
                        value: "601646",
                        label: "Eye Treatments",
                        name_slug: "eye-treatments",
                    },
                    {
                        value: "873480",
                        label: "Acne Treatments",
                        name_slug: "acne-treatments",
                    },
                ],
            },
            {
                value: "849416",
                label: "Personal Care Appliances",
                name_slug: "personal-care-appliances",
                children: [
                    {
                        value: "1027208",
                        label: "Refurbished Haircare Device",
                        name_slug: "refurbished-haircare-device",
                    },
                    {
                        value: "874248",
                        label: "Oral Irrigators",
                        name_slug: "oral-irrigators",
                    },
                    {
                        value: "854032",
                        label: "Nose & Ear Hair Trimmers",
                        name_slug: "nose-ear-hair-trimmers",
                    },
                    {
                        value: "601660",
                        label: "Massage Devices",
                        name_slug: "massage-devices",
                    },
                    {
                        value: "848016",
                        label: "Massage Chairs",
                        name_slug: "massage-chairs",
                    },
                    {
                        value: "2167568",
                        label: "Heating Pad",
                        name_slug: "heating-pad",
                    },
                    {
                        value: "874632",
                        label: "Hair Trimmers & Clippers",
                        name_slug: "hair-trimmers-clippers",
                    },
                    {
                        value: "824464",
                        label: "Hair Removal Devices",
                        name_slug: "hair-removal-devices",
                    },
                    {
                        value: "874376",
                        label: "Hair Dryers",
                        name_slug: "hair-dryers",
                    },
                    {
                        value: "601672",
                        label: "Facial Beauty Devices",
                        name_slug: "facial-beauty-devices",
                    },
                    {
                        value: "2167696",
                        label: "Electronic Otoscopes",
                        name_slug: "electronic-otoscopes",
                    },
                    {
                        value: "874120",
                        label: "Electric Toothbrushes",
                        name_slug: "electric-toothbrushes",
                    },
                    {
                        value: "873992",
                        label: "Electric Shavers",
                        name_slug: "electric-shavers",
                    },
                    {
                        value: "601669",
                        label: "Electric Eyebrow Shapers",
                        name_slug: "electric-eyebrow-shapers",
                    },
                    {
                        value: "874504",
                        label: "Curlers & Straighteners",
                        name_slug: "curlers-straighteners",
                    },
                    {
                        value: "2167824",
                        label: "Body Hair Trimmers",
                        name_slug: "body-hair-trimmers",
                    },
                    {
                        value: "601664",
                        label: "Body Beauty Devices",
                        name_slug: "body-beauty-devices",
                    },
                    {
                        value: "601677",
                        label: "Accessories",
                        name_slug: "accessories",
                    },
                ],
            },
            {
                value: "849672",
                label: "Nasal & Oral Care",
                name_slug: "nasal-oral-care",
                children: [
                    {
                        value: "601696",
                        label: "Toothpastes",
                        name_slug: "toothpastes",
                    },
                    {
                        value: "601697",
                        label: "Toothbrushes",
                        name_slug: "toothbrushes",
                    },
                    {
                        value: "824208",
                        label: "Tongue Cleaners",
                        name_slug: "tongue-cleaners",
                    },
                    {
                        value: "601690",
                        label: "Teeth Whitening",
                        name_slug: "teeth-whitening",
                    },
                    {
                        value: "2167952",
                        label: "Teeth Grinding Guards",
                        name_slug: "teeth-grinding-guards",
                    },
                    {
                        value: "978184",
                        label: "Orthodontic Accessories",
                        name_slug: "orthodontic-accessories",
                    },
                    {
                        value: "601693",
                        label: "Oral Spray",
                        name_slug: "oral-spray",
                    },
                    {
                        value: "601692",
                        label: "Oral Care Kits",
                        name_slug: "oral-care-kits",
                    },
                    {
                        value: "875400",
                        label: "Nasal Cleaning",
                        name_slug: "nasal-cleaning",
                    },
                    {
                        value: "601694",
                        label: "Mouthwash",
                        name_slug: "mouthwash",
                    },
                    {
                        value: "875272",
                        label: "Denture Care",
                        name_slug: "denture-care",
                    },
                    {
                        value: "601698",
                        label: "Dental Floss & Picks",
                        name_slug: "dental-floss-picks",
                    },
                ],
            },
            {
                value: "849288",
                label: "Men's Care",
                name_slug: "mens-care",
                children: [
                    {
                        value: "601627",
                        label: "Skincare",
                        name_slug: "skincare",
                    },
                    {
                        value: "1004808",
                        label: "Shaving Tool Sets",
                        name_slug: "shaving-tool-sets",
                    },
                    {
                        value: "601644",
                        label: "Shaving Foam & Aftershave",
                        name_slug: "shaving-foam-aftershave",
                    },
                    {
                        value: "700791",
                        label: "Razors",
                        name_slug: "razors",
                    },
                    {
                        value: "2168080",
                        label: "Men's Intimate Care & Wipes",
                        name_slug: "mens-intimate-care-wipes",
                    },
                    {
                        value: "2168208",
                        label: "Men's Grooming",
                        name_slug: "mens-grooming",
                    },
                    {
                        value: "2168336",
                        label: "Men's Deodorant",
                        name_slug: "mens-deodorant",
                    },
                    {
                        value: "1004936",
                        label: "Manual Shaving Accessories",
                        name_slug: "manual-shaving-accessories",
                    },
                    {
                        value: "601565",
                        label: "Makeup",
                        name_slug: "makeup",
                    },
                    {
                        value: "601681",
                        label: "Hair Care",
                        name_slug: "hair-care",
                    },
                    {
                        value: "601520",
                        label: "Bath & Body Care",
                        name_slug: "bath-body-care",
                    },
                ],
            },
            {
                value: "848648",
                label: "Makeup",
                name_slug: "makeup",
                children: [
                    {
                        value: "824592",
                        label: "Temporary Tattoos",
                        name_slug: "temporary-tattoos",
                    },
                    {
                        value: "1004424",
                        label: "Tattoo Removal",
                        name_slug: "tattoo-removal",
                    },
                    {
                        value: "993672",
                        label: "Tattoo Machines & Kits",
                        name_slug: "tattoo-machines-kits",
                    },
                    {
                        value: "853264",
                        label: "Powder Puffs",
                        name_slug: "powder-puffs",
                    },
                    {
                        value: "601558",
                        label: "Powder",
                        name_slug: "powder",
                    },
                    {
                        value: "601583",
                        label: "Perfume",
                        name_slug: "perfume",
                    },
                    {
                        value: "601585",
                        label: "Mascara",
                        name_slug: "mascara",
                    },
                    {
                        value: "601537",
                        label: "Makeup Tools",
                        name_slug: "makeup-tools",
                    },
                    {
                        value: "601529",
                        label: "Makeup Sets",
                        name_slug: "makeup-sets",
                    },
                    {
                        value: "601618",
                        label: "Makeup Remover",
                        name_slug: "makeup-remover",
                    },
                    {
                        value: "852752",
                        label: "Makeup Mirrors",
                        name_slug: "makeup-mirrors",
                    },
                    {
                        value: "601552",
                        label: "Makeup Fixing Spray",
                        name_slug: "makeup-fixing-spray",
                    },
                    {
                        value: "852880",
                        label: "Makeup Brushes",
                        name_slug: "makeup-brushes",
                    },
                    {
                        value: "853008",
                        label: "Makeup Blenders & Sponges",
                        name_slug: "makeup-blenders-sponges",
                    },
                    {
                        value: "601556",
                        label: "Makeup Base and Primers",
                        name_slug: "makeup-base-and-primers",
                    },
                    {
                        value: "601534",
                        label: "Lipstick & Lip Gloss",
                        name_slug: "lipstick-lip-gloss",
                    },
                    {
                        value: "853520",
                        label: "Lash Enhancers & Primers",
                        name_slug: "lash-enhancers-primers",
                    },
                    {
                        value: "824720",
                        label: "False Eyelashes & Adhesives",
                        name_slug: "false-eyelashes-adhesives",
                    },
                    {
                        value: "601588",
                        label: "Eyeshadow",
                        name_slug: "eyeshadow",
                    },
                    {
                        value: "601587",
                        label: "Eyeliner & Lipliner",
                        name_slug: "eyeliner-lipliner",
                    },
                    {
                        value: "853392",
                        label: "Eyelash Curlers",
                        name_slug: "eyelash-curlers",
                    },
                    {
                        value: "601586",
                        label: "Eyebrow Products",
                        name_slug: "eyebrow-products",
                    },
                    {
                        value: "853136",
                        label: "Cotton Swabs",
                        name_slug: "cotton-swabs",
                    },
                    {
                        value: "601554",
                        label: "Concealer & Foundation",
                        name_slug: "concealer-foundation",
                    },
                    {
                        value: "601555",
                        label: "Bronzer & Highlighter",
                        name_slug: "bronzer-highlighter",
                    },
                    {
                        value: "601582",
                        label: "Body Makeup",
                        name_slug: "body-makeup",
                    },
                    {
                        value: "601560",
                        label: "Blush",
                        name_slug: "blush",
                    },
                    {
                        value: "601550",
                        label: "BB & CC Creams",
                        name_slug: "bb-cc-creams",
                    },
                ],
            },
            {
                value: "849032",
                label: "Hand, Foot & Nail Care",
                name_slug: "hand-foot-nail-care",
                children: [
                    {
                        value: "977672",
                        label: "Nail Treatments",
                        name_slug: "nail-treatments",
                    },
                    {
                        value: "1004680",
                        label: "Nail Polish Removers",
                        name_slug: "nail-polish-removers",
                    },
                    {
                        value: "824336",
                        label: "Nail Art Kits",
                        name_slug: "nail-art-kits",
                    },
                    {
                        value: "852112",
                        label: "Nail Art Decoration & Accessories",
                        name_slug: "nail-art-decoration-accessories",
                    },
                    {
                        value: "601591",
                        label: "Nail Art & Nail Polish",
                        name_slug: "nail-art-nail-polish",
                    },
                    {
                        value: "700790",
                        label: "Manicure & Pedicure Tools",
                        name_slug: "manicure-pedicure-tools",
                    },
                    {
                        value: "601508",
                        label: "Hand Wash",
                        name_slug: "hand-wash",
                    },
                    {
                        value: "1004552",
                        label: "Hand Sanitizers",
                        name_slug: "hand-sanitizers",
                    },
                    {
                        value: "601454",
                        label: "Hand & Foot Masks",
                        name_slug: "hand-foot-masks",
                    },
                    {
                        value: "601480",
                        label: "Hand & Foot Lotions, Creams & Scrubs",
                        name_slug: "hand-foot-lotions-creams-scrubs",
                    },
                    {
                        value: "601456",
                        label: "Foot Treatments & Remedies",
                        name_slug: "foot-treatments-remedies",
                    },
                ],
            },
            {
                value: "848904",
                label: "Haircare & Styling",
                name_slug: "haircare-styling",
                children: [
                    {
                        value: "601469",
                        label: "Shampoo & Conditioner",
                        name_slug: "shampoo-conditioner",
                    },
                    {
                        value: "2168464",
                        label: "Scalp Treatments",
                        name_slug: "scalp-treatments",
                    },
                    {
                        value: "601513",
                        label: "Mousse & Gel",
                        name_slug: "mousse-gel",
                    },
                    {
                        value: "2168592",
                        label: "Hairdresser Furnishings",
                        name_slug: "hairdresser-furnishings",
                    },
                    {
                        value: "700789",
                        label: "Hair Styling Tools",
                        name_slug: "hair-styling-tools",
                    },
                    {
                        value: "1004168",
                        label: "Hair Styling Powders",
                        name_slug: "hair-styling-powders",
                    },
                    {
                        value: "2168720",
                        label: "Hair Relaxers",
                        name_slug: "hair-relaxers",
                    },
                    {
                        value: "2168848",
                        label: "Hair Perms & Texturizers",
                        name_slug: "hair-perms-texturizers",
                    },
                    {
                        value: "981512",
                        label: "Hair Oils & Treatments",
                        name_slug: "hair-oils-treatments",
                    },
                    {
                        value: "806160",
                        label: "Hair Loss Products",
                        name_slug: "hair-loss-products",
                    },
                    {
                        value: "2168976",
                        label: "Hair Lice Treatments",
                        name_slug: "hair-lice-treatments",
                    },
                    {
                        value: "1011080",
                        label: "Hair Fragrance",
                        name_slug: "hair-fragrance",
                    },
                    {
                        value: "601516",
                        label: "Hair Color",
                        name_slug: "hair-color",
                    },
                    {
                        value: "851984",
                        label: "Hair Brushes & Combs",
                        name_slug: "hair-brushes-combs",
                    },
                ],
            },
            {
                value: "856208",
                label: "Fragrance",
                name_slug: "fragrance",
                children: [
                    {
                        value: "855952",
                        label: "Women's Fragrance",
                        name_slug: "womens-fragrance",
                    },
                    {
                        value: "855824",
                        label: "Unisex Fragrance",
                        name_slug: "unisex-fragrance",
                    },
                    {
                        value: "855696",
                        label: "Men's Fragrance",
                        name_slug: "mens-fragrance",
                    },
                    {
                        value: "856080",
                        label: "Fragrance Sets",
                        name_slug: "fragrance-sets",
                    },
                ],
            },
            {
                value: "849800",
                label: "Feminine Care",
                name_slug: "feminine-care",
                children: [
                    {
                        value: "875528",
                        label: "Tampons",
                        name_slug: "tampons",
                    },
                    {
                        value: "601477",
                        label: "Pads, Liners & Protectors",
                        name_slug: "pads-liners-protectors",
                    },
                    {
                        value: "2169104",
                        label: "Menstrual Underwear",
                        name_slug: "menstrual-underwear",
                    },
                    {
                        value: "875784",
                        label: "Menstrual Cups & Discs",
                        name_slug: "menstrual-cups-discs",
                    },
                    {
                        value: "1011208",
                        label: "Menstrual Cup Case and Sterilizer",
                        name_slug: "menstrual-cup-case-and-sterilizer",
                    },
                    {
                        value: "805648",
                        label: "Menopause Products",
                        name_slug: "menopause-products",
                    },
                    {
                        value: "601476",
                        label: "Intimate Washes & Wipes",
                        name_slug: "intimate-washes-wipes",
                    },
                    {
                        value: "1004296",
                        label: "Feminine Deodorants",
                        name_slug: "feminine-deodorants",
                    },
                    {
                        value: "601475",
                        label: "Feminine Creams & Moisturizers",
                        name_slug: "feminine-creams-moisturizers",
                    },
                ],
            },
            {
                value: "849544",
                label: "Eye & Ear Care",
                name_slug: "eye-ear-care",
                children: [
                    {
                        value: "601737",
                        label: "Sleep Masks",
                        name_slug: "sleep-masks",
                    },
                    {
                        value: "874760",
                        label: "Reading Glasses",
                        name_slug: "reading-glasses",
                    },
                    {
                        value: "875016",
                        label: "Earwax Removal Products",
                        name_slug: "earwax-removal-products",
                    },
                    {
                        value: "875144",
                        label: "Ear Plugs",
                        name_slug: "ear-plugs",
                    },
                    {
                        value: "874888",
                        label: "Ear Drops",
                        name_slug: "ear-drops",
                    },
                    {
                        value: "601461",
                        label: "Contact Lens Solutions & Eyedrops",
                        name_slug: "contact-lens-solutions-eyedrops",
                    },
                    {
                        value: "601463",
                        label: "Contact Lens Care Accessories",
                        name_slug: "contact-lens-care-accessories",
                    },
                    {
                        value: "601462",
                        label: "Contact Lens",
                        name_slug: "contact-lens",
                    },
                    {
                        value: "854160",
                        label: "Colored Contact Lens",
                        name_slug: "colored-contact-lens",
                    },
                ],
            },
            {
                value: "849160",
                label: "Bath & Body Care",
                name_slug: "bath-body-care",
                children: [
                    {
                        value: "2169232",
                        label: "Tattoo Aftercare Balms & Creams",
                        name_slug: "tattoo-aftercare-balms-creams",
                    },
                    {
                        value: "978056",
                        label: "Tanning",
                        name_slug: "tanning",
                    },
                    {
                        value: "601494",
                        label: "Talcum Powder",
                        name_slug: "talcum-powder",
                    },
                    {
                        value: "1003784",
                        label: "Neck Care",
                        name_slug: "neck-care",
                    },
                    {
                        value: "700785",
                        label: "Manual Massage Tools",
                        name_slug: "manual-massage-tools",
                    },
                    {
                        value: "601495",
                        label: "Hair Removal Cream, Wax & Shave",
                        name_slug: "hair-removal-cream-wax-shave",
                    },
                    {
                        value: "601498",
                        label: "Deodorants & Antiperspirants",
                        name_slug: "deodorants-antiperspirants",
                    },
                    {
                        value: "601511",
                        label: "Breast Cream/Lotion",
                        name_slug: "breast-creamlotion",
                    },
                    {
                        value: "873864",
                        label: "Body Sunscreen",
                        name_slug: "body-sunscreen",
                    },
                    {
                        value: "601686",
                        label: "Body Shaping Cream",
                        name_slug: "body-shaping-cream",
                    },
                    {
                        value: "601506",
                        label: "Body Scrubs & Peels",
                        name_slug: "body-scrubs-peels",
                    },
                    {
                        value: "601492",
                        label: "Body Moisturizers",
                        name_slug: "body-moisturizers",
                    },
                    {
                        value: "873608",
                        label: "Body Masks",
                        name_slug: "body-masks",
                    },
                    {
                        value: "601490",
                        label: "Body Care Sets",
                        name_slug: "body-care-sets",
                    },
                    {
                        value: "873736",
                        label: "Body & Massage Oil",
                        name_slug: "body-massage-oil",
                    },
                    {
                        value: "853512",
                        label: "Bathing Accessories",
                        name_slug: "bathing-accessories",
                    },
                    {
                        value: "601493",
                        label: "Bath & Shower",
                        name_slug: "bath-shower",
                    },
                ],
            },
        ],
    },
    {
        value: "601152",
        label: "Womenswear & Underwear",
        name_slug: "womenswear-underwear",
        children: [
            {
                value: "842888",
                label: "Women's Underwear",
                name_slug: "womens-underwear",
                children: [
                    {
                        value: "845704",
                        label: "Underwear Sets",
                        name_slug: "underwear-sets",
                    },
                    {
                        value: "844552",
                        label: "Tights",
                        name_slug: "tights",
                    },
                    {
                        value: "844680",
                        label: "Thermal Underwear",
                        name_slug: "thermal-underwear",
                    },
                    {
                        value: "845448",
                        label: "Socks",
                        name_slug: "socks",
                    },
                    {
                        value: "601259",
                        label: "Shapewear",
                        name_slug: "shapewear",
                    },
                    {
                        value: "601247",
                        label: "Panties",
                        name_slug: "panties",
                    },
                    {
                        value: "845192",
                        label: "Lingerie",
                        name_slug: "lingerie",
                    },
                    {
                        value: "601262",
                        label: "Bras",
                        name_slug: "bras",
                    },
                    {
                        value: "845576",
                        label: "Bralettes",
                        name_slug: "bralettes",
                    },
                    {
                        value: "844936",
                        label: "Bra Accessories",
                        name_slug: "bra-accessories",
                    },
                ],
            },
            {
                value: "842248",
                label: "Women's Tops",
                name_slug: "womens-tops",
                children: [
                    {
                        value: "601282",
                        label: "Women's Vests",
                        name_slug: "womens-vests",
                    },
                    {
                        value: "843400",
                        label: "Women's Tanks & Camis",
                        name_slug: "womens-tanks-camis",
                    },
                    {
                        value: "601302",
                        label: "Women's T-shirts",
                        name_slug: "womens-t-shirts",
                    },
                    {
                        value: "961032",
                        label: "Women's Polo Shirts",
                        name_slug: "womens-polo-shirts",
                    },
                    {
                        value: "601284",
                        label: "Women's Knitwear",
                        name_slug: "womens-knitwear",
                    },
                    {
                        value: "601267",
                        label: "Jackets & Coats",
                        name_slug: "jackets-coats",
                    },
                    {
                        value: "601295",
                        label: "Hoodies & Sweatshirts",
                        name_slug: "hoodies-sweatshirts",
                    },
                    {
                        value: "843528",
                        label: "Bodysuits",
                        name_slug: "bodysuits",
                    },
                    {
                        value: "601265",
                        label: "Blouses & Shirts",
                        name_slug: "blouses-shirts",
                    },
                ],
            },
            {
                value: "842760",
                label: "Women's Suits & Sets",
                name_slug: "womens-suits-sets",
                children: [
                    {
                        value: "601296",
                        label: "Women's Suits",
                        name_slug: "womens-suits",
                    },
                    {
                        value: "601291",
                        label: "Women's Clothing Sets",
                        name_slug: "womens-clothing-sets",
                    },
                    {
                        value: "601280",
                        label: "Overalls",
                        name_slug: "overalls",
                    },
                    {
                        value: "844296",
                        label: "Family Clothing Sets",
                        name_slug: "family-clothing-sets",
                    },
                    {
                        value: "844040",
                        label: "Couples Clothing Sets",
                        name_slug: "couples-clothing-sets",
                    },
                ],
            },
            {
                value: "842632",
                label: "Women's Special Clothing",
                name_slug: "womens-special-clothing",
                children: [
                    {
                        value: "843784",
                        label: "Workwear & Uniforms",
                        name_slug: "workwear-uniforms",
                    },
                    {
                        value: "843912",
                        label: "Traditional Dress",
                        name_slug: "traditional-dress",
                    },
                    {
                        value: "843656",
                        label: "Costumes & Accessories",
                        name_slug: "costumes-accessories",
                    },
                ],
            },
            {
                value: "2337680",
                label: "Women's South Asian Clothing",
                name_slug: "womens-south-asian-clothing",
                children: [
                    {
                        value: "2338320",
                        label: "Suits",
                        name_slug: "suits",
                    },
                    {
                        value: "2338192",
                        label: "Sarees",
                        name_slug: "sarees",
                    },
                    {
                        value: "2338448",
                        label: "Salwar Kameez",
                        name_slug: "salwar-kameez",
                    },
                    {
                        value: "2338064",
                        label: "Dresses",
                        name_slug: "dresses",
                    },
                ],
            },
            {
                value: "843016",
                label: "Women's Sleepwear & Loungewear",
                name_slug: "womens-sleepwear-loungewear",
                children: [
                    {
                        value: "845832",
                        label: "Pajamas & Loungewear",
                        name_slug: "pajamas-loungewear",
                    },
                    {
                        value: "803216",
                        label: "Onesies",
                        name_slug: "onesies",
                    },
                    {
                        value: "846088",
                        label: "Nightdresses",
                        name_slug: "nightdresses",
                    },
                    {
                        value: "845960",
                        label: "Bathrobes & Dressing Gowns",
                        name_slug: "bathrobes-dressing-gowns",
                    },
                ],
            },
            {
                value: "842504",
                label: "Women's Dresses",
                name_slug: "womens-dresses",
                children: [
                    {
                        value: "601270",
                        label: "Wedding Dresses",
                        name_slug: "wedding-dresses",
                    },
                    {
                        value: "601271",
                        label: "Formal Dresses",
                        name_slug: "formal-dresses",
                    },
                    {
                        value: "601281",
                        label: "Casual Dresses",
                        name_slug: "casual-dresses",
                    },
                    {
                        value: "961672",
                        label: "Bridesmaid Dresses",
                        name_slug: "bridesmaid-dresses",
                    },
                ],
            },
            {
                value: "842376",
                label: "Women's Bottoms",
                name_slug: "womens-bottoms",
                children: [
                    {
                        value: "601264",
                        label: "Skirts",
                        name_slug: "skirts",
                    },
                    {
                        value: "601266",
                        label: "Shorts",
                        name_slug: "shorts",
                    },
                    {
                        value: "854928",
                        label: "Pantskirts",
                        name_slug: "pantskirts",
                    },
                    {
                        value: "601277",
                        label: "Pants",
                        name_slug: "pants",
                    },
                    {
                        value: "601274",
                        label: "Leggings",
                        name_slug: "leggings",
                    },
                    {
                        value: "601276",
                        label: "Jeans",
                        name_slug: "jeans",
                    },
                ],
            },
        ],
    },
    {
        value: "824328",
        label: "Menswear & Underwear",
        name_slug: "menswear-underwear",
        children: [
            {
                value: "840456",
                label: "Men's Underwear & Socks",
                name_slug: "mens-underwear-socks",
                children: [
                    {
                        value: "841736",
                        label: "Socks",
                        name_slug: "socks",
                    },
                    {
                        value: "841352",
                        label: "Men's Underwear",
                        name_slug: "mens-underwear",
                    },
                    {
                        value: "841608",
                        label: "Men's Thermal Underwear",
                        name_slug: "mens-thermal-underwear",
                    },
                    {
                        value: "841480",
                        label: "Men's Tanks & Undershirts",
                        name_slug: "mens-tanks-undershirts",
                    },
                    {
                        value: "2157712",
                        label: "Men's Shapewear",
                        name_slug: "mens-shapewear",
                    },
                ],
            },
            {
                value: "839944",
                label: "Men's Tops",
                name_slug: "mens-tops",
                children: [
                    {
                        value: "601194",
                        label: "Waistcoats & Gilets",
                        name_slug: "waistcoats-gilets",
                    },
                    {
                        value: "960648",
                        label: "Vests",
                        name_slug: "vests",
                    },
                    {
                        value: "601226",
                        label: "T-shirts",
                        name_slug: "t-shirts",
                    },
                    {
                        value: "601195",
                        label: "Shirts",
                        name_slug: "shirts",
                    },
                    {
                        value: "960776",
                        label: "Polo Shirts",
                        name_slug: "polo-shirts",
                    },
                    {
                        value: "601223",
                        label: "Knitwear",
                        name_slug: "knitwear",
                    },
                    {
                        value: "601197",
                        label: "Jackets & Coats",
                        name_slug: "jackets-coats",
                    },
                    {
                        value: "601213",
                        label: "Hoodies & Sweatshirts",
                        name_slug: "hoodies-sweatshirts",
                    },
                ],
            },
            {
                value: "840712",
                label: "Men's Suits & Sets",
                name_slug: "mens-suits-sets",
                children: [
                    {
                        value: "840840",
                        label: "Overalls",
                        name_slug: "overalls",
                    },
                    {
                        value: "601216",
                        label: "Men's Suits",
                        name_slug: "mens-suits",
                    },
                    {
                        value: "601210",
                        label: "Men's Clothing Sets",
                        name_slug: "mens-clothing-sets",
                    },
                ],
            },
            {
                value: "840328",
                label: "Men's Special Occasion Clothing",
                name_slug: "mens-special-occasion-clothing",
                children: [
                    {
                        value: "841096",
                        label: "Workwear & Uniforms",
                        name_slug: "workwear-uniforms",
                    },
                    {
                        value: "841224",
                        label: "Traditional Clothing",
                        name_slug: "traditional-clothing",
                    },
                    {
                        value: "840968",
                        label: "Costumes & Accessories",
                        name_slug: "costumes-accessories",
                    },
                ],
            },
            {
                value: "2337808",
                label: "Men's South Asian Clothing",
                name_slug: "mens-south-asian-clothing",
                children: [
                    {
                        value: "2338576",
                        label: "Trousers",
                        name_slug: "trousers",
                    },
                    {
                        value: "2338704",
                        label: "Shirts",
                        name_slug: "shirts",
                    },
                    {
                        value: "2338832",
                        label: "Kurtas",
                        name_slug: "kurtas",
                    },
                ],
            },
            {
                value: "840584",
                label: "Men's Sleepwear & Loungewear",
                name_slug: "mens-sleepwear-loungewear",
                children: [
                    {
                        value: "841864",
                        label: "Pajamas & Loungewear",
                        name_slug: "pajamas-loungewear",
                    },
                    {
                        value: "842120",
                        label: "Nightshirts",
                        name_slug: "nightshirts",
                    },
                    {
                        value: "841992",
                        label: "Men's Robes",
                        name_slug: "mens-robes",
                    },
                    {
                        value: "803344",
                        label: "Men's Pajamas Onesies",
                        name_slug: "mens-pajamas-onesies",
                    },
                ],
            },
            {
                value: "840072",
                label: "Men's Bottoms",
                name_slug: "mens-bottoms",
                children: [
                    {
                        value: "601196",
                        label: "Men's Shorts",
                        name_slug: "mens-shorts",
                    },
                    {
                        value: "601218",
                        label: "Men's Pants",
                        name_slug: "mens-pants",
                    },
                    {
                        value: "601202",
                        label: "Men's Jeans",
                        name_slug: "mens-jeans",
                    },
                ],
            },
        ],
    },
    {
        value: "600001",
        label: "Home Supplies",
        name_slug: "home-supplies",
        children: [
            {
                value: "852616",
                label: "Miscellaneous Home",
                name_slug: "miscellaneous-home",
                children: [
                    {
                        value: "600570",
                        label: "Umbrellas",
                        name_slug: "umbrellas",
                    },
                    {
                        value: "600573",
                        label: "Raincoats",
                        name_slug: "raincoats",
                    },
                    {
                        value: "600574",
                        label: "Rain Shoes & Covers",
                        name_slug: "rain-shoes-covers",
                    },
                    {
                        value: "600569",
                        label: "Rain Cloths",
                        name_slug: "rain-cloths",
                    },
                    {
                        value: "856456",
                        label: "Lighter Accessories",
                        name_slug: "lighter-accessories",
                    },
                    {
                        value: "856200",
                        label: "Hot Water Bottles",
                        name_slug: "hot-water-bottles",
                    },
                ],
            },
            {
                value: "852360",
                label: "Laundry Tools & Accessories",
                name_slug: "laundry-tools-accessories",
                children: [
                    {
                        value: "1014280",
                        label: "Washing Machine Cleaners",
                        name_slug: "washing-machine-cleaners",
                    },
                    {
                        value: "600750",
                        label: "Washing Lines",
                        name_slug: "washing-lines",
                    },
                    {
                        value: "600747",
                        label: "Washing Bags",
                        name_slug: "washing-bags",
                    },
                    {
                        value: "855304",
                        label: "Washboards",
                        name_slug: "washboards",
                    },
                    {
                        value: "1014152",
                        label: "Starch & Anti-static Sprays",
                        name_slug: "starch-anti-static-sprays",
                    },
                    {
                        value: "1014024",
                        label: "Stain Removers",
                        name_slug: "stain-removers",
                    },
                    {
                        value: "1013896",
                        label: "Liquid Fabric Softener",
                        name_slug: "liquid-fabric-softener",
                    },
                    {
                        value: "1013768",
                        label: "Laundry Detergent",
                        name_slug: "laundry-detergent",
                    },
                    {
                        value: "2160144",
                        label: "Laundry Buskets",
                        name_slug: "laundry-buskets",
                    },
                    {
                        value: "855176",
                        label: "Laundry Balls & Discs",
                        name_slug: "laundry-balls-discs",
                    },
                    {
                        value: "600756",
                        label: "Ironing Boards",
                        name_slug: "ironing-boards",
                    },
                    {
                        value: "1013640",
                        label: "Fabric Deodorizer",
                        name_slug: "fabric-deodorizer",
                    },
                    {
                        value: "600758",
                        label: "Drying Racks",
                        name_slug: "drying-racks",
                    },
                    {
                        value: "1013512",
                        label: "Dryer Sheets",
                        name_slug: "dryer-sheets",
                    },
                    {
                        value: "1013384",
                        label: "Bleach",
                        name_slug: "bleach",
                    },
                ],
            },
            {
                value: "851848",
                label: "Home Organizers",
                name_slug: "home-organizers",
                children: [
                    {
                        value: "852872",
                        label: "Storage Holders & Racks",
                        name_slug: "storage-holders-racks",
                    },
                    {
                        value: "600621",
                        label: "Storage Boxes & Bins",
                        name_slug: "storage-boxes-bins",
                    },
                    {
                        value: "853000",
                        label: "Storage Bottles & Jars",
                        name_slug: "storage-bottles-jars",
                    },
                    {
                        value: "600686",
                        label: "Storage Baskets",
                        name_slug: "storage-baskets",
                    },
                    {
                        value: "852744",
                        label: "Storage Bags",
                        name_slug: "storage-bags",
                    },
                    {
                        value: "853128",
                        label: "Hooks & Rails",
                        name_slug: "hooks-rails",
                    },
                    {
                        value: "600748",
                        label: "Hangers & Pegs",
                        name_slug: "hangers-pegs",
                    },
                ],
            },
            {
                value: "852104",
                label: "Home Decor",
                name_slug: "home-decor",
                children: [
                    {
                        value: "700655",
                        label: "Vase & Fillers",
                        name_slug: "vase-fillers",
                    },
                    {
                        value: "853896",
                        label: "Tapestries",
                        name_slug: "tapestries",
                    },
                    {
                        value: "600299",
                        label: "Statues & Figurines",
                        name_slug: "statues-figurines",
                    },
                    {
                        value: "854792",
                        label: "Religious Decorations",
                        name_slug: "religious-decorations",
                    },
                    {
                        value: "854536",
                        label: "Refrigerator Magnets",
                        name_slug: "refrigerator-magnets",
                    },
                    {
                        value: "1000072",
                        label: "Posters & Prints",
                        name_slug: "posters-prints",
                    },
                    {
                        value: "982280",
                        label: "Plaques & Signs",
                        name_slug: "plaques-signs",
                    },
                    {
                        value: "984200",
                        label: "Piggy Banks",
                        name_slug: "piggy-banks",
                    },
                    {
                        value: "600341",
                        label: "Photo Frames",
                        name_slug: "photo-frames",
                    },
                    {
                        value: "982408",
                        label: "Photo Albums",
                        name_slug: "photo-albums",
                    },
                    {
                        value: "806544",
                        label: "Music Boxes",
                        name_slug: "music-boxes",
                    },
                    {
                        value: "854408",
                        label: "Mirrors",
                        name_slug: "mirrors",
                    },
                    {
                        value: "600347",
                        label: "Hooks & Shelves",
                        name_slug: "hooks-shelves",
                    },
                    {
                        value: "854024",
                        label: "Hanging Decor",
                        name_slug: "hanging-decor",
                    },
                    {
                        value: "984712",
                        label: "Hand Fans",
                        name_slug: "hand-fans",
                    },
                    {
                        value: "854664",
                        label: "Fengshui Ornaments",
                        name_slug: "fengshui-ornaments",
                    },
                    {
                        value: "806288",
                        label: "Door Stops",
                        name_slug: "door-stops",
                    },
                    {
                        value: "600338",
                        label: "Decorative Stickers",
                        name_slug: "decorative-stickers",
                    },
                    {
                        value: "700656",
                        label: "Decorative Painting",
                        name_slug: "decorative-painting",
                    },
                    {
                        value: "700654",
                        label: "Decorative Flowers, Plants & Fruit",
                        name_slug: "decorative-flowers-plants-fruit",
                    },
                    {
                        value: "600321",
                        label: "Clocks",
                        name_slug: "clocks",
                    },
                    {
                        value: "806416",
                        label: "Cardboard Cutouts",
                        name_slug: "cardboard-cutouts",
                    },
                    {
                        value: "854152",
                        label: "Candles",
                        name_slug: "candles",
                    },
                    {
                        value: "854280",
                        label: "Candle Holders",
                        name_slug: "candle-holders",
                    },
                ],
            },
            {
                value: "852232",
                label: "Home Care Supplies",
                name_slug: "home-care-supplies",
                children: [
                    {
                        value: "600401",
                        label: "Trash Bags",
                        name_slug: "trash-bags",
                    },
                    {
                        value: "600839",
                        label: "Toilet Paper & Wipes",
                        name_slug: "toilet-paper-wipes",
                    },
                    {
                        value: "993544",
                        label: "Tissues & Napkins",
                        name_slug: "tissues-napkins",
                    },
                    {
                        value: "600418",
                        label: "Squeegees",
                        name_slug: "squeegees",
                    },
                    {
                        value: "855048",
                        label: "Sponges & Scouring Pads",
                        name_slug: "sponges-scouring-pads",
                    },
                    {
                        value: "817296",
                        label: "Splash Guards",
                        name_slug: "splash-guards",
                    },
                    {
                        value: "600466",
                        label: "Pest & Weed Control",
                        name_slug: "pest-weed-control",
                    },
                    {
                        value: "600458",
                        label: "Moth, Mold & Damp Proofing",
                        name_slug: "moth-mold-damp-proofing",
                    },
                    {
                        value: "600423",
                        label: "Mops",
                        name_slug: "mops",
                    },
                    {
                        value: "993416",
                        label: "Kitchen Rolls & Wipes",
                        name_slug: "kitchen-rolls-wipes",
                    },
                    {
                        value: "600812",
                        label: "Household Cleaners",
                        name_slug: "household-cleaners",
                    },
                    {
                        value: "600477",
                        label: "Home Fragrances",
                        name_slug: "home-fragrances",
                    },
                    {
                        value: "600475",
                        label: "Formaldehyde Removers",
                        name_slug: "formaldehyde-removers",
                    },
                    {
                        value: "600378",
                        label: "Dusters/Duster Heads",
                        name_slug: "dustersduster-heads",
                    },
                    {
                        value: "700665",
                        label: "Dust Covers",
                        name_slug: "dust-covers",
                    },
                    {
                        value: "994184",
                        label: "Disposable Shoe Covers",
                        name_slug: "disposable-shoe-covers",
                    },
                    {
                        value: "600396",
                        label: "Cleaning Gloves",
                        name_slug: "cleaning-gloves",
                    },
                    {
                        value: "600409",
                        label: "Cleaning Cloths",
                        name_slug: "cleaning-cloths",
                    },
                    {
                        value: "854920",
                        label: "Buckets",
                        name_slug: "buckets",
                    },
                    {
                        value: "600417",
                        label: "Brooms",
                        name_slug: "brooms",
                    },
                    {
                        value: "600403",
                        label: "Bins",
                        name_slug: "bins",
                    },
                    {
                        value: "600427",
                        label: "Aprons",
                        name_slug: "aprons",
                    },
                ],
            },
            {
                value: "852488",
                label: "Festive & Party Supplies",
                name_slug: "festive-party-supplies",
                children: [
                    {
                        value: "889616",
                        label: "Wedding Supplies",
                        name_slug: "wedding-supplies",
                    },
                    {
                        value: "600019",
                        label: "Sprays, Confetti & Streamers",
                        name_slug: "sprays-confetti-streamers",
                    },
                    {
                        value: "1001736",
                        label: "Sky Lanterns",
                        name_slug: "sky-lanterns",
                    },
                    {
                        value: "855816",
                        label: "Party Hats, Masks & Accessories",
                        name_slug: "party-hats-masks-accessories",
                    },
                    {
                        value: "855944",
                        label: "Party Bags & Gifts",
                        name_slug: "party-bags-gifts",
                    },
                    {
                        value: "889104",
                        label: "Matches",
                        name_slug: "matches",
                    },
                    {
                        value: "600009",
                        label: "Festive Decorations",
                        name_slug: "festive-decorations",
                    },
                    {
                        value: "855688",
                        label: "Disposable Tableware",
                        name_slug: "disposable-tableware",
                    },
                    {
                        value: "856072",
                        label: "Cake Decorations",
                        name_slug: "cake-decorations",
                    },
                    {
                        value: "600017",
                        label: "Balloons",
                        name_slug: "balloons",
                    },
                    {
                        value: "855432",
                        label: "Backdrops & Banners",
                        name_slug: "backdrops-banners",
                    },
                ],
            },
            {
                value: "851976",
                label: "Bathroom Supplies",
                name_slug: "bathroom-supplies",
                children: [
                    {
                        value: "600451",
                        label: "Wash Tubs & Foot Baths",
                        name_slug: "wash-tubs-foot-baths",
                    },
                    {
                        value: "810888",
                        label: "Towels",
                        name_slug: "towels",
                    },
                    {
                        value: "600436",
                        label: "Toothbrush Holders",
                        name_slug: "toothbrush-holders",
                    },
                    {
                        value: "600406",
                        label: "Toilet Seat Covers",
                        name_slug: "toilet-seat-covers",
                    },
                    {
                        value: "600405",
                        label: "Toilet Brush & Plungers",
                        name_slug: "toilet-brush-plungers",
                    },
                    {
                        value: "600416",
                        label: "Soap Dispensers",
                        name_slug: "soap-dispensers",
                    },
                    {
                        value: "600447",
                        label: "Soap Dishes",
                        name_slug: "soap-dishes",
                    },
                    {
                        value: "600439",
                        label: "Shower Curtains & Rods",
                        name_slug: "shower-curtains-rods",
                    },
                    {
                        value: "853768",
                        label: "Shower Caps",
                        name_slug: "shower-caps",
                    },
                    {
                        value: "600430",
                        label: "Bathroom Tumblers",
                        name_slug: "bathroom-tumblers",
                    },
                    {
                        value: "853384",
                        label: "Bathroom Sets",
                        name_slug: "bathroom-sets",
                    },
                    {
                        value: "853256",
                        label: "Bathroom Gadgets",
                        name_slug: "bathroom-gadgets",
                    },
                    {
                        value: "853640",
                        label: "Bath Mats",
                        name_slug: "bath-mats",
                    },
                ],
            },
        ],
    },
    {
        value: "605248",
        label: "Fashion Accessories",
        name_slug: "fashion-accessories",
        children: [
            {
                value: "888592",
                label: "Wedding Accessories",
                name_slug: "wedding-accessories",
                children: [
                    {
                        value: "2161040",
                        label: "Wrist Corsages",
                        name_slug: "wrist-corsages",
                    },
                    {
                        value: "2161168",
                        label: "Wedding Jackets & Wraps",
                        name_slug: "wedding-jackets-wraps",
                    },
                    {
                        value: "889232",
                        label: "Traditional Men's Accessories",
                        name_slug: "traditional-mens-accessories",
                    },
                    {
                        value: "2161296",
                        label: "Petticoats",
                        name_slug: "petticoats",
                    },
                    {
                        value: "890768",
                        label: "Mahr",
                        name_slug: "mahr",
                    },
                    {
                        value: "889360",
                        label: "Groom's Belt",
                        name_slug: "grooms-belt",
                    },
                    {
                        value: "2161424",
                        label: "Bridal Veils",
                        name_slug: "bridal-veils",
                    },
                    {
                        value: "2161552",
                        label: "Bridal Headwear",
                        name_slug: "bridal-headwear",
                    },
                    {
                        value: "2161680",
                        label: "Bridal Gloves",
                        name_slug: "bridal-gloves",
                    },
                    {
                        value: "2161808",
                        label: "Bridal Belts",
                        name_slug: "bridal-belts",
                    },
                    {
                        value: "2161936",
                        label: "Boutonnieres",
                        name_slug: "boutonnieres",
                    },
                ],
            },
            {
                value: "810128",
                label: "Hair Extensions & Wigs",
                name_slug: "hair-extensions-wigs",
                children: [
                    {
                        value: "812816",
                        label: "Synthetic Lace Front Wigs",
                        name_slug: "synthetic-lace-front-wigs",
                    },
                    {
                        value: "812688",
                        label: "Synthetic Full Machine Wigs",
                        name_slug: "synthetic-full-machine-wigs",
                    },
                    {
                        value: "812944",
                        label: "Synthetic Extensions & Pieces",
                        name_slug: "synthetic-extensions-pieces",
                    },
                    {
                        value: "908808",
                        label: "Synthetic Costume Wigs",
                        name_slug: "synthetic-costume-wigs",
                    },
                    {
                        value: "812560",
                        label: "Synthetic Braided Lace Wigs",
                        name_slug: "synthetic-braided-lace-wigs",
                    },
                    {
                        value: "811536",
                        label: "Human Hair T Part Lace Wigs",
                        name_slug: "human-hair-t-part-lace-wigs",
                    },
                    {
                        value: "908680",
                        label: "Human Hair Silk Base Lace Wigs",
                        name_slug: "human-hair-silk-base-lace-wigs",
                    },
                    {
                        value: "811920",
                        label: "Human Hair Lace Front Wigs",
                        name_slug: "human-hair-lace-front-wigs",
                    },
                    {
                        value: "812048",
                        label: "Human Hair Lace Closure Wigs",
                        name_slug: "human-hair-lace-closure-wigs",
                    },
                    {
                        value: "812304",
                        label: "Human Hair Full Machine Wigs",
                        name_slug: "human-hair-full-machine-wigs",
                    },
                    {
                        value: "811664",
                        label: "Human Hair Full Lace Wigs",
                        name_slug: "human-hair-full-lace-wigs",
                    },
                    {
                        value: "812432",
                        label: "Human Hair Extensions & Pieces",
                        name_slug: "human-hair-extensions-pieces",
                    },
                    {
                        value: "812176",
                        label: "Human Hair Custom Lace Wigs",
                        name_slug: "human-hair-custom-lace-wigs",
                    },
                    {
                        value: "811792",
                        label: "Human Hair 360 Lace Wigs",
                        name_slug: "human-hair-360-lace-wigs",
                    },
                    {
                        value: "846096",
                        label: "Hair Extensions & Wigs Accessories",
                        name_slug: "hair-extensions-wigs-accessories",
                    },
                ],
            },
            {
                value: "905864",
                label: "Hair Accessories",
                name_slug: "hair-accessories",
                children: [
                    {
                        value: "908936",
                        label: "Headpieces & Crowns",
                        name_slug: "headpieces-crowns",
                    },
                    {
                        value: "605271",
                        label: "Headbands",
                        name_slug: "headbands",
                    },
                    {
                        value: "908424",
                        label: "Hairbands & Scrunchies",
                        name_slug: "hairbands-scrunchies",
                    },
                    {
                        value: "2314256",
                        label: "Hair Curler",
                        name_slug: "hair-curler",
                    },
                    {
                        value: "908552",
                        label: "Hair Clips & Hair Pins",
                        name_slug: "hair-clips-hair-pins",
                    },
                    {
                        value: "2314384",
                        label: "Hair Accessory Sets",
                        name_slug: "hair-accessory-sets",
                    },
                ],
            },
            {
                value: "905480",
                label: "Fashion Watches & Accessories",
                name_slug: "fashion-watches-accessories",
                children: [
                    {
                        value: "605254",
                        label: "Fashion Women's Watches",
                        name_slug: "fashion-womens-watches",
                    },
                    {
                        value: "700795",
                        label: "Fashion Watch Accessories",
                        name_slug: "fashion-watch-accessories",
                    },
                    {
                        value: "907144",
                        label: "Fashion Unisex Watches",
                        name_slug: "fashion-unisex-watches",
                    },
                    {
                        value: "605251",
                        label: "Fashion Men's Watches",
                        name_slug: "fashion-mens-watches",
                    },
                    {
                        value: "605257",
                        label: "Fashion Couple Watches",
                        name_slug: "fashion-couple-watches",
                    },
                ],
            },
            {
                value: "905352",
                label: "Eyewear",
                name_slug: "eyewear",
                children: [
                    {
                        value: "605304",
                        label: "Sunglasses",
                        name_slug: "sunglasses",
                    },
                    {
                        value: "907016",
                        label: "Glasses Cases & Accessories",
                        name_slug: "glasses-cases-accessories",
                    },
                    {
                        value: "605302",
                        label: "Frames & Glasses",
                        name_slug: "frames-glasses",
                    },
                ],
            },
            {
                value: "843144",
                label: "Dressmaking Fabrics",
                name_slug: "dressmaking-fabrics",
                children: [
                    {
                        value: "846600",
                        label: "Wool",
                        name_slug: "wool",
                    },
                    {
                        value: "846728",
                        label: "Velvet, Silk & Satin",
                        name_slug: "velvet-silk-satin",
                    },
                    {
                        value: "847496",
                        label: "Songket",
                        name_slug: "songket",
                    },
                    {
                        value: "846984",
                        label: "Polyester",
                        name_slug: "polyester",
                    },
                    {
                        value: "846856",
                        label: "Leather",
                        name_slug: "leather",
                    },
                    {
                        value: "846344",
                        label: "Lace",
                        name_slug: "lace",
                    },
                    {
                        value: "847368",
                        label: "Kain Pasang",
                        name_slug: "kain-pasang",
                    },
                    {
                        value: "847112",
                        label: "Denim",
                        name_slug: "denim",
                    },
                    {
                        value: "846472",
                        label: "Cotton",
                        name_slug: "cotton",
                    },
                    {
                        value: "847240",
                        label: "Canvas",
                        name_slug: "canvas",
                    },
                    {
                        value: "846216",
                        label: "Batik",
                        name_slug: "batik",
                    },
                ],
            },
            {
                value: "905608",
                label: "Costume Jewelry & Accessories",
                name_slug: "costume-jewelry-accessories",
                children: [
                    {
                        value: "605273",
                        label: "Rings",
                        name_slug: "rings",
                    },
                    {
                        value: "605280",
                        label: "Necklaces",
                        name_slug: "necklaces",
                    },
                    {
                        value: "907656",
                        label: "Keychains",
                        name_slug: "keychains",
                    },
                    {
                        value: "907784",
                        label: "Jewelry Sets",
                        name_slug: "jewelry-sets",
                    },
                    {
                        value: "995080",
                        label: "Jewelry Adjusters & Protectors",
                        name_slug: "jewelry-adjusters-protectors",
                    },
                    {
                        value: "605268",
                        label: "Earrings",
                        name_slug: "earrings",
                    },
                    {
                        value: "907400",
                        label: "Charms & Pendants",
                        name_slug: "charms-pendants",
                    },
                    {
                        value: "605274",
                        label: "Bracelets & Bangles",
                        name_slug: "bracelets-bangles",
                    },
                    {
                        value: "907528",
                        label: "Body Jewelry",
                        name_slug: "body-jewelry",
                    },
                    {
                        value: "605272",
                        label: "Anklets",
                        name_slug: "anklets",
                    },
                ],
            },
            {
                value: "905224",
                label: "Clothes Accessories",
                name_slug: "clothes-accessories",
                children: [
                    {
                        value: "906504",
                        label: "Ties & Bow ties",
                        name_slug: "ties-bow-ties",
                    },
                    {
                        value: "905992",
                        label: "Scarves & Shawls",
                        name_slug: "scarves-shawls",
                    },
                    {
                        value: "906248",
                        label: "Hats",
                        name_slug: "hats",
                    },
                    {
                        value: "906632",
                        label: "Handkerchiefs",
                        name_slug: "handkerchiefs",
                    },
                    {
                        value: "906120",
                        label: "Fashion Gloves",
                        name_slug: "fashion-gloves",
                    },
                    {
                        value: "605289",
                        label: "Fashion Accessory Sets",
                        name_slug: "fashion-accessory-sets",
                    },
                    {
                        value: "906760",
                        label: "Face Covering Masks & Accessories",
                        name_slug: "face-covering-masks-accessories",
                    },
                    {
                        value: "960392",
                        label: "Earmuffs",
                        name_slug: "earmuffs",
                    },
                    {
                        value: "906888",
                        label: "Cuff Links, Shirt Studs & Tie Clips",
                        name_slug: "cuff-links-shirt-studs-tie-clips",
                    },
                    {
                        value: "605281",
                        label: "Collar Clips & Brooches",
                        name_slug: "collar-clips-brooches",
                    },
                    {
                        value: "906376",
                        label: "Belts",
                        name_slug: "belts",
                    },
                ],
            },
        ],
    },
    {
        value: "601739",
        label: "Phones & Electronics",
        name_slug: "phones-electronics",
        children: [
            {
                value: "978952",
                label: "Universal Accessories",
                name_slug: "universal-accessories",
                children: [
                    {
                        value: "842128",
                        label: "Universal Battery Chargers",
                        name_slug: "universal-battery-chargers",
                    },
                    {
                        value: "803856",
                        label: "USB Vacuums",
                        name_slug: "usb-vacuums",
                    },
                    {
                        value: "983816",
                        label: "USB & Mobile Lights",
                        name_slug: "usb-mobile-lights",
                    },
                    {
                        value: "990728",
                        label: "USB & Mobile Fans",
                        name_slug: "usb-mobile-fans",
                    },
                    {
                        value: "1011720",
                        label: "Power Strips & Surge Protectors",
                        name_slug: "power-strips-surge-protectors",
                    },
                    {
                        value: "1022600",
                        label: "Power Stations & Accessories",
                        name_slug: "power-stations-accessories",
                    },
                    {
                        value: "979208",
                        label: "Pocket Wi-Fi",
                        name_slug: "pocket-wi-fi",
                    },
                    {
                        value: "841872",
                        label: "Dry Cell Batteries",
                        name_slug: "dry-cell-batteries",
                    },
                    {
                        value: "842000",
                        label: "Button Batteries",
                        name_slug: "button-batteries",
                    },
                ],
            },
            {
                value: "984584",
                label: "Tablet & Computer Accessories",
                name_slug: "tablet-computer-accessories",
                children: [
                    {
                        value: "992136",
                        label: "Tablet Stands & Bases",
                        name_slug: "tablet-stands-bases",
                    },
                    {
                        value: "991880",
                        label: "Tablet Screen Protectors",
                        name_slug: "tablet-screen-protectors",
                    },
                    {
                        value: "991752",
                        label: "Tablet Parts",
                        name_slug: "tablet-parts",
                    },
                    {
                        value: "992008",
                        label: "Tablet Keyboards",
                        name_slug: "tablet-keyboards",
                    },
                    {
                        value: "991496",
                        label: "Tablet Covers & Cases",
                        name_slug: "tablet-covers-cases",
                    },
                    {
                        value: "991624",
                        label: "Tablet Chargers & Adapters",
                        name_slug: "tablet-chargers-adapters",
                    },
                    {
                        value: "993288",
                        label: "Tablet Bags & Sleeves",
                        name_slug: "tablet-bags-sleeves",
                    },
                    {
                        value: "992264",
                        label: "Styluses",
                        name_slug: "styluses",
                    },
                ],
            },
            {
                value: "2108944",
                label: "Smart & Wearable Devices",
                name_slug: "smart-wearable-devices",
                children: [
                    {
                        value: "2156304",
                        label: "Sports Technology",
                        name_slug: "sports-technology",
                    },
                ],
            },
            {
                value: "909576",
                label: "Smart & Wearable Devices",
                name_slug: "smart-wearable-devices",
                children: [
                    {
                        value: "602080",
                        label: "Wearable Accessories",
                        name_slug: "wearable-accessories",
                    },
                    {
                        value: "914312",
                        label: "VR Devices",
                        name_slug: "vr-devices",
                    },
                    {
                        value: "602083",
                        label: "Smart Watches",
                        name_slug: "smart-watches",
                    },
                    {
                        value: "1011592",
                        label: "Smart Rings",
                        name_slug: "smart-rings",
                    },
                    {
                        value: "803728",
                        label: "Smart Glasses",
                        name_slug: "smart-glasses",
                    },
                    {
                        value: "914184",
                        label: "GPS, Finders & Accessories",
                        name_slug: "gps-finders-accessories",
                    },
                    {
                        value: "914056",
                        label: "Fitness Trackers",
                        name_slug: "fitness-trackers",
                    },
                ],
            },
            {
                value: "2109072",
                label: "Refurbished Electronics",
                name_slug: "refurbished-electronics",
                children: [
                    {
                        value: "2157200",
                        label: "Refurbished eReaders",
                        name_slug: "refurbished-ereaders",
                    },
                    {
                        value: "2156432",
                        label: "Refurbished Televisions",
                        name_slug: "refurbished-televisions",
                    },
                    {
                        value: "2156560",
                        label: "Refurbished Tablets & Tablet Accessories",
                        name_slug: "refurbished-tablets-tablet-accessories",
                    },
                    {
                        value: "2156688",
                        label: "Refurbished Smart & Wearable Devices",
                        name_slug: "refurbished-smart-wearable-devices",
                    },
                    {
                        value: "1027080",
                        label: "Refurbished Power Banks",
                        name_slug: "refurbished-power-banks",
                    },
                    {
                        value: "1026952",
                        label: "Refurbished Portable Power Stations",
                        name_slug: "refurbished-portable-power-stations",
                    },
                    {
                        value: "2156816",
                        label: "Refurbished Mobile Phones",
                        name_slug: "refurbished-mobile-phones",
                    },
                    {
                        value: "2156944",
                        label: "Refurbished Mobile Phone Accessories",
                        name_slug: "refurbished-mobile-phone-accessories",
                    },
                    {
                        value: "2157072",
                        label: "Refurbished Gaming & Consoles",
                        name_slug: "refurbished-gaming-consoles",
                    },
                    {
                        value: "2157328",
                        label: "Refurbished Computers & Accessories",
                        name_slug: "refurbished-computers-accessories",
                    },
                    {
                        value: "2157456",
                        label: "Refurbished Audio & Video",
                        name_slug: "refurbished-audio-video",
                    },
                ],
            },
            {
                value: "995976",
                label: "Phones & Tablets",
                name_slug: "phones-tablets",
                children: [
                    {
                        value: "825224",
                        label: "Tablets",
                        name_slug: "tablets",
                    },
                    {
                        value: "602097",
                        label: "Mobile Phones",
                        name_slug: "mobile-phones",
                    },
                ],
            },
            {
                value: "909064",
                label: "Mobile Phone Accessories",
                name_slug: "mobile-phone-accessories",
                children: [
                    {
                        value: "909960",
                        label: "Selfie Accessories",
                        name_slug: "selfie-accessories",
                    },
                    {
                        value: "910216",
                        label: "SIM Cards & Accessories",
                        name_slug: "sim-cards-accessories",
                    },
                    {
                        value: "910728",
                        label: "Power Banks",
                        name_slug: "power-banks",
                    },
                    {
                        value: "601936",
                        label: "Phone Straps & Charms",
                        name_slug: "phone-straps-charms",
                    },
                    {
                        value: "910344",
                        label: "Phone Holders & Mounts",
                        name_slug: "phone-holders-mounts",
                    },
                    {
                        value: "601927",
                        label: "Phone Batteries",
                        name_slug: "phone-batteries",
                    },
                    {
                        value: "909832",
                        label: "Mobile Phone Parts",
                        name_slug: "mobile-phone-parts",
                    },
                    {
                        value: "910088",
                        label: "Mobile Lenses & Flashes",
                        name_slug: "mobile-lenses-flashes",
                    },
                    {
                        value: "910472",
                        label: "Casting Devices",
                        name_slug: "casting-devices",
                    },
                    {
                        value: "601925",
                        label: "Cases, Screen Protectors & Stickers",
                        name_slug: "cases-screen-protectors-stickers",
                    },
                    {
                        value: "601937",
                        label: "Cables, Chargers & Adapters",
                        name_slug: "cables-chargers-adapters",
                    },
                ],
            },
            {
                value: "909448",
                label: "Gaming & Consoles",
                name_slug: "gaming-consoles",
                children: [
                    {
                        value: "913800",
                        label: "Video Games",
                        name_slug: "video-games",
                    },
                    {
                        value: "2157584",
                        label: "Prepaid Gaming Cards",
                        name_slug: "prepaid-gaming-cards",
                    },
                    {
                        value: "2312976",
                        label: "PC Gaming Accessories",
                        name_slug: "pc-gaming-accessories",
                    },
                    {
                        value: "913544",
                        label: "Home Games Consoles",
                        name_slug: "home-games-consoles",
                    },
                    {
                        value: "913672",
                        label: "Handheld Games Consoles",
                        name_slug: "handheld-games-consoles",
                    },
                    {
                        value: "913928",
                        label: "Console Accessories",
                        name_slug: "console-accessories",
                    },
                ],
            },
            {
                value: "909704",
                label: "Education Devices",
                name_slug: "education-devices",
                children: [
                    {
                        value: "914440",
                        label: "eReader Device",
                        name_slug: "ereader-device",
                    },
                    {
                        value: "984840",
                        label: "Writing Tablets",
                        name_slug: "writing-tablets",
                    },
                    {
                        value: "985096",
                        label: "Reading Pens & Devices",
                        name_slug: "reading-pens-devices",
                    },
                    {
                        value: "1022472",
                        label: "Foreign Language Translator",
                        name_slug: "foreign-language-translator",
                    },
                    {
                        value: "984968",
                        label: "Electronic Notebooks",
                        name_slug: "electronic-notebooks",
                    },
                    {
                        value: "985224",
                        label: "Electronic Learning Devices",
                        name_slug: "electronic-learning-devices",
                    },
                    {
                        value: "978824",
                        label: "Education Device Parts & Accessories",
                        name_slug: "education-device-parts-accessories",
                    },
                    {
                        value: "914568",
                        label: "E-dictionaries",
                        name_slug: "e-dictionaries",
                    },
                    {
                        value: "985352",
                        label: "Digital & Smart Pens",
                        name_slug: "digital-smart-pens",
                    },
                ],
            },
            {
                value: "909192",
                label: "Cameras & Photography",
                name_slug: "cameras-photography",
                children: [
                    {
                        value: "911240",
                        label: "Video Camcorders",
                        name_slug: "video-camcorders",
                    },
                    {
                        value: "911752",
                        label: "Security Cameras & Systems",
                        name_slug: "security-cameras-systems",
                    },
                    {
                        value: "910856",
                        label: "Point & Shoot Cameras",
                        name_slug: "point-shoot-cameras",
                    },
                    {
                        value: "910984",
                        label: "Mirrorless Cameras",
                        name_slug: "mirrorless-cameras",
                    },
                    {
                        value: "911368",
                        label: "Instant Cameras",
                        name_slug: "instant-cameras",
                    },
                    {
                        value: "911496",
                        label: "Film Cameras",
                        name_slug: "film-cameras",
                    },
                    {
                        value: "912008",
                        label: "Drones & Accessories",
                        name_slug: "drones-accessories",
                    },
                    {
                        value: "911624",
                        label: "DSLRs",
                        name_slug: "dslrs",
                    },
                    {
                        value: "911880",
                        label: "Camera Lenses",
                        name_slug: "camera-lenses",
                    },
                    {
                        value: "912136",
                        label: "Camera Care",
                        name_slug: "camera-care",
                    },
                    {
                        value: "601893",
                        label: "Camera Accessories",
                        name_slug: "camera-accessories",
                    },
                    {
                        value: "911112",
                        label: "Action Cameras & Accessories",
                        name_slug: "action-cameras-accessories",
                    },
                ],
            },
            {
                value: "909320",
                label: "Audio & Video",
                name_slug: "audio-video",
                children: [
                    {
                        value: "910600",
                        label: "Walkie Talkies",
                        name_slug: "walkie-talkies",
                    },
                    {
                        value: "912904",
                        label: "Voice Recorders",
                        name_slug: "voice-recorders",
                    },
                    {
                        value: "602029",
                        label: "Speakers",
                        name_slug: "speakers",
                    },
                    {
                        value: "913032",
                        label: "Radio & Cassette Players",
                        name_slug: "radio-cassette-players",
                    },
                    {
                        value: "912392",
                        label: "Projectors",
                        name_slug: "projectors",
                    },
                    {
                        value: "912264",
                        label: "Microphones",
                        name_slug: "microphones",
                    },
                    {
                        value: "912648",
                        label: "MP3 & MP4 Players",
                        name_slug: "mp3-mp4-players",
                    },
                    {
                        value: "912520",
                        label: "Home Cinema Systems",
                        name_slug: "home-cinema-systems",
                    },
                    {
                        value: "601990",
                        label: "Headphones, Earphones & Accessories",
                        name_slug: "headphones-earphones-accessories",
                    },
                    {
                        value: "912776",
                        label: "CD & DVD Players",
                        name_slug: "cd-dvd-players",
                    },
                    {
                        value: "913416",
                        label: "Audio & Video Accessories",
                        name_slug: "audio-video-accessories",
                    },
                    {
                        value: "913160",
                        label: "Amplifiers & Mixers",
                        name_slug: "amplifiers-mixers",
                    },
                    {
                        value: "913288",
                        label: "AV Receivers",
                        name_slug: "av-receivers",
                    },
                ],
            },
        ],
    },
    {
        value: "601303",
        label: "Muslim Fashion",
        name_slug: "muslim-fashion",
        children: [
            {
                value: "601310",
                label: "Women's Islamic Clothing",
                name_slug: "womens-islamic-clothing",
                children: [
                    {
                        value: "2352656",
                        label: "Women's Muslim Sleepwear & Loungewear",
                        name_slug: "womens-muslim-sleepwear-loungewear",
                    },
                    {
                        value: "854800",
                        label: "Turtlenecks & Inners",
                        name_slug: "turtlenecks-inners",
                    },
                    {
                        value: "601313",
                        label: "Tunics",
                        name_slug: "tunics",
                    },
                    {
                        value: "601316",
                        label: "Skirts",
                        name_slug: "skirts",
                    },
                    {
                        value: "601314",
                        label: "Shirts & Blouses",
                        name_slug: "shirts-blouses",
                    },
                    {
                        value: "935944",
                        label: "Robes",
                        name_slug: "robes",
                    },
                    {
                        value: "601317",
                        label: "Palazzo Pants",
                        name_slug: "palazzo-pants",
                    },
                    {
                        value: "601319",
                        label: "Leggings",
                        name_slug: "leggings",
                    },
                    {
                        value: "601322",
                        label: "Kaftans",
                        name_slug: "kaftans",
                    },
                    {
                        value: "601324",
                        label: "Jumpsuits",
                        name_slug: "jumpsuits",
                    },
                    {
                        value: "804112",
                        label: "Jilbabs",
                        name_slug: "jilbabs",
                    },
                    {
                        value: "936072",
                        label: "Gamis",
                        name_slug: "gamis",
                    },
                    {
                        value: "996744",
                        label: "Family Clothing Sets",
                        name_slug: "family-clothing-sets",
                    },
                    {
                        value: "935816",
                        label: "Dresses",
                        name_slug: "dresses",
                    },
                    {
                        value: "996616",
                        label: "Couples Clothing Sets",
                        name_slug: "couples-clothing-sets",
                    },
                    {
                        value: "935688",
                        label: "Clothing Sets",
                        name_slug: "clothing-sets",
                    },
                    {
                        value: "601323",
                        label: "Abayas",
                        name_slug: "abayas",
                    },
                ],
            },
            {
                value: "839176",
                label: "Umroh Equipment",
                name_slug: "umroh-equipment",
                children: [
                    {
                        value: "839304",
                        label: "White Shirt Sets",
                        name_slug: "white-shirt-sets",
                    },
                    {
                        value: "839432",
                        label: "Umroh Packages",
                        name_slug: "umroh-packages",
                    },
                    {
                        value: "839560",
                        label: "Ihram Clothing",
                        name_slug: "ihram-clothing",
                    },
                ],
            },
            {
                value: "601348",
                label: "Prayer Attire & Equipment",
                name_slug: "prayer-attire-equipment",
                children: [
                    {
                        value: "813072",
                        label: "Tasbih",
                        name_slug: "tasbih",
                    },
                    {
                        value: "601330",
                        label: "Sarongs",
                        name_slug: "sarongs",
                    },
                    {
                        value: "839688",
                        label: "Prayer Vests",
                        name_slug: "prayer-vests",
                    },
                    {
                        value: "601350",
                        label: "Prayer Sets",
                        name_slug: "prayer-sets",
                    },
                    {
                        value: "601351",
                        label: "Prayer Mats",
                        name_slug: "prayer-mats",
                    },
                    {
                        value: "601337",
                        label: "Prayer Attire",
                        name_slug: "prayer-attire",
                    },
                    {
                        value: "601349",
                        label: "Peci",
                        name_slug: "peci",
                    },
                    {
                        value: "838792",
                        label: "Mukena",
                        name_slug: "mukena",
                    },
                ],
            },
            {
                value: "601331",
                label: "Outerwear",
                name_slug: "outerwear",
                children: [
                    {
                        value: "601332",
                        label: "Waistcoats",
                        name_slug: "waistcoats",
                    },
                    {
                        value: "996872",
                        label: "Raincoats",
                        name_slug: "raincoats",
                    },
                    {
                        value: "601334",
                        label: "Jackets",
                        name_slug: "jackets",
                    },
                    {
                        value: "601335",
                        label: "Coats",
                        name_slug: "coats",
                    },
                    {
                        value: "601333",
                        label: "Cardigans",
                        name_slug: "cardigans",
                    },
                ],
            },
            {
                value: "601325",
                label: "Men's Islamic Clothing",
                name_slug: "mens-islamic-clothing",
                children: [
                    {
                        value: "601329",
                        label: "Trousers",
                        name_slug: "trousers",
                    },
                    {
                        value: "601327",
                        label: "Robes",
                        name_slug: "robes",
                    },
                    {
                        value: "2352528",
                        label: "Men's Muslim Sleepwear & Loungewear",
                        name_slug: "mens-muslim-sleepwear-loungewear",
                    },
                    {
                        value: "601326",
                        label: "Koko & Tops",
                        name_slug: "koko-tops",
                    },
                ],
            },
            {
                value: "601339",
                label: "Kids' Islamic Clothing",
                name_slug: "kids-islamic-clothing",
                children: [
                    {
                        value: "601340",
                        label: "Kids' Hijabs",
                        name_slug: "kids-hijabs",
                    },
                    {
                        value: "601341",
                        label: "Girls' Islamic Clothing",
                        name_slug: "girls-islamic-clothing",
                    },
                    {
                        value: "601342",
                        label: "Boys' Islamic Clothing",
                        name_slug: "boys-islamic-clothing",
                    },
                ],
            },
            {
                value: "838920",
                label: "Islamic Sportswear",
                name_slug: "islamic-sportswear",
                children: [
                    {
                        value: "839048",
                        label: "Islamic Tracksuits",
                        name_slug: "islamic-tracksuits",
                    },
                    {
                        value: "601347",
                        label: "Islamic Swimwear",
                        name_slug: "islamic-swimwear",
                    },
                ],
            },
            {
                value: "601343",
                label: "Islamic Accessories",
                name_slug: "islamic-accessories",
                children: [
                    {
                        value: "601346",
                        label: "Socks",
                        name_slug: "socks",
                    },
                    {
                        value: "601344",
                        label: "Hijab Pins",
                        name_slug: "hijab-pins",
                    },
                    {
                        value: "601345",
                        label: "Handsocks",
                        name_slug: "handsocks",
                    },
                ],
            },
            {
                value: "601304",
                label: "Hijabs",
                name_slug: "hijabs",
                children: [
                    {
                        value: "601305",
                        label: "Underscarves",
                        name_slug: "underscarves",
                    },
                    {
                        value: "601307",
                        label: "Square Hijabs",
                        name_slug: "square-hijabs",
                    },
                    {
                        value: "2349456",
                        label: "School Hijab",
                        name_slug: "school-hijab",
                    },
                    {
                        value: "601308",
                        label: "Pashmina Scarves",
                        name_slug: "pashmina-scarves",
                    },
                    {
                        value: "803984",
                        label: "Niqab",
                        name_slug: "niqab",
                    },
                    {
                        value: "601309",
                        label: "Khimars",
                        name_slug: "khimars",
                    },
                    {
                        value: "601306",
                        label: "Instant Hijab",
                        name_slug: "instant-hijab",
                    },
                ],
            },
        ],
    },
    {
        value: "824584",
        label: "Luggage & Bags",
        name_slug: "luggage-bags",
        children: [
            {
                value: "902408",
                label: "Women's Bags",
                name_slug: "womens-bags",
                children: [
                    {
                        value: "601441",
                        label: "Women's Wallets",
                        name_slug: "womens-wallets",
                    },
                    {
                        value: "903176",
                        label: "Women's Tote Bags",
                        name_slug: "womens-tote-bags",
                    },
                    {
                        value: "601445",
                        label: "Women's Handbags",
                        name_slug: "womens-handbags",
                    },
                    {
                        value: "2157840",
                        label: "Women's Fashion Backpacks",
                        name_slug: "womens-fashion-backpacks",
                    },
                    {
                        value: "903048",
                        label: "Women's Fanny Packs & Belt Bags",
                        name_slug: "womens-fanny-packs-belt-bags",
                    },
                    {
                        value: "601439",
                        label: "Women's Crossbody & Shoulder Bags",
                        name_slug: "womens-crossbody-shoulder-bags",
                    },
                    {
                        value: "601444",
                        label: "Women's Clutches & Wristlets",
                        name_slug: "womens-clutches-wristlets",
                    },
                    {
                        value: "2157968",
                        label: "Women's Card & ID Cases",
                        name_slug: "womens-card-id-cases",
                    },
                    {
                        value: "2158096",
                        label: "Women's Bags Sets",
                        name_slug: "womens-bags-sets",
                    },
                ],
            },
            {
                value: "902536",
                label: "Men's Bags",
                name_slug: "mens-bags",
                children: [
                    {
                        value: "601430",
                        label: "Men's Wallets",
                        name_slug: "mens-wallets",
                    },
                    {
                        value: "903304",
                        label: "Men's Tote Bags",
                        name_slug: "mens-tote-bags",
                    },
                    {
                        value: "2158224",
                        label: "Men's Fashion Backpacks",
                        name_slug: "mens-fashion-backpacks",
                    },
                    {
                        value: "903560",
                        label: "Men's Fanny Packs & Belt Bags",
                        name_slug: "mens-fanny-packs-belt-bags",
                    },
                    {
                        value: "601429",
                        label: "Men's Crossbody & Shoulder Bags",
                        name_slug: "mens-crossbody-shoulder-bags",
                    },
                    {
                        value: "601431",
                        label: "Men's Clutches",
                        name_slug: "mens-clutches",
                    },
                    {
                        value: "2158352",
                        label: "Men's Card & ID Cases",
                        name_slug: "mens-card-id-cases",
                    },
                    {
                        value: "903432",
                        label: "Men's Briefcases",
                        name_slug: "mens-briefcases",
                    },
                    {
                        value: "2158480",
                        label: "Men's Bags Sets",
                        name_slug: "mens-bags-sets",
                    },
                ],
            },
            {
                value: "902664",
                label: "Luggage & Travel Bags",
                name_slug: "luggage-travel-bags",
                children: [
                    {
                        value: "903816",
                        label: "Travel Organizers",
                        name_slug: "travel-organizers",
                    },
                    {
                        value: "601419",
                        label: "Travel Bags",
                        name_slug: "travel-bags",
                    },
                    {
                        value: "903944",
                        label: "Passport Holders & Covers",
                        name_slug: "passport-holders-covers",
                    },
                    {
                        value: "601449",
                        label: "Luggage Accessories",
                        name_slug: "luggage-accessories",
                    },
                    {
                        value: "903688",
                        label: "Luggage",
                        name_slug: "luggage",
                    },
                ],
            },
            {
                value: "902792",
                label: "Functional Bags",
                name_slug: "functional-bags",
                children: [
                    {
                        value: "995208",
                        label: "Toiletry Bags",
                        name_slug: "toiletry-bags",
                    },
                    {
                        value: "904456",
                        label: "Shopping Bags",
                        name_slug: "shopping-bags",
                    },
                    {
                        value: "601440",
                        label: "Make-up Bags",
                        name_slug: "make-up-bags",
                    },
                    {
                        value: "904200",
                        label: "Lunch Bags",
                        name_slug: "lunch-bags",
                    },
                    {
                        value: "601417",
                        label: "Laptop Bags",
                        name_slug: "laptop-bags",
                    },
                    {
                        value: "904328",
                        label: "Cooler Bags",
                        name_slug: "cooler-bags",
                    },
                    {
                        value: "601446",
                        label: "Backpacks",
                        name_slug: "backpacks",
                    },
                ],
            },
            {
                value: "902920",
                label: "Bag Accessories",
                name_slug: "bag-accessories",
                children: [
                    {
                        value: "2158608",
                        label: "DIY Bag accessories",
                        name_slug: "diy-bag-accessories",
                    },
                    {
                        value: "905096",
                        label: "Cleaning & Care",
                        name_slug: "cleaning-care",
                    },
                    {
                        value: "904840",
                        label: "Charms & Twillies",
                        name_slug: "charms-twillies",
                    },
                    {
                        value: "904584",
                        label: "Bag Straps & Chains",
                        name_slug: "bag-straps-chains",
                    },
                    {
                        value: "904968",
                        label: "Bag Organizers",
                        name_slug: "bag-organizers",
                    },
                    {
                        value: "904712",
                        label: "Bag Hangers",
                        name_slug: "bag-hangers",
                    },
                    {
                        value: "2158736",
                        label: "Bag Cover",
                        name_slug: "bag-cover",
                    },
                ],
            },
        ],
    },
    {
        value: "601352",
        label: "Shoes",
        name_slug: "shoes",
        children: [
            {
                value: "900488",
                label: "Women's Shoes",
                name_slug: "womens-shoes",
                children: [
                    {
                        value: "804624",
                        label: "Work & Safety Footwear",
                        name_slug: "work-safety-footwear",
                    },
                    {
                        value: "601409",
                        label: "Women's Boots",
                        name_slug: "womens-boots",
                    },
                    {
                        value: "2156048",
                        label: "Traditional Footwear",
                        name_slug: "traditional-footwear",
                    },
                    {
                        value: "601405",
                        label: "Slippers",
                        name_slug: "slippers",
                    },
                    {
                        value: "901256",
                        label: "Slip-Ons",
                        name_slug: "slip-ons",
                    },
                    {
                        value: "901128",
                        label: "Sandals & Flip Flops",
                        name_slug: "sandals-flip-flops",
                    },
                    {
                        value: "601387",
                        label: "Oxfords",
                        name_slug: "oxfords",
                    },
                    {
                        value: "901384",
                        label: "Mules & Clogs",
                        name_slug: "mules-clogs",
                    },
                    {
                        value: "804752",
                        label: "Mary Jane Shoes",
                        name_slug: "mary-jane-shoes",
                    },
                    {
                        value: "601396",
                        label: "Heels",
                        name_slug: "heels",
                    },
                    {
                        value: "901000",
                        label: "Flats",
                        name_slug: "flats",
                    },
                    {
                        value: "900872",
                        label: "Casual Trainers",
                        name_slug: "casual-trainers",
                    },
                ],
            },
            {
                value: "900744",
                label: "Shoe Accessories",
                name_slug: "shoe-accessories",
                children: [
                    {
                        value: "902152",
                        label: "Shoelaces",
                        name_slug: "shoelaces",
                    },
                    {
                        value: "902024",
                        label: "Shoe Horns & Trees",
                        name_slug: "shoe-horns-trees",
                    },
                    {
                        value: "804368",
                        label: "Shoe Decoration Charms",
                        name_slug: "shoe-decoration-charms",
                    },
                    {
                        value: "804240",
                        label: "Shoe & Boot Toe Guards",
                        name_slug: "shoe-boot-toe-guards",
                    },
                    {
                        value: "601366",
                        label: "Insoles & Heel Liners",
                        name_slug: "insoles-heel-liners",
                    },
                    {
                        value: "902280",
                        label: "Cleaning & Care",
                        name_slug: "cleaning-care",
                    },
                ],
            },
            {
                value: "900616",
                label: "Men's Shoes",
                name_slug: "mens-shoes",
                children: [
                    {
                        value: "804496",
                        label: "Work & Safety Footwear",
                        name_slug: "work-safety-footwear",
                    },
                    {
                        value: "889488",
                        label: "Wedding Shoes",
                        name_slug: "wedding-shoes",
                    },
                    {
                        value: "2156176",
                        label: "Traditional Footwear",
                        name_slug: "traditional-footwear",
                    },
                    {
                        value: "601374",
                        label: "Slippers",
                        name_slug: "slippers",
                    },
                    {
                        value: "901768",
                        label: "Slip-Ons & Flat Shoes",
                        name_slug: "slip-ons-flat-shoes",
                    },
                    {
                        value: "601364",
                        label: "Sandals & Flip Flops",
                        name_slug: "sandals-flip-flops",
                    },
                    {
                        value: "901896",
                        label: "Mules & Clogs",
                        name_slug: "mules-clogs",
                    },
                    {
                        value: "601369",
                        label: "Men's Oxfords",
                        name_slug: "mens-oxfords",
                    },
                    {
                        value: "601376",
                        label: "Men's Boots",
                        name_slug: "mens-boots",
                    },
                    {
                        value: "901640",
                        label: "Formal Shoes",
                        name_slug: "formal-shoes",
                    },
                    {
                        value: "601357",
                        label: "Casual Trainers",
                        name_slug: "casual-trainers",
                    },
                ],
            },
        ],
    },
    {
        value: "602284",
        label: "Baby & Maternity",
        name_slug: "baby-maternity",
        children: [
            {
                value: "877832",
                label: "Nursing & Feeding",
                name_slug: "nursing-feeding",
                children: [
                    {
                        value: "890632",
                        label: "Nursing Covers",
                        name_slug: "nursing-covers",
                    },
                    {
                        value: "2169360",
                        label: "Nipple Creams",
                        name_slug: "nipple-creams",
                    },
                    {
                        value: "962952",
                        label: "Formula & Milk Storage & Organization",
                        name_slug: "formula-milk-storage-organization",
                    },
                    {
                        value: "602707",
                        label: "Food Processors",
                        name_slug: "food-processors",
                    },
                    {
                        value: "890888",
                        label: "Dummies",
                        name_slug: "dummies",
                    },
                    {
                        value: "998024",
                        label: "Breastfeeding Pillows",
                        name_slug: "breastfeeding-pillows",
                    },
                    {
                        value: "933640",
                        label: "Breast Pumps & Accessories",
                        name_slug: "breast-pumps-accessories",
                    },
                    {
                        value: "890504",
                        label: "Breast Pads",
                        name_slug: "breast-pads",
                    },
                    {
                        value: "700707",
                        label: "Baby Utensils",
                        name_slug: "baby-utensils",
                    },
                    {
                        value: "700704",
                        label: "Baby Bottles & Accessories",
                        name_slug: "baby-bottles-accessories",
                    },
                    {
                        value: "890376",
                        label: "Baby Bottle Warmers, Coolers & Sterilizers",
                        name_slug: "baby-bottle-warmers-coolers-sterilizers",
                    },
                    {
                        value: "819728",
                        label: "Baby Bottle Cleaners",
                        name_slug: "baby-bottle-cleaners",
                    },
                    {
                        value: "842896",
                        label: "Baby Bottle Boxes & Drying Racks",
                        name_slug: "baby-bottle-boxes-drying-racks",
                    },
                ],
            },
            {
                value: "880008",
                label: "Maternity Supplies",
                name_slug: "maternity-supplies",
                children: [
                    {
                        value: "893192",
                        label: "Supporting Belts",
                        name_slug: "supporting-belts",
                    },
                    {
                        value: "819600",
                        label: "Prenatal Monitoring Devices",
                        name_slug: "prenatal-monitoring-devices",
                    },
                    {
                        value: "892936",
                        label: "Nursing Clothes",
                        name_slug: "nursing-clothes",
                    },
                    {
                        value: "855056",
                        label: "Milk Formula for Pregnant & Lactating Women",
                        name_slug: "milk-formula-for-pregnant-lactating-women",
                    },
                    {
                        value: "947720",
                        label: "Maternity Vitamins & Supplement",
                        name_slug: "maternity-vitamins-supplement",
                    },
                    {
                        value: "700710",
                        label: "Maternity Underwear",
                        name_slug: "maternity-underwear",
                    },
                    {
                        value: "893320",
                        label: "Maternity Skincare",
                        name_slug: "maternity-skincare",
                    },
                    {
                        value: "998664",
                        label: "Maternity Seat Belts & Accessories",
                        name_slug: "maternity-seat-belts-accessories",
                    },
                    {
                        value: "893064",
                        label: "Maternity Pillows",
                        name_slug: "maternity-pillows",
                    },
                    {
                        value: "700718",
                        label: "Maternity Clothing & Accessories",
                        name_slug: "maternity-clothing-accessories",
                    },
                ],
            },
            {
                value: "879496",
                label: "Formula Milk & Baby Food",
                name_slug: "formula-milk-baby-food",
                children: [
                    {
                        value: "934024",
                        label: "Snacks",
                        name_slug: "snacks",
                    },
                    {
                        value: "2169488",
                        label: "Prepared Meals & Side Dishes",
                        name_slug: "prepared-meals-side-dishes",
                    },
                    {
                        value: "933896",
                        label: "Oatmeal, Puree & Cereal",
                        name_slug: "oatmeal-puree-cereal",
                    },
                    {
                        value: "843024",
                        label: "Infant Formula",
                        name_slug: "infant-formula",
                    },
                    {
                        value: "933768",
                        label: "Growth Milk Formula",
                        name_slug: "growth-milk-formula",
                    },
                    {
                        value: "819344",
                        label: "Beverages",
                        name_slug: "beverages",
                    },
                ],
            },
            {
                value: "877576",
                label: "Baby Travel Gear",
                name_slug: "baby-travel-gear",
                children: [
                    {
                        value: "700705",
                        label: "Strollers and Bassinet Strollers",
                        name_slug: "strollers-and-bassinet-strollers",
                    },
                    {
                        value: "889736",
                        label: "Stroller Accessories",
                        name_slug: "stroller-accessories",
                    },
                    {
                        value: "998792",
                        label: "Seat Belts & Accessories",
                        name_slug: "seat-belts-accessories",
                    },
                    {
                        value: "890120",
                        label: "Diaper Bags",
                        name_slug: "diaper-bags",
                    },
                    {
                        value: "890248",
                        label: "Child Harnesses & Reins",
                        name_slug: "child-harnesses-reins",
                    },
                    {
                        value: "889992",
                        label: "Car Seat Accessories",
                        name_slug: "car-seat-accessories",
                    },
                    {
                        value: "889608",
                        label: "Baby Carriers",
                        name_slug: "baby-carriers",
                    },
                    {
                        value: "889864",
                        label: "Baby Car Seats",
                        name_slug: "baby-car-seats",
                    },
                ],
            },
            {
                value: "878984",
                label: "Baby Toys",
                name_slug: "baby-toys",
                children: [
                    {
                        value: "819856",
                        label: "Toy Figures & Models",
                        name_slug: "toy-figures-models",
                    },
                    {
                        value: "961288",
                        label: "Roly-Poly Toys",
                        name_slug: "roly-poly-toys",
                    },
                    {
                        value: "961416",
                        label: "Rocking Horses & Animals",
                        name_slug: "rocking-horses-animals",
                    },
                    {
                        value: "891528",
                        label: "Playpens",
                        name_slug: "playpens",
                    },
                    {
                        value: "891400",
                        label: "Playgyms & Playmats",
                        name_slug: "playgyms-playmats",
                    },
                    {
                        value: "817936",
                        label: "Mirrors",
                        name_slug: "mirrors",
                    },
                    {
                        value: "818448",
                        label: "Indoor Climbers & Play Structures",
                        name_slug: "indoor-climbers-play-structures",
                    },
                    {
                        value: "961544",
                        label: "Gift Sets",
                        name_slug: "gift-sets",
                    },
                    {
                        value: "892040",
                        label: "Early Education & Smart Toys",
                        name_slug: "early-education-smart-toys",
                    },
                    {
                        value: "961160",
                        label: "Dolls & Stuffed Toys",
                        name_slug: "dolls-stuffed-toys",
                    },
                    {
                        value: "818192",
                        label: "Car Seat & Stroller Toys",
                        name_slug: "car-seat-stroller-toys",
                    },
                    {
                        value: "891656",
                        label: "Bath Toys",
                        name_slug: "bath-toys",
                    },
                    {
                        value: "818064",
                        label: "Balls",
                        name_slug: "balls",
                    },
                    {
                        value: "960904",
                        label: "Baby Sports & Outdoor Play",
                        name_slug: "baby-sports-outdoor-play",
                    },
                    {
                        value: "891784",
                        label: "Baby Sound Toys",
                        name_slug: "baby-sound-toys",
                    },
                    {
                        value: "818704",
                        label: "Baby Pretend Play",
                        name_slug: "baby-pretend-play",
                    },
                    {
                        value: "818576",
                        label: "Baby Electric & Remote Control Toys",
                        name_slug: "baby-electric-remote-control-toys",
                    },
                    {
                        value: "818320",
                        label: "Activity Centres",
                        name_slug: "activity-centres",
                    },
                ],
            },
            {
                value: "878600",
                label: "Baby Safety",
                name_slug: "baby-safety",
                children: [
                    {
                        value: "602532",
                        label: "Safety Locks & Straps",
                        name_slug: "safety-locks-straps",
                    },
                    {
                        value: "2169616",
                        label: "Safety Harnesses",
                        name_slug: "safety-harnesses",
                    },
                    {
                        value: "891144",
                        label: "Mosquito Netting",
                        name_slug: "mosquito-netting",
                    },
                    {
                        value: "602538",
                        label: "Monitors",
                        name_slug: "monitors",
                    },
                    {
                        value: "2169744",
                        label: "Humidifiers",
                        name_slug: "humidifiers",
                    },
                    {
                        value: "2169872",
                        label: "Hearing Protection Earmuffs",
                        name_slug: "hearing-protection-earmuffs",
                    },
                    {
                        value: "2170000",
                        label: "Guards & Locks",
                        name_slug: "guards-locks",
                    },
                    {
                        value: "891272",
                        label: "Gates & Gate Extensions",
                        name_slug: "gates-gate-extensions",
                    },
                    {
                        value: "602533",
                        label: "Electric Shock Protection",
                        name_slug: "electric-shock-protection",
                    },
                    {
                        value: "602534",
                        label: "Edge & Corner Guards",
                        name_slug: "edge-corner-guards",
                    },
                    {
                        value: "602536",
                        label: "Bed Rails & Guards",
                        name_slug: "bed-rails-guards",
                    },
                ],
            },
            {
                value: "878216",
                label: "Baby Furniture",
                name_slug: "baby-furniture",
                children: [
                    {
                        value: "2170128",
                        label: "Storage",
                        name_slug: "storage",
                    },
                    {
                        value: "893448",
                        label: "Potty Training & Commode Chairs",
                        name_slug: "potty-training-commode-chairs",
                    },
                    {
                        value: "2170256",
                        label: "Playpens",
                        name_slug: "playpens",
                    },
                    {
                        value: "602734",
                        label: "Mattresses & Bedding",
                        name_slug: "mattresses-bedding",
                    },
                    {
                        value: "602761",
                        label: "Infant & Toddler Beds",
                        name_slug: "infant-toddler-beds",
                    },
                    {
                        value: "2170384",
                        label: "Highchairs, Seats & Accessories",
                        name_slug: "highchairs-seats-accessories",
                    },
                    {
                        value: "2170512",
                        label: "Furniture Sets",
                        name_slug: "furniture-sets",
                    },
                    {
                        value: "2170640",
                        label: "Decoration",
                        name_slug: "decoration",
                    },
                    {
                        value: "998280",
                        label: "Changing Tables",
                        name_slug: "changing-tables",
                    },
                    {
                        value: "602760",
                        label: "Bouncers, Jumpers & Swings",
                        name_slug: "bouncers-jumpers-swings",
                    },
                    {
                        value: "891016",
                        label: "Baby Walkers",
                        name_slug: "baby-walkers",
                    },
                    {
                        value: "998408",
                        label: "Baby Tables & Desks",
                        name_slug: "baby-tables-desks",
                    },
                    {
                        value: "700706",
                        label: "Baby Chairs",
                        name_slug: "baby-chairs",
                    },
                ],
            },
            {
                value: "961928",
                label: "Baby Fashion Accessories",
                name_slug: "baby-fashion-accessories",
                children: [
                    {
                        value: "817424",
                        label: "Sunglasses",
                        name_slug: "sunglasses",
                    },
                    {
                        value: "998536",
                        label: "Gift Sets",
                        name_slug: "gift-sets",
                    },
                    {
                        value: "890760",
                        label: "Bibs & Burp Cloths",
                        name_slug: "bibs-burp-cloths",
                    },
                    {
                        value: "962184",
                        label: "Baby Scarves",
                        name_slug: "baby-scarves",
                    },
                    {
                        value: "962312",
                        label: "Baby Hats & Caps",
                        name_slug: "baby-hats-caps",
                    },
                    {
                        value: "962696",
                        label: "Baby Hair Accessories",
                        name_slug: "baby-hair-accessories",
                    },
                    {
                        value: "962056",
                        label: "Baby Gloves",
                        name_slug: "baby-gloves",
                    },
                    {
                        value: "962568",
                        label: "Baby Face Masks",
                        name_slug: "baby-face-masks",
                    },
                    {
                        value: "962440",
                        label: "Baby Earmuffs",
                        name_slug: "baby-earmuffs",
                    },
                    {
                        value: "602301",
                        label: "Baby Costume Jewelry",
                        name_slug: "baby-costume-jewelry",
                    },
                    {
                        value: "998920",
                        label: "Baby Bags",
                        name_slug: "baby-bags",
                    },
                ],
            },
            {
                value: "877320",
                label: "Baby Clothing & Shoes",
                name_slug: "baby-clothing-shoes",
                children: [
                    {
                        value: "889224",
                        label: "Tops",
                        name_slug: "tops",
                    },
                    {
                        value: "888456",
                        label: "Swimwear",
                        name_slug: "swimwear",
                    },
                    {
                        value: "817808",
                        label: "Sweaters",
                        name_slug: "sweaters",
                    },
                    {
                        value: "888584",
                        label: "Socks & Tights",
                        name_slug: "socks-tights",
                    },
                    {
                        value: "889480",
                        label: "Sleepwear",
                        name_slug: "sleepwear",
                    },
                    {
                        value: "602787",
                        label: "Shoes",
                        name_slug: "shoes",
                    },
                    {
                        value: "889352",
                        label: "Jackets & Coats",
                        name_slug: "jackets-coats",
                    },
                    {
                        value: "817680",
                        label: "Hoodies & Active",
                        name_slug: "hoodies-active",
                    },
                    {
                        value: "888968",
                        label: "Gift Sets",
                        name_slug: "gift-sets",
                    },
                    {
                        value: "889096",
                        label: "Dresses",
                        name_slug: "dresses",
                    },
                    {
                        value: "998152",
                        label: "Costumes",
                        name_slug: "costumes",
                    },
                    {
                        value: "888712",
                        label: "Bottoms",
                        name_slug: "bottoms",
                    },
                    {
                        value: "700694",
                        label: "Bodysuits & One-pieces",
                        name_slug: "bodysuits-one-pieces",
                    },
                    {
                        value: "817552",
                        label: "Bloomers, Diaper Covers & Underwear",
                        name_slug: "bloomers-diaper-covers-underwear",
                    },
                ],
            },
            {
                value: "879112",
                label: "Baby Care & Health",
                name_slug: "baby-care-health",
                children: [
                    {
                        value: "892808",
                        label: "Wipes & Holders",
                        name_slug: "wipes-holders",
                    },
                    {
                        value: "892296",
                        label: "Towels & Shower Caps",
                        name_slug: "towels-shower-caps",
                    },
                    {
                        value: "819088",
                        label: "Scales",
                        name_slug: "scales",
                    },
                    {
                        value: "891912",
                        label: "Pacifiers, Teethers & Teething Relief",
                        name_slug: "pacifiers-teethers-teething-relief",
                    },
                    {
                        value: "818960",
                        label: "Nasal Aspirators & Tweezers",
                        name_slug: "nasal-aspirators-tweezers",
                    },
                    {
                        value: "818832",
                        label: "Medicine Dispensers",
                        name_slug: "medicine-dispensers",
                    },
                    {
                        value: "602673",
                        label: "Laundry Detergent",
                        name_slug: "laundry-detergent",
                    },
                    {
                        value: "842640",
                        label: "Insect & Pest Repellents",
                        name_slug: "insect-pest-repellents",
                    },
                    {
                        value: "819472",
                        label: "Height & Circumference Measuring Devices",
                        name_slug: "height-circumference-measuring-devices",
                    },
                    {
                        value: "997896",
                        label: "Hand & Footprint Makers",
                        name_slug: "hand-footprint-makers",
                    },
                    {
                        value: "602317",
                        label: "Hair Care & Body Wash",
                        name_slug: "hair-care-body-wash",
                    },
                    {
                        value: "892552",
                        label: "Fragrances",
                        name_slug: "fragrances",
                    },
                    {
                        value: "602676",
                        label: "Ear, Nose & Oral Care",
                        name_slug: "ear-nose-oral-care",
                    },
                    {
                        value: "947592",
                        label: "Baby Vitamins & Supplements",
                        name_slug: "baby-vitamins-supplements",
                    },
                    {
                        value: "2170768",
                        label: "Baby Thermometers",
                        name_slug: "baby-thermometers",
                    },
                    {
                        value: "602296",
                        label: "Baby Skincare",
                        name_slug: "baby-skincare",
                    },
                    {
                        value: "602672",
                        label: "Baby Hand Sanitizer",
                        name_slug: "baby-hand-sanitizer",
                    },
                    {
                        value: "602608",
                        label: "Baby Hair Trimmers",
                        name_slug: "baby-hair-trimmers",
                    },
                    {
                        value: "602622",
                        label: "Baby Hair Dryers",
                        name_slug: "baby-hair-dryers",
                    },
                    {
                        value: "892680",
                        label: "Baby Grooming Tools",
                        name_slug: "baby-grooming-tools",
                    },
                    {
                        value: "929672",
                        label: "Baby Diapering Products",
                        name_slug: "baby-diapering-products",
                    },
                    {
                        value: "602678",
                        label: "Baby Clothes Sterilizers",
                        name_slug: "baby-clothes-sterilizers",
                    },
                    {
                        value: "892168",
                        label: "Baby Baths & Bath Seats",
                        name_slug: "baby-baths-bath-seats",
                    },
                    {
                        value: "892424",
                        label: "Baby Bath Supplies",
                        name_slug: "baby-bath-supplies",
                    },
                ],
            },
        ],
    },
    {
        value: "600024",
        label: "Kitchenware",
        name_slug: "kitchenware",
        children: [
            {
                value: "858504",
                label: "Tea & Coffeeware",
                name_slug: "tea-coffeeware",
                children: [
                    {
                        value: "860808",
                        label: "Teapots",
                        name_slug: "teapots",
                    },
                    {
                        value: "861064",
                        label: "Tea-Making Tools",
                        name_slug: "tea-making-tools",
                    },
                    {
                        value: "860936",
                        label: "Tea Sets",
                        name_slug: "tea-sets",
                    },
                    {
                        value: "600102",
                        label: "Milk Jugs",
                        name_slug: "milk-jugs",
                    },
                    {
                        value: "860680",
                        label: "Manual Coffee Grinders",
                        name_slug: "manual-coffee-grinders",
                    },
                    {
                        value: "600103",
                        label: "Coffee-Making Tools",
                        name_slug: "coffee-making-tools",
                    },
                    {
                        value: "600100",
                        label: "Coffee Sets",
                        name_slug: "coffee-sets",
                    },
                    {
                        value: "600096",
                        label: "Coffee Pots",
                        name_slug: "coffee-pots",
                    },
                    {
                        value: "860424",
                        label: "Coffee Filters",
                        name_slug: "coffee-filters",
                    },
                ],
            },
            {
                value: "859528",
                label: "Kitchen Utensils & Gadgets",
                name_slug: "kitchen-utensils-gadgets",
                children: [
                    {
                        value: "600139",
                        label: "Specialty Kitchen Utensils",
                        name_slug: "specialty-kitchen-utensils",
                    },
                    {
                        value: "600135",
                        label: "Sieves and Colanders",
                        name_slug: "sieves-and-colanders",
                    },
                    {
                        value: "865288",
                        label: "Seasoning Utensils",
                        name_slug: "seasoning-utensils",
                    },
                    {
                        value: "866440",
                        label: "Seafood Utensils",
                        name_slug: "seafood-utensils",
                    },
                    {
                        value: "600029",
                        label: "Preserving Containers",
                        name_slug: "preserving-containers",
                    },
                    {
                        value: "867208",
                        label: "Peelers & Cutters",
                        name_slug: "peelers-cutters",
                    },
                    {
                        value: "865800",
                        label: "Pasta & Pizza Utensils",
                        name_slug: "pasta-pizza-utensils",
                    },
                    {
                        value: "866824",
                        label: "Openers",
                        name_slug: "openers",
                    },
                    {
                        value: "866952",
                        label: "Oil Dispensers",
                        name_slug: "oil-dispensers",
                    },
                    {
                        value: "600132",
                        label: "Meat & Poultry Utensils",
                        name_slug: "meat-poultry-utensils",
                    },
                    {
                        value: "600121",
                        label: "Measuring Utensils",
                        name_slug: "measuring-utensils",
                    },
                    {
                        value: "600127",
                        label: "Kitchen Timers",
                        name_slug: "kitchen-timers",
                    },
                    {
                        value: "865544",
                        label: "Kitchen Thermometers",
                        name_slug: "kitchen-thermometers",
                    },
                    {
                        value: "863248",
                        label: "Kitchen Scales",
                        name_slug: "kitchen-scales",
                    },
                    {
                        value: "865928",
                        label: "Ice Cream Utensils",
                        name_slug: "ice-cream-utensils",
                    },
                    {
                        value: "600060",
                        label: "Fruit & Vegetable Utensils",
                        name_slug: "fruit-vegetable-utensils",
                    },
                    {
                        value: "600123",
                        label: "Fire Starters",
                        name_slug: "fire-starters",
                    },
                    {
                        value: "866184",
                        label: "Egg Utensils",
                        name_slug: "egg-utensils",
                    },
                    {
                        value: "866568",
                        label: "Drinking Utensils",
                        name_slug: "drinking-utensils",
                    },
                    {
                        value: "600148",
                        label: "Cooking Utensils",
                        name_slug: "cooking-utensils",
                    },
                ],
            },
            {
                value: "858632",
                label: "Kitchen Knives",
                name_slug: "kitchen-knives",
                children: [
                    {
                        value: "861192",
                        label: "Knife Sharpeners",
                        name_slug: "knife-sharpeners",
                    },
                    {
                        value: "861320",
                        label: "Knife Blocks & Storage",
                        name_slug: "knife-blocks-storage",
                    },
                    {
                        value: "861832",
                        label: "Knife Block Sets",
                        name_slug: "knife-block-sets",
                    },
                    {
                        value: "861576",
                        label: "Kitchen Scissors",
                        name_slug: "kitchen-scissors",
                    },
                    {
                        value: "600145",
                        label: "Kitchen Knives",
                        name_slug: "kitchen-knives",
                    },
                    {
                        value: "600151",
                        label: "Chopping Boards",
                        name_slug: "chopping-boards",
                    },
                ],
            },
            {
                value: "859400",
                label: "Drinkware",
                name_slug: "drinkware",
                children: [
                    {
                        value: "600048",
                        label: "Water Bottles",
                        name_slug: "water-bottles",
                    },
                    {
                        value: "600032",
                        label: "Vacuum Flasks",
                        name_slug: "vacuum-flasks",
                    },
                    {
                        value: "600042",
                        label: "Mugs",
                        name_slug: "mugs",
                    },
                    {
                        value: "864904",
                        label: "Kettles & Jugs",
                        name_slug: "kettles-jugs",
                    },
                    {
                        value: "865032",
                        label: "Hip Flasks",
                        name_slug: "hip-flasks",
                    },
                    {
                        value: "600036",
                        label: "Glasses",
                        name_slug: "glasses",
                    },
                    {
                        value: "600047",
                        label: "Drinkware Accessories",
                        name_slug: "drinkware-accessories",
                    },
                    {
                        value: "600095",
                        label: "Cups & Saucers",
                        name_slug: "cups-saucers",
                    },
                ],
            },
            {
                value: "859272",
                label: "Cutlery & Tableware",
                name_slug: "cutlery-tableware",
                children: [
                    {
                        value: "600071",
                        label: "Tableware Sets",
                        name_slug: "tableware-sets",
                    },
                    {
                        value: "993800",
                        label: "Tableware Rests",
                        name_slug: "tableware-rests",
                    },
                    {
                        value: "600073",
                        label: "Spoons",
                        name_slug: "spoons",
                    },
                    {
                        value: "600064",
                        label: "Plates",
                        name_slug: "plates",
                    },
                    {
                        value: "600033",
                        label: "Placemats & Coasters",
                        name_slug: "placemats-coasters",
                    },
                    {
                        value: "864648",
                        label: "Napkins",
                        name_slug: "napkins",
                    },
                    {
                        value: "600059",
                        label: "Lunch Boxes",
                        name_slug: "lunch-boxes",
                    },
                    {
                        value: "600072",
                        label: "Knives",
                        name_slug: "knives",
                    },
                    {
                        value: "600070",
                        label: "Forks",
                        name_slug: "forks",
                    },
                    {
                        value: "600063",
                        label: "Chopsticks",
                        name_slug: "chopsticks",
                    },
                    {
                        value: "600069",
                        label: "Bowls",
                        name_slug: "bowls",
                    },
                ],
            },
            {
                value: "859144",
                label: "Cookware",
                name_slug: "cookware",
                children: [
                    {
                        value: "864008",
                        label: "Steamers",
                        name_slug: "steamers",
                    },
                    {
                        value: "864264",
                        label: "Pressure Cookers",
                        name_slug: "pressure-cookers",
                    },
                    {
                        value: "600146",
                        label: "Pots",
                        name_slug: "pots",
                    },
                    {
                        value: "863880",
                        label: "Pans & Woks",
                        name_slug: "pans-woks",
                    },
                    {
                        value: "864392",
                        label: "Disposable Cookware",
                        name_slug: "disposable-cookware",
                    },
                    {
                        value: "863624",
                        label: "Cookware Sets",
                        name_slug: "cookware-sets",
                    },
                    {
                        value: "1001864",
                        label: "Cookware Accessories",
                        name_slug: "cookware-accessories",
                    },
                ],
            },
            {
                value: "858760",
                label: "Barbecue",
                name_slug: "barbecue",
                children: [
                    {
                        value: "862216",
                        label: "Barbecues",
                        name_slug: "barbecues",
                    },
                    {
                        value: "862344",
                        label: "Barbecue Utensils",
                        name_slug: "barbecue-utensils",
                    },
                ],
            },
            {
                value: "858888",
                label: "Bar & Wine Utensils",
                name_slug: "bar-wine-utensils",
                children: [
                    {
                        value: "600080",
                        label: "Wine Racks",
                        name_slug: "wine-racks",
                    },
                    {
                        value: "806672",
                        label: "Wine Making Equipment",
                        name_slug: "wine-making-equipment",
                    },
                    {
                        value: "600075",
                        label: "Bar Utensils",
                        name_slug: "bar-utensils",
                    },
                    {
                        value: "600081",
                        label: "Bar Sets",
                        name_slug: "bar-sets",
                    },
                ],
            },
            {
                value: "859016",
                label: "Bakeware",
                name_slug: "bakeware",
                children: [
                    {
                        value: "862856",
                        label: "Oven Mitts",
                        name_slug: "oven-mitts",
                    },
                    {
                        value: "863368",
                        label: "Decorating Tools",
                        name_slug: "decorating-tools",
                    },
                    {
                        value: "600152",
                        label: "Baking Utensils",
                        name_slug: "baking-utensils",
                    },
                    {
                        value: "863112",
                        label: "Baking Trays",
                        name_slug: "baking-trays",
                    },
                    {
                        value: "600119",
                        label: "Baking Tins & Molds",
                        name_slug: "baking-tins-molds",
                    },
                    {
                        value: "862600",
                        label: "Baking Sets",
                        name_slug: "baking-sets",
                    },
                ],
            },
        ],
    },
    {
        value: "603014",
        label: "Sports & Outdoor",
        name_slug: "sports-outdoor",
        children: [
            {
                value: "835208",
                label: "Winter Sports",
                name_slug: "winter-sports",
                children: [
                    {
                        value: "966664",
                        label: "Snowshoeing",
                        name_slug: "snowshoeing",
                    },
                    {
                        value: "2150288",
                        label: "Snowmobiling",
                        name_slug: "snowmobiling",
                    },
                    {
                        value: "837512",
                        label: "Snowboarding",
                        name_slug: "snowboarding",
                    },
                    {
                        value: "966536",
                        label: "Sledding",
                        name_slug: "sledding",
                    },
                    {
                        value: "700779",
                        label: "Skiing",
                        name_slug: "skiing",
                    },
                    {
                        value: "2150416",
                        label: "Protective Gear",
                        name_slug: "protective-gear",
                    },
                    {
                        value: "966280",
                        label: "Ice Skating",
                        name_slug: "ice-skating",
                    },
                    {
                        value: "603625",
                        label: "Ice Hockey",
                        name_slug: "ice-hockey",
                    },
                    {
                        value: "2150544",
                        label: "Dog Sledding",
                        name_slug: "dog-sledding",
                    },
                    {
                        value: "966408",
                        label: "Curling",
                        name_slug: "curling",
                    },
                ],
            },
            {
                value: "835080",
                label: "Water Sports",
                name_slug: "water-sports",
                children: [
                    {
                        value: "967816",
                        label: "Windsurfing",
                        name_slug: "windsurfing",
                    },
                    {
                        value: "967560",
                        label: "Water Skiing & Wakeboarding",
                        name_slug: "water-skiing-wakeboarding",
                    },
                    {
                        value: "967688",
                        label: "Water Polo",
                        name_slug: "water-polo",
                    },
                    {
                        value: "837256",
                        label: "Swimming",
                        name_slug: "swimming",
                    },
                    {
                        value: "603131",
                        label: "Surfing",
                        name_slug: "surfing",
                    },
                    {
                        value: "967432",
                        label: "Stand Up Paddleboarding",
                        name_slug: "stand-up-paddleboarding",
                    },
                    {
                        value: "967304",
                        label: "Sailing",
                        name_slug: "sailing",
                    },
                    {
                        value: "967176",
                        label: "Rowing & Crew",
                        name_slug: "rowing-crew",
                    },
                    {
                        value: "967048",
                        label: "Kitesurfing",
                        name_slug: "kitesurfing",
                    },
                    {
                        value: "966920",
                        label: "Kayaking",
                        name_slug: "kayaking",
                    },
                    {
                        value: "700781",
                        label: "Diving",
                        name_slug: "diving",
                    },
                    {
                        value: "966792",
                        label: "Canoeing",
                        name_slug: "canoeing",
                    },
                    {
                        value: "837384",
                        label: "Boating",
                        name_slug: "boating",
                    },
                ],
            },
            {
                value: "846224",
                label: "Swimwear, Surfwear & Wetsuits",
                name_slug: "swimwear-surfwear-wetsuits",
                children: [
                    {
                        value: "811024",
                        label: "Wetsuits",
                        name_slug: "wetsuits",
                    },
                    {
                        value: "846992",
                        label: "Tankinis",
                        name_slug: "tankinis",
                    },
                    {
                        value: "847120",
                        label: "Swimdresses",
                        name_slug: "swimdresses",
                    },
                    {
                        value: "846352",
                        label: "Swim shorts & trunks",
                        name_slug: "swim-shorts-trunks",
                    },
                    {
                        value: "846608",
                        label: "Rash Guard Swimsuits",
                        name_slug: "rash-guard-swimsuits",
                    },
                    {
                        value: "846736",
                        label: "Racing Swimwear",
                        name_slug: "racing-swimwear",
                    },
                    {
                        value: "847248",
                        label: "One-Pieces",
                        name_slug: "one-pieces",
                    },
                    {
                        value: "847376",
                        label: "Cover Ups",
                        name_slug: "cover-ups",
                    },
                    {
                        value: "846480",
                        label: "Briefs",
                        name_slug: "briefs",
                    },
                    {
                        value: "846864",
                        label: "Bikinis",
                        name_slug: "bikinis",
                    },
                ],
            },
            {
                value: "834696",
                label: "Sports Footwear",
                name_slug: "sports-footwear",
                children: [
                    {
                        value: "2150672",
                        label: "Yoga Shoes",
                        name_slug: "yoga-shoes",
                    },
                    {
                        value: "2150800",
                        label: "Wrestling Shoes",
                        name_slug: "wrestling-shoes",
                    },
                    {
                        value: "811408",
                        label: "Water shoes",
                        name_slug: "water-shoes",
                    },
                    {
                        value: "1001096",
                        label: "Walking Shoes",
                        name_slug: "walking-shoes",
                    },
                    {
                        value: "603750",
                        label: "Volleyball Shoes",
                        name_slug: "volleyball-shoes",
                    },
                    {
                        value: "836360",
                        label: "Training & Gym Shoes",
                        name_slug: "training-gym-shoes",
                    },
                    {
                        value: "2150928",
                        label: "Track & Field & Cross Country Shoes",
                        name_slug: "track-field-cross-country-shoes",
                    },
                    {
                        value: "603755",
                        label: "Tennis Shoes",
                        name_slug: "tennis-shoes",
                    },
                    {
                        value: "1000584",
                        label: "Sports Slide & Sandals",
                        name_slug: "sports-slide-sandals",
                    },
                    {
                        value: "1001480",
                        label: "Sports Shoe Accessories",
                        name_slug: "sports-shoe-accessories",
                    },
                    {
                        value: "2151056",
                        label: "Softball Shoes",
                        name_slug: "softball-shoes",
                    },
                    {
                        value: "2151184",
                        label: "Sneaker",
                        name_slug: "sneaker",
                    },
                    {
                        value: "1000968",
                        label: "Skateboarding Shoes",
                        name_slug: "skateboarding-shoes",
                    },
                    {
                        value: "603751",
                        label: "Running Shoes",
                        name_slug: "running-shoes",
                    },
                    {
                        value: "836488",
                        label: "Roller & Ice Skates",
                        name_slug: "roller-ice-skates",
                    },
                    {
                        value: "836616",
                        label: "Kids' Sport Shoes",
                        name_slug: "kids-sport-shoes",
                    },
                    {
                        value: "603856",
                        label: "Hiking Shoes",
                        name_slug: "hiking-shoes",
                    },
                    {
                        value: "603579",
                        label: "Golf Shoes",
                        name_slug: "golf-shoes",
                    },
                    {
                        value: "1000840",
                        label: "Futsal Shoes",
                        name_slug: "futsal-shoes",
                    },
                    {
                        value: "603760",
                        label: "Football Boots",
                        name_slug: "football-boots",
                    },
                    {
                        value: "2151312",
                        label: "Equestrian Sport Boots",
                        name_slug: "equestrian-sport-boots",
                    },
                    {
                        value: "603171",
                        label: "Dance Shoes",
                        name_slug: "dance-shoes",
                    },
                    {
                        value: "1000712",
                        label: "Cycling Shoes",
                        name_slug: "cycling-shoes",
                    },
                    {
                        value: "2151440",
                        label: "Cross-Training Shoes",
                        name_slug: "cross-training-shoes",
                    },
                    {
                        value: "2151568",
                        label: "Climbing Shoes",
                        name_slug: "climbing-shoes",
                    },
                    {
                        value: "2151696",
                        label: "Boxing Shoes",
                        name_slug: "boxing-shoes",
                    },
                    {
                        value: "603748",
                        label: "Basketball Shoes",
                        name_slug: "basketball-shoes",
                    },
                    {
                        value: "603744",
                        label: "Baseball Shoes",
                        name_slug: "baseball-shoes",
                    },
                    {
                        value: "603758",
                        label: "Badminton Shoes",
                        name_slug: "badminton-shoes",
                    },
                    {
                        value: "2151824",
                        label: "American Football Shoes",
                        name_slug: "american-football-shoes",
                    },
                ],
            },
            {
                value: "834824",
                label: "Sports & Outdoor Accessories",
                name_slug: "sports-outdoor-accessories",
                children: [
                    {
                        value: "810768",
                        label: "Trophies, Medals & Awards",
                        name_slug: "trophies-medals-awards",
                    },
                    {
                        value: "2151952",
                        label: "Training & Playing Field Equipment",
                        name_slug: "training-playing-field-equipment",
                    },
                    {
                        value: "966152",
                        label: "Swimming Caps",
                        name_slug: "swimming-caps",
                    },
                    {
                        value: "837000",
                        label: "Stopwatches & Timers",
                        name_slug: "stopwatches-timers",
                    },
                    {
                        value: "965640",
                        label: "Sports Wristbands",
                        name_slug: "sports-wristbands",
                    },
                    {
                        value: "940168",
                        label: "Sports Water Bottles",
                        name_slug: "sports-water-bottles",
                    },
                    {
                        value: "2152080",
                        label: "Sports Towel",
                        name_slug: "sports-towel",
                    },
                    {
                        value: "965768",
                        label: "Sports Tapes",
                        name_slug: "sports-tapes",
                    },
                    {
                        value: "836872",
                        label: "Sports Socks",
                        name_slug: "sports-socks",
                    },
                    {
                        value: "810512",
                        label: "Sports Sleeves & Support",
                        name_slug: "sports-sleeves-support",
                    },
                    {
                        value: "965896",
                        label: "Sports Shoe Bags",
                        name_slug: "sports-shoe-bags",
                    },
                    {
                        value: "965512",
                        label: "Sports Headbands",
                        name_slug: "sports-headbands",
                    },
                    {
                        value: "965384",
                        label: "Sports Gloves",
                        name_slug: "sports-gloves",
                    },
                    {
                        value: "836744",
                        label: "Sports Eyewear",
                        name_slug: "sports-eyewear",
                    },
                    {
                        value: "603654",
                        label: "Sports & Outdoor Hats",
                        name_slug: "sports-outdoor-hats",
                    },
                    {
                        value: "2152208",
                        label: "Reflective Gear",
                        name_slug: "reflective-gear",
                    },
                    {
                        value: "603872",
                        label: "Protective Gear",
                        name_slug: "protective-gear",
                    },
                    {
                        value: "603366",
                        label: "Pedometers",
                        name_slug: "pedometers",
                    },
                    {
                        value: "966024",
                        label: "Life Jackets & Vests",
                        name_slug: "life-jackets-vests",
                    },
                    {
                        value: "810896",
                        label: "Hand Chalk",
                        name_slug: "hand-chalk",
                    },
                    {
                        value: "603682",
                        label: "Gym Bags",
                        name_slug: "gym-bags",
                    },
                    {
                        value: "1000456",
                        label: "Face Covers & Mask",
                        name_slug: "face-covers-mask",
                    },
                    {
                        value: "810640",
                        label: "Coaches' & Referees' Gear",
                        name_slug: "coaches-referees-gear",
                    },
                    {
                        value: "2152336",
                        label: "Ball Storage",
                        name_slug: "ball-storage",
                    },
                    {
                        value: "2152464",
                        label: "Athletic Supporters & Cups",
                        name_slug: "athletic-supporters-cups",
                    },
                ],
            },
            {
                value: "834568",
                label: "Sport & Outdoor Clothing",
                name_slug: "sport-outdoor-clothing",
                children: [
                    {
                        value: "700751",
                        label: "Swimwear",
                        name_slug: "swimwear",
                    },
                    {
                        value: "2153232",
                        label: "Sun Protective",
                        name_slug: "sun-protective",
                    },
                    {
                        value: "835848",
                        label: "Sports Vests",
                        name_slug: "sports-vests",
                    },
                    {
                        value: "1001352",
                        label: "Sports Underwear",
                        name_slug: "sports-underwear",
                    },
                    {
                        value: "835720",
                        label: "Sports Tops",
                        name_slug: "sports-tops",
                    },
                    {
                        value: "963720",
                        label: "Sports Skirts",
                        name_slug: "sports-skirts",
                    },
                    {
                        value: "835976",
                        label: "Sports Shorts",
                        name_slug: "sports-shorts",
                    },
                    {
                        value: "603706",
                        label: "Sports Outerwear",
                        name_slug: "sports-outerwear",
                    },
                    {
                        value: "2153360",
                        label: "Sports Jumpsuits",
                        name_slug: "sports-jumpsuits",
                    },
                    {
                        value: "963976",
                        label: "Sports Dresses",
                        name_slug: "sports-dresses",
                    },
                    {
                        value: "603705",
                        label: "Sports Clothing Sets",
                        name_slug: "sports-clothing-sets",
                    },
                    {
                        value: "603729",
                        label: "Sports Bras",
                        name_slug: "sports-bras",
                    },
                    {
                        value: "836104",
                        label: "Sports Bottoms",
                        name_slug: "sports-bottoms",
                    },
                    {
                        value: "811280",
                        label: "Sport Thermal Underwear",
                        name_slug: "sport-thermal-underwear",
                    },
                    {
                        value: "811152",
                        label: "Sport Rainwear",
                        name_slug: "sport-rainwear",
                    },
                    {
                        value: "1001224",
                        label: "Rashguards",
                        name_slug: "rashguards",
                    },
                    {
                        value: "603042",
                        label: "Professional Sports Clothing",
                        name_slug: "professional-sports-clothing",
                    },
                    {
                        value: "804104",
                        label: "Kids' Swimwear",
                        name_slug: "kids-swimwear",
                    },
                    {
                        value: "836232",
                        label: "Kids' Sports Clothing",
                        name_slug: "kids-sports-clothing",
                    },
                    {
                        value: "603704",
                        label: "Joggers",
                        name_slug: "joggers",
                    },
                    {
                        value: "963592",
                        label: "Dancewear & Dance Costumes",
                        name_slug: "dancewear-dance-costumes",
                    },
                ],
            },
            {
                value: "835592",
                label: "Leisure & Outdoor Recreation Equipment",
                name_slug: "leisure-outdoor-recreation-equipment",
                children: [
                    {
                        value: "603084",
                        label: "Yoga & Pilates",
                        name_slug: "yoga-pilates",
                    },
                    {
                        value: "603301",
                        label: "Wrestling",
                        name_slug: "wrestling",
                    },
                    {
                        value: "970248",
                        label: "Triathlon",
                        name_slug: "triathlon",
                    },
                    {
                        value: "603247",
                        label: "Track & Field",
                        name_slug: "track-field",
                    },
                    {
                        value: "603317",
                        label: "Taekwondo",
                        name_slug: "taekwondo",
                    },
                    {
                        value: "970120",
                        label: "Skydiving",
                        name_slug: "skydiving",
                    },
                    {
                        value: "603493",
                        label: "Skateboarding",
                        name_slug: "skateboarding",
                    },
                    {
                        value: "969992",
                        label: "Running",
                        name_slug: "running",
                    },
                    {
                        value: "970376",
                        label: "Racing",
                        name_slug: "racing",
                    },
                    {
                        value: "969864",
                        label: "Paintball",
                        name_slug: "paintball",
                    },
                    {
                        value: "603304",
                        label: "Nunchucks",
                        name_slug: "nunchucks",
                    },
                    {
                        value: "968968",
                        label: "Karate",
                        name_slug: "karate",
                    },
                    {
                        value: "603295",
                        label: "Judo",
                        name_slug: "judo",
                    },
                    {
                        value: "939912",
                        label: "Inline & Roller Skating",
                        name_slug: "inline-roller-skating",
                    },
                    {
                        value: "700740",
                        label: "Indoor Recreation",
                        name_slug: "indoor-recreation",
                    },
                    {
                        value: "999944",
                        label: "Hunting",
                        name_slug: "hunting",
                    },
                    {
                        value: "969480",
                        label: "Gymnastics",
                        name_slug: "gymnastics",
                    },
                    {
                        value: "603818",
                        label: "Fishing",
                        name_slug: "fishing",
                    },
                    {
                        value: "700741",
                        label: "Fencing",
                        name_slug: "fencing",
                    },
                    {
                        value: "603477",
                        label: "Equestrian",
                        name_slug: "equestrian",
                    },
                    {
                        value: "970504",
                        label: "E-sports",
                        name_slug: "e-sports",
                    },
                    {
                        value: "969736",
                        label: "Disc Sports",
                        name_slug: "disc-sports",
                    },
                    {
                        value: "603605",
                        label: "Darts",
                        name_slug: "darts",
                    },
                    {
                        value: "838408",
                        label: "Cycling",
                        name_slug: "cycling",
                    },
                    {
                        value: "969096",
                        label: "Climbing",
                        name_slug: "climbing",
                    },
                    {
                        value: "969352",
                        label: "Cheerleading",
                        name_slug: "cheerleading",
                    },
                    {
                        value: "603288",
                        label: "Boxing & Martial Arts",
                        name_slug: "boxing-martial-arts",
                    },
                    {
                        value: "968840",
                        label: "Ballet & Dance",
                        name_slug: "ballet-dance",
                    },
                    {
                        value: "603389",
                        label: "Archery",
                        name_slug: "archery",
                    },
                    {
                        value: "969224",
                        label: "Airsoft",
                        name_slug: "airsoft",
                    },
                    {
                        value: "969608",
                        label: "Aerobics",
                        name_slug: "aerobics",
                    },
                ],
            },
            {
                value: "2108816",
                label: "Lawn Games",
                name_slug: "lawn-games",
                children: [
                    {
                        value: "2153488",
                        label: "Tetherball",
                        name_slug: "tetherball",
                    },
                    {
                        value: "2153616",
                        label: "Speed Badminton",
                        name_slug: "speed-badminton",
                    },
                    {
                        value: "2153744",
                        label: "Petanque & Boules",
                        name_slug: "petanque-boules",
                    },
                    {
                        value: "2153872",
                        label: "Horseshoes",
                        name_slug: "horseshoes",
                    },
                    {
                        value: "2154000",
                        label: "Croquet",
                        name_slug: "croquet",
                    },
                    {
                        value: "2154128",
                        label: "Beanbags & Foot Bags",
                        name_slug: "beanbags-foot-bags",
                    },
                ],
            },
            {
                value: "835336",
                label: "Fitness",
                name_slug: "fitness",
                children: [
                    {
                        value: "837640",
                        label: "Weight Training",
                        name_slug: "weight-training",
                    },
                    {
                        value: "994312",
                        label: "Trampolines & Accessories",
                        name_slug: "trampolines-accessories",
                    },
                    {
                        value: "994568",
                        label: "Suspension Trainers",
                        name_slug: "suspension-trainers",
                    },
                    {
                        value: "2154256",
                        label: "Strength Training Equipment",
                        name_slug: "strength-training-equipment",
                    },
                    {
                        value: "843408",
                        label: "Sports Mats",
                        name_slug: "sports-mats",
                    },
                    {
                        value: "603375",
                        label: "Skipping Ropes",
                        name_slug: "skipping-ropes",
                    },
                    {
                        value: "940040",
                        label: "Scooters Equipment",
                        name_slug: "scooters-equipment",
                    },
                    {
                        value: "939784",
                        label: "Resistance Bands",
                        name_slug: "resistance-bands",
                    },
                    {
                        value: "837896",
                        label: "Pull-Up Bars",
                        name_slug: "pull-up-bars",
                    },
                    {
                        value: "2154384",
                        label: "Massage Belts & Electric Stimulators",
                        name_slug: "massage-belts-electric-stimulators",
                    },
                    {
                        value: "994440",
                        label: "Hand Strengtheners",
                        name_slug: "hand-strengtheners",
                    },
                    {
                        value: "603358",
                        label: "Gym Balls & Accessories",
                        name_slug: "gym-balls-accessories",
                    },
                    {
                        value: "2154512",
                        label: "Fitness Technology",
                        name_slug: "fitness-technology",
                    },
                    {
                        value: "837768",
                        label: "Exercise Machines",
                        name_slug: "exercise-machines",
                    },
                    {
                        value: "994696",
                        label: "Exercise Machine Accessories",
                        name_slug: "exercise-machine-accessories",
                    },
                    {
                        value: "603353",
                        label: "Exercise Hoop",
                        name_slug: "exercise-hoop",
                    },
                    {
                        value: "999816",
                        label: "Balance Training Equipment",
                        name_slug: "balance-training-equipment",
                    },
                    {
                        value: "810256",
                        label: "Aquatic Fitness Equipment",
                        name_slug: "aquatic-fitness-equipment",
                    },
                    {
                        value: "810384",
                        label: "Agility Training Equipment",
                        name_slug: "agility-training-equipment",
                    },
                    {
                        value: "2154640",
                        label: "Accessories",
                        name_slug: "accessories",
                    },
                    {
                        value: "603355",
                        label: "Ab Training",
                        name_slug: "ab-training",
                    },
                ],
            },
            {
                value: "936712",
                label: "Fan Shop",
                name_slug: "fan-shop",
                children: [
                    {
                        value: "937608",
                        label: "Tennis",
                        name_slug: "tennis",
                    },
                    {
                        value: "936840",
                        label: "Premier League",
                        name_slug: "premier-league",
                    },
                    {
                        value: "937224",
                        label: "Golf",
                        name_slug: "golf",
                    },
                    {
                        value: "937352",
                        label: "Gaming",
                        name_slug: "gaming",
                    },
                    {
                        value: "937096",
                        label: "Cricket",
                        name_slug: "cricket",
                    },
                    {
                        value: "936968",
                        label: "Basketball",
                        name_slug: "basketball",
                    },
                    {
                        value: "937480",
                        label: "American Football",
                        name_slug: "american-football",
                    },
                ],
            },
            {
                value: "835464",
                label: "Camping & Hiking",
                name_slug: "camping-hiking",
                children: [
                    {
                        value: "2154768",
                        label: "Waterproofing & Cleaning",
                        name_slug: "waterproofing-cleaning",
                    },
                    {
                        value: "1000200",
                        label: "Water Filters, Purifiers & Storage",
                        name_slug: "water-filters-purifiers-storage",
                    },
                    {
                        value: "2154896",
                        label: "Trekking Poles",
                        name_slug: "trekking-poles",
                    },
                    {
                        value: "700782",
                        label: "Tents & Accessories",
                        name_slug: "tents-accessories",
                    },
                    {
                        value: "604054",
                        label: "Sleeping Gear",
                        name_slug: "sleeping-gear",
                    },
                    {
                        value: "2155024",
                        label: "Safety & Survival Gear",
                        name_slug: "safety-survival-gear",
                    },
                    {
                        value: "838152",
                        label: "Picnicware",
                        name_slug: "picnicware",
                    },
                    {
                        value: "1000328",
                        label: "Personal Care",
                        name_slug: "personal-care",
                    },
                    {
                        value: "603970",
                        label: "Lights & Lanterns",
                        name_slug: "lights-lanterns",
                    },
                    {
                        value: "2155152",
                        label: "Lighters & Fire Starters",
                        name_slug: "lighters-fire-starters",
                    },
                    {
                        value: "603835",
                        label: "Knives & Tools",
                        name_slug: "knives-tools",
                    },
                    {
                        value: "838024",
                        label: "Hiking Sticks",
                        name_slug: "hiking-sticks",
                    },
                    {
                        value: "2155280",
                        label: "Hand & Foot Warmers",
                        name_slug: "hand-foot-warmers",
                    },
                    {
                        value: "603952",
                        label: "Hammocks",
                        name_slug: "hammocks",
                    },
                    {
                        value: "604059",
                        label: "GPS & Navigation",
                        name_slug: "gps-navigation",
                    },
                    {
                        value: "2155408",
                        label: "Child Carriers",
                        name_slug: "child-carriers",
                    },
                    {
                        value: "2155536",
                        label: "Camping Shelters",
                        name_slug: "camping-shelters",
                    },
                    {
                        value: "838280",
                        label: "Camping Furniture",
                        name_slug: "camping-furniture",
                    },
                    {
                        value: "1023112",
                        label: "Camping Fan",
                        name_slug: "camping-fan",
                    },
                    {
                        value: "603917",
                        label: "Camp Kitchen",
                        name_slug: "camp-kitchen",
                    },
                    {
                        value: "2155792",
                        label: "Bivy Bags",
                        name_slug: "bivy-bags",
                    },
                    {
                        value: "604065",
                        label: "Binoculars & Telescopes",
                        name_slug: "binoculars-telescopes",
                    },
                    {
                        value: "2155920",
                        label: "Bags & Packs",
                        name_slug: "bags-packs",
                    },
                ],
            },
            {
                value: "834952",
                label: "Ball Sports",
                name_slug: "ball-sports",
                children: [
                    {
                        value: "603437",
                        label: "Volleyball",
                        name_slug: "volleyball",
                    },
                    {
                        value: "603221",
                        label: "Tennis",
                        name_slug: "tennis",
                    },
                    {
                        value: "603396",
                        label: "Table Tennis",
                        name_slug: "table-tennis",
                    },
                    {
                        value: "603641",
                        label: "Squash",
                        name_slug: "squash",
                    },
                    {
                        value: "968712",
                        label: "Softball",
                        name_slug: "softball",
                    },
                    {
                        value: "837128",
                        label: "Rugby",
                        name_slug: "rugby",
                    },
                    {
                        value: "2152592",
                        label: "Roller Hockey",
                        name_slug: "roller-hockey",
                    },
                    {
                        value: "2152720",
                        label: "Rodeo",
                        name_slug: "rodeo",
                    },
                    {
                        value: "2152848",
                        label: "Racquetball",
                        name_slug: "racquetball",
                    },
                    {
                        value: "968584",
                        label: "Polo",
                        name_slug: "polo",
                    },
                    {
                        value: "1025672",
                        label: "Pickleball",
                        name_slug: "pickleball",
                    },
                    {
                        value: "2152976",
                        label: "Paddle Tennis",
                        name_slug: "paddle-tennis",
                    },
                    {
                        value: "968456",
                        label: "Netball",
                        name_slug: "netball",
                    },
                    {
                        value: "2153104",
                        label: "Lacrosse",
                        name_slug: "lacrosse",
                    },
                    {
                        value: "968072",
                        label: "Handball",
                        name_slug: "handball",
                    },
                    {
                        value: "603573",
                        label: "Golf",
                        name_slug: "golf",
                    },
                    {
                        value: "968200",
                        label: "Futsal",
                        name_slug: "futsal",
                    },
                    {
                        value: "603041",
                        label: "Football",
                        name_slug: "football",
                    },
                    {
                        value: "968328",
                        label: "Field Hockey",
                        name_slug: "field-hockey",
                    },
                    {
                        value: "936584",
                        label: "Cricket",
                        name_slug: "cricket",
                    },
                    {
                        value: "603646",
                        label: "Bowling",
                        name_slug: "bowling",
                    },
                    {
                        value: "603331",
                        label: "Billiards & Snooker",
                        name_slug: "billiards-snooker",
                    },
                    {
                        value: "603524",
                        label: "Basketball",
                        name_slug: "basketball",
                    },
                    {
                        value: "603652",
                        label: "Baseballs",
                        name_slug: "baseballs",
                    },
                    {
                        value: "603065",
                        label: "Badminton",
                        name_slug: "badminton",
                    },
                    {
                        value: "967944",
                        label: "American Handball",
                        name_slug: "american-handball",
                    },
                    {
                        value: "936328",
                        label: "American Football",
                        name_slug: "american-football",
                    },
                ],
            },
        ],
    },
    {
        value: "700437",
        label: "Food & Beverages",
        name_slug: "food-beverages",
        children: [
            {
                value: "915080",
                label: "Staples & Cooking Essentials",
                name_slug: "staples-cooking-essentials",
                children: [
                    {
                        value: "919560",
                        label: "Vinegar",
                        name_slug: "vinegar",
                    },
                    {
                        value: "919048",
                        label: "Sugar & Sweeteners",
                        name_slug: "sugar-sweeteners",
                    },
                    {
                        value: "2160528",
                        label: "Shortening",
                        name_slug: "shortening",
                    },
                    {
                        value: "919304",
                        label: "Salt",
                        name_slug: "salt",
                    },
                    {
                        value: "917896",
                        label: "Rice",
                        name_slug: "rice",
                    },
                    {
                        value: "918024",
                        label: "Pasta, Noodles & Vermicelli",
                        name_slug: "pasta-noodles-vermicelli",
                    },
                    {
                        value: "918920",
                        label: "Oils",
                        name_slug: "oils",
                    },
                    {
                        value: "2160656",
                        label: "Infused Oils",
                        name_slug: "infused-oils",
                    },
                    {
                        value: "920328",
                        label: "Honey & Maple Syrup",
                        name_slug: "honey-maple-syrup",
                    },
                    {
                        value: "919176",
                        label: "Herbs, Spices & Seasonings",
                        name_slug: "herbs-spices-seasonings",
                    },
                    {
                        value: "920200",
                        label: "Flour",
                        name_slug: "flour",
                    },
                    {
                        value: "920072",
                        label: "Flavor Enhancers",
                        name_slug: "flavor-enhancers",
                    },
                    {
                        value: "963336",
                        label: "Dried Foods",
                        name_slug: "dried-foods",
                    },
                    {
                        value: "920456",
                        label: "Dressings & Spreads",
                        name_slug: "dressings-spreads",
                    },
                    {
                        value: "919688",
                        label: "Cooking Wine",
                        name_slug: "cooking-wine",
                    },
                    {
                        value: "919432",
                        label: "Cooking Sauces",
                        name_slug: "cooking-sauces",
                    },
                    {
                        value: "919944",
                        label: "Cooking Pastes & Seasoning Kits",
                        name_slug: "cooking-pastes-seasoning-kits",
                    },
                    {
                        value: "919816",
                        label: "Broth, Gravy & Instant Soup",
                        name_slug: "broth-gravy-instant-soup",
                    },
                    {
                        value: "918152",
                        label: "Beans & Grains",
                        name_slug: "beans-grains",
                    },
                ],
            },
            {
                value: "915336",
                label: "Snacks",
                name_slug: "snacks",
                children: [
                    {
                        value: "820368",
                        label: "Snack Cakes & Pastries",
                        name_slug: "snack-cakes-pastries",
                    },
                    {
                        value: "921864",
                        label: "Seeds",
                        name_slug: "seeds",
                    },
                    {
                        value: "922120",
                        label: "Seaweed",
                        name_slug: "seaweed",
                    },
                    {
                        value: "921992",
                        label: "Popcorn",
                        name_slug: "popcorn",
                    },
                    {
                        value: "851856",
                        label: "Plant-based & Gluten Snacks",
                        name_slug: "plant-based-gluten-snacks",
                    },
                    {
                        value: "922248",
                        label: "Nuts & Peas",
                        name_slug: "nuts-peas",
                    },
                    {
                        value: "963464",
                        label: "Gift Sets",
                        name_slug: "gift-sets",
                    },
                    {
                        value: "922504",
                        label: "Dried Snacks",
                        name_slug: "dried-snacks",
                    },
                    {
                        value: "922376",
                        label: "Custard Puddings & Jelly",
                        name_slug: "custard-puddings-jelly",
                    },
                    {
                        value: "700554",
                        label: "Crisps & Puffed Snacks",
                        name_slug: "crisps-puffed-snacks",
                    },
                    {
                        value: "700768",
                        label: "Chocolate & Chocolate Snacks",
                        name_slug: "chocolate-chocolate-snacks",
                    },
                    {
                        value: "946952",
                        label: "Chewing & Bubble Gum",
                        name_slug: "chewing-bubble-gum",
                    },
                    {
                        value: "921736",
                        label: "Candy",
                        name_slug: "candy",
                    },
                    {
                        value: "700553",
                        label: "Biscuits, Cookies & Wafers",
                        name_slug: "biscuits-cookies-wafers",
                    },
                    {
                        value: "947080",
                        label: "Bars",
                        name_slug: "bars",
                    },
                ],
            },
            {
                value: "914952",
                label: "Pantry Food",
                name_slug: "pantry-food",
                children: [
                    {
                        value: "918408",
                        label: "Pickled, Preserves and Jams",
                        name_slug: "pickled-preserves-and-jams",
                    },
                    {
                        value: "918536",
                        label: "Instant Rice & Porridge",
                        name_slug: "instant-rice-porridge",
                    },
                    {
                        value: "700644",
                        label: "Instant Noodles",
                        name_slug: "instant-noodles",
                    },
                    {
                        value: "918664",
                        label: "Instant Hotpot",
                        name_slug: "instant-hotpot",
                    },
                    {
                        value: "918280",
                        label: "Canned, Jarred & Packaged Foods",
                        name_slug: "canned-jarred-packaged-foods",
                    },
                    {
                        value: "918792",
                        label: "Breakfast Cereal, Granola & Oatmeal",
                        name_slug: "breakfast-cereal-granola-oatmeal",
                    },
                    {
                        value: "853648",
                        label: "Bird's Nest",
                        name_slug: "birds-nest",
                    },
                ],
            },
            {
                value: "809744",
                label: "Milk & Dairy",
                name_slug: "milk-dairy",
                children: [
                    {
                        value: "999432",
                        label: "Yogurt & Fermented Dairy Products",
                        name_slug: "yogurt-fermented-dairy-products",
                    },
                    {
                        value: "820496",
                        label: "UHT Milk",
                        name_slug: "uht-milk",
                    },
                    {
                        value: "820624",
                        label: "Powdered Milk",
                        name_slug: "powdered-milk",
                    },
                    {
                        value: "917128",
                        label: "Non-Dairy Milk",
                        name_slug: "non-dairy-milk",
                    },
                    {
                        value: "999304",
                        label: "Milk",
                        name_slug: "milk",
                    },
                    {
                        value: "1011336",
                        label: "Cheese",
                        name_slug: "cheese",
                    },
                ],
            },
            {
                value: "915464",
                label: "Fresh & Frozen Food",
                name_slug: "fresh-frozen-food",
                children: [
                    {
                        value: "922888",
                        label: "Vegetarian Meat Alternatives",
                        name_slug: "vegetarian-meat-alternatives",
                    },
                    {
                        value: "923784",
                        label: "Vegetables",
                        name_slug: "vegetables",
                    },
                    {
                        value: "923656",
                        label: "Tofu",
                        name_slug: "tofu",
                    },
                    {
                        value: "807568",
                        label: "Soups & Stews",
                        name_slug: "soups-stews",
                    },
                    {
                        value: "922760",
                        label: "Seafood",
                        name_slug: "seafood",
                    },
                    {
                        value: "807440",
                        label: "Sandwiches & Wraps",
                        name_slug: "sandwiches-wraps",
                    },
                    {
                        value: "924296",
                        label: "Processed Meat & Seafood",
                        name_slug: "processed-meat-seafood",
                    },
                    {
                        value: "807952",
                        label: "Prepared Meals",
                        name_slug: "prepared-meals",
                    },
                    {
                        value: "807312",
                        label: "Pizza & Focaccia",
                        name_slug: "pizza-focaccia",
                    },
                    {
                        value: "923272",
                        label: "Pastries",
                        name_slug: "pastries",
                    },
                    {
                        value: "807696",
                        label: "Pasta & Sauces",
                        name_slug: "pasta-sauces",
                    },
                    {
                        value: "924040",
                        label: "Mushroom",
                        name_slug: "mushroom",
                    },
                    {
                        value: "922632",
                        label: "Meat",
                        name_slug: "meat",
                    },
                    {
                        value: "946824",
                        label: "Meal Kits",
                        name_slug: "meal-kits",
                    },
                    {
                        value: "923400",
                        label: "Ice Cream",
                        name_slug: "ice-cream",
                    },
                    {
                        value: "923912",
                        label: "Fruit",
                        name_slug: "fruit",
                    },
                    {
                        value: "924168",
                        label: "Frozen Food",
                        name_slug: "frozen-food",
                    },
                    {
                        value: "1011464",
                        label: "Fresh & Frozen Beverages",
                        name_slug: "fresh-frozen-beverages",
                    },
                    {
                        value: "923528",
                        label: "Eggs",
                        name_slug: "eggs",
                    },
                    {
                        value: "807824",
                        label: "Deli",
                        name_slug: "deli",
                    },
                    {
                        value: "923144",
                        label: "Cakes & Pies",
                        name_slug: "cakes-pies",
                    },
                    {
                        value: "923016",
                        label: "Bread",
                        name_slug: "bread",
                    },
                ],
            },
            {
                value: "914824",
                label: "Drinks",
                name_slug: "drinks",
                children: [
                    {
                        value: "917000",
                        label: "Water & Flavored Water",
                        name_slug: "water-flavored-water",
                    },
                    {
                        value: "843536",
                        label: "Water",
                        name_slug: "water",
                    },
                    {
                        value: "916488",
                        label: "Tea",
                        name_slug: "tea",
                    },
                    {
                        value: "917768",
                        label: "Syrups & Concentrates",
                        name_slug: "syrups-concentrates",
                    },
                    {
                        value: "917256",
                        label: "Sports & Energy Drinks",
                        name_slug: "sports-energy-drinks",
                    },
                    {
                        value: "917384",
                        label: "Non-Alcoholic Drinks",
                        name_slug: "non-alcoholic-drinks",
                    },
                    {
                        value: "2160784",
                        label: "Milk Substitute",
                        name_slug: "milk-substitute",
                    },
                    {
                        value: "819984",
                        label: "Meal Replacement & Protein Drinks",
                        name_slug: "meal-replacement-protein-drinks",
                    },
                    {
                        value: "916744",
                        label: "Juice & Smoothies",
                        name_slug: "juice-smoothies",
                    },
                    {
                        value: "917512",
                        label: "Hydration Powders",
                        name_slug: "hydration-powders",
                    },
                    {
                        value: "916872",
                        label: "Fizzy Drinks",
                        name_slug: "fizzy-drinks",
                    },
                    {
                        value: "917640",
                        label: "Drink Toppings",
                        name_slug: "drink-toppings",
                    },
                    {
                        value: "820112",
                        label: "Coffee Substitutes",
                        name_slug: "coffee-substitutes",
                    },
                    {
                        value: "700612",
                        label: "Coffee",
                        name_slug: "coffee",
                    },
                    {
                        value: "916616",
                        label: "Chocolate & Malted Drinks",
                        name_slug: "chocolate-malted-drinks",
                    },
                ],
            },
            {
                value: "914696",
                label: "Beer, Wine & Spirits",
                name_slug: "beer-wine-spirits",
                children: [
                    {
                        value: "915720",
                        label: "Wine",
                        name_slug: "wine",
                    },
                    {
                        value: "916360",
                        label: "Spirits",
                        name_slug: "spirits",
                    },
                    {
                        value: "916232",
                        label: "Sparkling Wine & Champagne",
                        name_slug: "sparkling-wine-champagne",
                    },
                    {
                        value: "916104",
                        label: "Sake, Soju & Umeshu",
                        name_slug: "sake-soju-umeshu",
                    },
                    {
                        value: "915976",
                        label: "Pre-Mixed & Ready to Drink",
                        name_slug: "pre-mixed-ready-to-drink",
                    },
                    {
                        value: "999560",
                        label: "Fruit Wine & Seasonal Wine",
                        name_slug: "fruit-wine-seasonal-wine",
                    },
                    {
                        value: "999688",
                        label: "Fortified & Dessert Wines",
                        name_slug: "fortified-dessert-wines",
                    },
                    {
                        value: "915848",
                        label: "Cider",
                        name_slug: "cider",
                    },
                    {
                        value: "915592",
                        label: "Beer",
                        name_slug: "beer",
                    },
                ],
            },
            {
                value: "915208",
                label: "Baking",
                name_slug: "baking",
                children: [
                    {
                        value: "999176",
                        label: "Marshmallows",
                        name_slug: "marshmallows",
                    },
                    {
                        value: "921224",
                        label: "Frosting, Icing & Decorations",
                        name_slug: "frosting-icing-decorations",
                    },
                    {
                        value: "920584",
                        label: "Food Flavoring & Extracts",
                        name_slug: "food-flavoring-extracts",
                    },
                    {
                        value: "921096",
                        label: "Food Coloring",
                        name_slug: "food-coloring",
                    },
                    {
                        value: "2160912",
                        label: "Evaporated Milk",
                        name_slug: "evaporated-milk",
                    },
                    {
                        value: "921352",
                        label: "Creamers",
                        name_slug: "creamers",
                    },
                    {
                        value: "999048",
                        label: "Cream",
                        name_slug: "cream",
                    },
                    {
                        value: "820752",
                        label: "Condensed Milk",
                        name_slug: "condensed-milk",
                    },
                    {
                        value: "921608",
                        label: "Cheese & Cheese Powder",
                        name_slug: "cheese-cheese-powder",
                    },
                    {
                        value: "921480",
                        label: "Butter & Margarine",
                        name_slug: "butter-margarine",
                    },
                    {
                        value: "820240",
                        label: "Breadcrumbs & Stuffing",
                        name_slug: "breadcrumbs-stuffing",
                    },
                    {
                        value: "920712",
                        label: "Baking Powder & Soda",
                        name_slug: "baking-powder-soda",
                    },
                    {
                        value: "920840",
                        label: "Baking Mixes",
                        name_slug: "baking-mixes",
                    },
                    {
                        value: "920968",
                        label: "Baking Flours",
                        name_slug: "baking-flours",
                    },
                ],
            },
        ],
    },
    {
        value: "601755",
        label: "Computers & Office Equipment",
        name_slug: "computers-office-equipment",
        children: [
            {
                value: "831112",
                label: "Office Stationery & Supplies",
                name_slug: "office-stationery-supplies",
                children: [
                    {
                        value: "603002",
                        label: "Writing & Correction Tools",
                        name_slug: "writing-correction-tools",
                    },
                    {
                        value: "988936",
                        label: "Tape, Adhesives & Fasteners",
                        name_slug: "tape-adhesives-fasteners",
                    },
                    {
                        value: "831624",
                        label: "School & Educational Supplies",
                        name_slug: "school-educational-supplies",
                    },
                    {
                        value: "899336",
                        label: "Safes",
                        name_slug: "safes",
                    },
                    {
                        value: "988680",
                        label: "Office Presentation Supplies",
                        name_slug: "office-presentation-supplies",
                    },
                    {
                        value: "988552",
                        label: "Office Measuring Supplies",
                        name_slug: "office-measuring-supplies",
                    },
                    {
                        value: "988040",
                        label: "Office Filing Products",
                        name_slug: "office-filing-products",
                    },
                    {
                        value: "2162320",
                        label: "Office Equipment Cleaners",
                        name_slug: "office-equipment-cleaners",
                    },
                    {
                        value: "831368",
                        label: "Office Cutting Supplies",
                        name_slug: "office-cutting-supplies",
                    },
                    {
                        value: "831880",
                        label: "Notebooks & Paper",
                        name_slug: "notebooks-paper",
                    },
                    {
                        value: "2162448",
                        label: "Money Handling Products",
                        name_slug: "money-handling-products",
                    },
                    {
                        value: "988296",
                        label: "Labels, Index Dividers & Stamps",
                        name_slug: "labels-index-dividers-stamps",
                    },
                    {
                        value: "988168",
                        label: "Identification Badges & Supplies",
                        name_slug: "identification-badges-supplies",
                    },
                    {
                        value: "832136",
                        label: "Gifts & Wrapping",
                        name_slug: "gifts-wrapping",
                    },
                    {
                        value: "832008",
                        label: "Envelopes & Postal Supplies",
                        name_slug: "envelopes-postal-supplies",
                    },
                    {
                        value: "832392",
                        label: "Desk Organizers & Accessories",
                        name_slug: "desk-organizers-accessories",
                    },
                    {
                        value: "855560",
                        label: "Cards & Card Stock",
                        name_slug: "cards-card-stock",
                    },
                    {
                        value: "987912",
                        label: "Calendars, Planners & Personal Organisers",
                        name_slug: "calendars-planners-personal-organisers",
                    },
                    {
                        value: "1026312",
                        label: "Book Covers & Book Accessories",
                        name_slug: "book-covers-book-accessories",
                    },
                    {
                        value: "831240",
                        label: "Binders & Binder Accessories",
                        name_slug: "binders-binder-accessories",
                    },
                    {
                        value: "831752",
                        label: "Art Supplies",
                        name_slug: "art-supplies",
                    },
                    {
                        value: "832264",
                        label: "Accounting Supplies",
                        name_slug: "accounting-supplies",
                    },
                ],
            },
            {
                value: "830344",
                label: "Office Equipment",
                name_slug: "office-equipment",
                children: [
                    {
                        value: "830472",
                        label: "Typewriters",
                        name_slug: "typewriters",
                    },
                    {
                        value: "986504",
                        label: "Smart Retail Equipment",
                        name_slug: "smart-retail-equipment",
                    },
                    {
                        value: "830984",
                        label: "Printers & Scanners",
                        name_slug: "printers-scanners",
                    },
                    {
                        value: "830728",
                        label: "Paper Shredders",
                        name_slug: "paper-shredders",
                    },
                    {
                        value: "987656",
                        label: "Office Equipment Parts",
                        name_slug: "office-equipment-parts",
                    },
                    {
                        value: "830856",
                        label: "Money Counters",
                        name_slug: "money-counters",
                    },
                    {
                        value: "987784",
                        label: "Laminators",
                        name_slug: "laminators",
                    },
                    {
                        value: "986888",
                        label: "Label Printers",
                        name_slug: "label-printers",
                    },
                    {
                        value: "987528",
                        label: "Ink & Toner Cartridges",
                        name_slug: "ink-toner-cartridges",
                    },
                    {
                        value: "985608",
                        label: "Fax Machines",
                        name_slug: "fax-machines",
                    },
                    {
                        value: "993160",
                        label: "Conference Video & Audio Devices",
                        name_slug: "conference-video-audio-devices",
                    },
                    {
                        value: "986248",
                        label: "Barcode Scanners",
                        name_slug: "barcode-scanners",
                    },
                    {
                        value: "987272",
                        label: "Advertisement Printing Equipment",
                        name_slug: "advertisement-printing-equipment",
                    },
                    {
                        value: "830600",
                        label: "Access Control & Attendance Devices",
                        name_slug: "access-control-attendance-devices",
                    },
                    {
                        value: "985480",
                        label: "3D Printing Supplies",
                        name_slug: "3d-printing-supplies",
                    },
                ],
            },
            {
                value: "829192",
                label: "Network Components",
                name_slug: "network-components",
                children: [
                    {
                        value: "829576",
                        label: "Wireless Adapters & Network Cards",
                        name_slug: "wireless-adapters-network-cards",
                    },
                    {
                        value: "829448",
                        label: "Repeaters",
                        name_slug: "repeaters",
                    },
                    {
                        value: "830216",
                        label: "Print Servers",
                        name_slug: "print-servers",
                    },
                    {
                        value: "829704",
                        label: "Powerline Adapters",
                        name_slug: "powerline-adapters",
                    },
                    {
                        value: "829832",
                        label: "Network Switches & PoE",
                        name_slug: "network-switches-poe",
                    },
                    {
                        value: "829960",
                        label: "Network Cables & Connectors",
                        name_slug: "network-cables-connectors",
                    },
                    {
                        value: "829320",
                        label: "Modems & Wireless Routers",
                        name_slug: "modems-wireless-routers",
                    },
                    {
                        value: "830088",
                        label: "KVM Switches",
                        name_slug: "kvm-switches",
                    },
                ],
            },
            {
                value: "824840",
                label: "Desktop Computers, Laptops & Tablets",
                name_slug: "desktop-computers-laptops-tablets",
                children: [
                    {
                        value: "978568",
                        label: "Servers & Server Racks",
                        name_slug: "servers-server-racks",
                    },
                    {
                        value: "601756",
                        label: "Laptops",
                        name_slug: "laptops",
                    },
                    {
                        value: "601836",
                        label: "Desktop Computers",
                        name_slug: "desktop-computers",
                    },
                    {
                        value: "854672",
                        label: "All-in-One Desktops",
                        name_slug: "all-in-one-desktops",
                    },
                    {
                        value: "1026184",
                        label: "Advertising Monitor",
                        name_slug: "advertising-monitor",
                    },
                ],
            },
            {
                value: "825352",
                label: "Desktop & Laptop Components",
                name_slug: "desktop-laptop-components",
                children: [
                    {
                        value: "826248",
                        label: "UPS & Stabilizers",
                        name_slug: "ups-stabilizers",
                    },
                    {
                        value: "2318480",
                        label: "Thermal Paste & Pads",
                        name_slug: "thermal-paste-pads",
                    },
                    {
                        value: "2318608",
                        label: "TV Tuner & Video Capture Cards",
                        name_slug: "tv-tuner-video-capture-cards",
                    },
                    {
                        value: "826632",
                        label: "Sound Cards",
                        name_slug: "sound-cards",
                    },
                    {
                        value: "2162576",
                        label: "Single Board Computers",
                        name_slug: "single-board-computers",
                    },
                    {
                        value: "826120",
                        label: "RAM",
                        name_slug: "ram",
                    },
                    {
                        value: "825608",
                        label: "Processors",
                        name_slug: "processors",
                    },
                    {
                        value: "825992",
                        label: "Power Supply Units",
                        name_slug: "power-supply-units",
                    },
                    {
                        value: "826376",
                        label: "PC Cases",
                        name_slug: "pc-cases",
                    },
                    {
                        value: "826504",
                        label: "Optical Drives",
                        name_slug: "optical-drives",
                    },
                    {
                        value: "825736",
                        label: "Motherboards",
                        name_slug: "motherboards",
                    },
                    {
                        value: "601783",
                        label: "Monitors",
                        name_slug: "monitors",
                    },
                    {
                        value: "825864",
                        label: "Graphics Cards",
                        name_slug: "graphics-cards",
                    },
                    {
                        value: "825480",
                        label: "Fans & Heatsinks",
                        name_slug: "fans-heatsinks",
                    },
                    {
                        value: "2162704",
                        label: "Cables & Accessories",
                        name_slug: "cables-accessories",
                    },
                ],
            },
            {
                value: "828168",
                label: "Data Storage & Software",
                name_slug: "data-storage-software",
                children: [
                    {
                        value: "829064",
                        label: "Software",
                        name_slug: "software",
                    },
                    {
                        value: "828424",
                        label: "SSD",
                        name_slug: "ssd",
                    },
                    {
                        value: "828552",
                        label: "Network Attached Storage (NAS)",
                        name_slug: "network-attached-storage-nas",
                    },
                    {
                        value: "880784",
                        label: "Micro SD Cards",
                        name_slug: "micro-sd-cards",
                    },
                    {
                        value: "828296",
                        label: "Hard Drives",
                        name_slug: "hard-drives",
                    },
                    {
                        value: "828808",
                        label: "Hard Disk Enclosures & Docking Stations",
                        name_slug: "hard-disk-enclosures-docking-stations",
                    },
                    {
                        value: "828680",
                        label: "Flash Drives & OTG Cables",
                        name_slug: "flash-drives-otg-cables",
                    },
                    {
                        value: "828936",
                        label: "Compact Discs",
                        name_slug: "compact-discs",
                    },
                ],
            },
            {
                value: "826760",
                label: "Computer Accessories",
                name_slug: "computer-accessories",
                children: [
                    {
                        value: "827144",
                        label: "Webcams",
                        name_slug: "webcams",
                    },
                    {
                        value: "827016",
                        label: "USB Hubs & Card Readers",
                        name_slug: "usb-hubs-card-readers",
                    },
                    {
                        value: "2162832",
                        label: "Portable Computer Monitor",
                        name_slug: "portable-computer-monitor",
                    },
                    {
                        value: "828040",
                        label: "Mouse Pads",
                        name_slug: "mouse-pads",
                    },
                    {
                        value: "827528",
                        label: "Laptop Stands & Trays",
                        name_slug: "laptop-stands-trays",
                    },
                    {
                        value: "827272",
                        label: "Laptop Covers & Cases",
                        name_slug: "laptop-covers-cases",
                    },
                    {
                        value: "827912",
                        label: "Laptop Chargers & Adapters",
                        name_slug: "laptop-chargers-adapters",
                    },
                    {
                        value: "827784",
                        label: "Laptop Batteries",
                        name_slug: "laptop-batteries",
                    },
                    {
                        value: "601760",
                        label: "Keyboards & Mice",
                        name_slug: "keyboards-mice",
                    },
                    {
                        value: "827656",
                        label: "Keyboard & Trackpad Covers",
                        name_slug: "keyboard-trackpad-covers",
                    },
                    {
                        value: "827400",
                        label: "Cooling Pads",
                        name_slug: "cooling-pads",
                    },
                ],
            },
        ],
    },
    {
        value: "604206",
        label: "Toys & Hobbies",
        name_slug: "toys-hobbies",
        children: [
            {
                value: "859912",
                label: "Sports & Outdoor Play",
                name_slug: "sports-outdoor-play",
                children: [
                    {
                        value: "822544",
                        label: "Toy Swords & Sabres",
                        name_slug: "toy-swords-sabres",
                    },
                    {
                        value: "866056",
                        label: "Sports Toys",
                        name_slug: "sports-toys",
                    },
                    {
                        value: "864520",
                        label: "Ride-on Toys",
                        name_slug: "ride-on-toys",
                    },
                    {
                        value: "865416",
                        label: "Pool, Water & Sand Toys",
                        name_slug: "pool-water-sand-toys",
                    },
                    {
                        value: "865160",
                        label: "Playhouses, Tents & Tunnels",
                        name_slug: "playhouses-tents-tunnels",
                    },
                    {
                        value: "864776",
                        label: "Playground Equipment",
                        name_slug: "playground-equipment",
                    },
                    {
                        value: "822160",
                        label: "Nature Exploration Toys",
                        name_slug: "nature-exploration-toys",
                    },
                    {
                        value: "822288",
                        label: "Marble Games",
                        name_slug: "marble-games",
                    },
                    {
                        value: "866696",
                        label: "Kites & Wind Spinners",
                        name_slug: "kites-wind-spinners",
                    },
                    {
                        value: "866312",
                        label: "Flying Toys",
                        name_slug: "flying-toys",
                    },
                    {
                        value: "822416",
                        label: "Bubbles",
                        name_slug: "bubbles",
                    },
                    {
                        value: "865672",
                        label: "Blasters & Toy Guns",
                        name_slug: "blasters-toy-guns",
                    },
                ],
            },
            {
                value: "860552",
                label: "Musical Instruments & Accessories",
                name_slug: "musical-instruments-accessories",
                children: [
                    {
                        value: "870408",
                        label: "Wind Instruments",
                        name_slug: "wind-instruments",
                    },
                    {
                        value: "870280",
                        label: "Percussion Instruments",
                        name_slug: "percussion-instruments",
                    },
                    {
                        value: "870792",
                        label: "Music Accessories",
                        name_slug: "music-accessories",
                    },
                    {
                        value: "870152",
                        label: "Keyboards & Pianos",
                        name_slug: "keyboards-pianos",
                    },
                    {
                        value: "904072",
                        label: "Instrument Bags & Cases",
                        name_slug: "instrument-bags-cases",
                    },
                    {
                        value: "870664",
                        label: "Guitars & Stringed Instruments",
                        name_slug: "guitars-stringed-instruments",
                    },
                    {
                        value: "870920",
                        label: "Electronic Synthesizer",
                        name_slug: "electronic-synthesizer",
                    },
                ],
            },
            {
                value: "860168",
                label: "Games & Puzzles",
                name_slug: "games-puzzles",
                children: [
                    {
                        value: "821136",
                        label: "Stacking Games",
                        name_slug: "stacking-games",
                    },
                    {
                        value: "868360",
                        label: "Puzzles",
                        name_slug: "puzzles",
                    },
                    {
                        value: "868232",
                        label: "Magic Cubes",
                        name_slug: "magic-cubes",
                    },
                    {
                        value: "868872",
                        label: "Magic Acrobatics Equipment",
                        name_slug: "magic-acrobatics-equipment",
                    },
                    {
                        value: "820880",
                        label: "Floor Games",
                        name_slug: "floor-games",
                    },
                    {
                        value: "868488",
                        label: "Dice",
                        name_slug: "dice",
                    },
                    {
                        value: "868744",
                        label: "Card Games",
                        name_slug: "card-games",
                    },
                    {
                        value: "868616",
                        label: "Board Games",
                        name_slug: "board-games",
                    },
                ],
            },
            {
                value: "860040",
                label: "Electric & Remote Control Toys",
                name_slug: "electric-remote-control-toys",
                children: [
                    {
                        value: "821520",
                        label: "Walkie Talkies Toys",
                        name_slug: "walkie-talkies-toys",
                    },
                    {
                        value: "867848",
                        label: "Tanks",
                        name_slug: "tanks",
                    },
                    {
                        value: "867976",
                        label: "Robots",
                        name_slug: "robots",
                    },
                    {
                        value: "867336",
                        label: "Motorcycles",
                        name_slug: "motorcycles",
                    },
                    {
                        value: "821392",
                        label: "Karaoke Machines",
                        name_slug: "karaoke-machines",
                    },
                    {
                        value: "821648",
                        label: "Electronic Pets",
                        name_slug: "electronic-pets",
                    },
                    {
                        value: "868104",
                        label: "Electric Toy Accessories",
                        name_slug: "electric-toy-accessories",
                    },
                    {
                        value: "842768",
                        label: "Digital Cameras",
                        name_slug: "digital-cameras",
                    },
                    {
                        value: "821264",
                        label: "Dance Mats",
                        name_slug: "dance-mats",
                    },
                    {
                        value: "867592",
                        label: "Cars, Lorries & Trains",
                        name_slug: "cars-lorries-trains",
                    },
                    {
                        value: "867464",
                        label: "Boats & Submarines",
                        name_slug: "boats-submarines",
                    },
                    {
                        value: "867720",
                        label: "Animals",
                        name_slug: "animals",
                    },
                    {
                        value: "867080",
                        label: "Airplanes & Helicopters",
                        name_slug: "airplanes-helicopters",
                    },
                ],
            },
            {
                value: "859784",
                label: "Educational Toys",
                name_slug: "educational-toys",
                children: [
                    {
                        value: "864136",
                        label: "Toy Tablets & Computers",
                        name_slug: "toy-tablets-computers",
                    },
                    {
                        value: "863240",
                        label: "Shape Sorters",
                        name_slug: "shape-sorters",
                    },
                    {
                        value: "862984",
                        label: "Science & Technology Toys",
                        name_slug: "science-technology-toys",
                    },
                    {
                        value: "863752",
                        label: "Musical Toys",
                        name_slug: "musical-toys",
                    },
                    {
                        value: "862728",
                        label: "Maths Toys",
                        name_slug: "maths-toys",
                    },
                    {
                        value: "997000",
                        label: "Language Toys",
                        name_slug: "language-toys",
                    },
                    {
                        value: "821904",
                        label: "Flash Cards",
                        name_slug: "flash-cards",
                    },
                    {
                        value: "821776",
                        label: "Detective & Spy",
                        name_slug: "detective-spy",
                    },
                    {
                        value: "862472",
                        label: "Arts & Crafts",
                        name_slug: "arts-crafts",
                    },
                ],
            },
            {
                value: "859656",
                label: "Dolls & Stuffed Toys",
                name_slug: "dolls-stuffed-toys",
                children: [
                    {
                        value: "700699",
                        label: "Stuffed Toys",
                        name_slug: "stuffed-toys",
                    },
                    {
                        value: "861448",
                        label: "Dolls",
                        name_slug: "dolls",
                    },
                    {
                        value: "861704",
                        label: "Doll Houses & Playsets",
                        name_slug: "doll-houses-playsets",
                    },
                    {
                        value: "604390",
                        label: "Doll Accessories",
                        name_slug: "doll-accessories",
                    },
                ],
            },
            {
                value: "951560",
                label: "DIY",
                name_slug: "diy",
                children: [
                    {
                        value: "952328",
                        label: "Specialty DIY Supplies",
                        name_slug: "specialty-diy-supplies",
                    },
                    {
                        value: "951688",
                        label: "Scrapbooking & Stamping",
                        name_slug: "scrapbooking-stamping",
                    },
                    {
                        value: "954376",
                        label: "Pottery & Ceramics",
                        name_slug: "pottery-ceramics",
                    },
                    {
                        value: "952072",
                        label: "Needlework",
                        name_slug: "needlework",
                    },
                    {
                        value: "952456",
                        label: "Leathercraft",
                        name_slug: "leathercraft",
                    },
                    {
                        value: "951816",
                        label: "Knitting & Crochet",
                        name_slug: "knitting-crochet",
                    },
                    {
                        value: "954632",
                        label: "Felt Crafts",
                        name_slug: "felt-crafts",
                    },
                    {
                        value: "954504",
                        label: "DIY Woodwork",
                        name_slug: "diy-woodwork",
                    },
                    {
                        value: "952200",
                        label: "DIY Painting Supplies",
                        name_slug: "diy-painting-supplies",
                    },
                    {
                        value: "952584",
                        label: "Candle & Soap Making",
                        name_slug: "candle-soap-making",
                    },
                    {
                        value: "951944",
                        label: "Beading & Jewelry Making",
                        name_slug: "beading-jewelry-making",
                    },
                    {
                        value: "954248",
                        label: "Badge Making",
                        name_slug: "badge-making",
                    },
                ],
            },
            {
                value: "860296",
                label: "Classic & Novelty Toys",
                name_slug: "classic-novelty-toys",
                children: [
                    {
                        value: "869768",
                        label: "Yo-yos",
                        name_slug: "yo-yos",
                    },
                    {
                        value: "869640",
                        label: "Stress Relief Toys",
                        name_slug: "stress-relief-toys",
                    },
                    {
                        value: "870024",
                        label: "Spinning Tops",
                        name_slug: "spinning-tops",
                    },
                    {
                        value: "963080",
                        label: "Slime & Squishy Toys",
                        name_slug: "slime-squishy-toys",
                    },
                    {
                        value: "822032",
                        label: "Puppets & Puppet Theaters",
                        name_slug: "puppets-puppet-theaters",
                    },
                    {
                        value: "869000",
                        label: "Pretend Play",
                        name_slug: "pretend-play",
                    },
                    {
                        value: "869128",
                        label: "Novelty & Gag Toys",
                        name_slug: "novelty-gag-toys",
                    },
                    {
                        value: "700700",
                        label: "Model & Toy Vehicles",
                        name_slug: "model-toy-vehicles",
                    },
                    {
                        value: "963208",
                        label: "Mahjong",
                        name_slug: "mahjong",
                    },
                    {
                        value: "822672",
                        label: "Fidget & Finger Toys",
                        name_slug: "fidget-finger-toys",
                    },
                    {
                        value: "869896",
                        label: "Capsule Toys",
                        name_slug: "capsule-toys",
                    },
                    {
                        value: "869512",
                        label: "Building Toys",
                        name_slug: "building-toys",
                    },
                    {
                        value: "869256",
                        label: "Action & Toy Figures",
                        name_slug: "action-toy-figures",
                    },
                ],
            },
        ],
    },
    {
        value: "802184",
        label: "Kids' Fashion",
        name_slug: "kids-fashion",
        children: [
            {
                value: "806792",
                label: "Kids' Fashion Accessories",
                name_slug: "kids-fashion-accessories",
                children: [
                    {
                        value: "807816",
                        label: "Watches",
                        name_slug: "watches",
                    },
                    {
                        value: "954760",
                        label: "Ties & Bowties",
                        name_slug: "ties-bowties",
                    },
                    {
                        value: "807688",
                        label: "Kids' Scarves & Shawls",
                        name_slug: "kids-scarves-shawls",
                    },
                    {
                        value: "807048",
                        label: "Kids' Hats",
                        name_slug: "kids-hats",
                    },
                    {
                        value: "807944",
                        label: "Kids Costume Jewelry & Accessories",
                        name_slug: "kids-costume-jewelry-accessories",
                    },
                    {
                        value: "807304",
                        label: "Hair Accessories",
                        name_slug: "hair-accessories",
                    },
                    {
                        value: "807432",
                        label: "Gloves",
                        name_slug: "gloves",
                    },
                    {
                        value: "960520",
                        label: "Face Masks",
                        name_slug: "face-masks",
                    },
                    {
                        value: "807176",
                        label: "Eyewear",
                        name_slug: "eyewear",
                    },
                    {
                        value: "808072",
                        label: "Earmuffs",
                        name_slug: "earmuffs",
                    },
                    {
                        value: "807560",
                        label: "Belts",
                        name_slug: "belts",
                    },
                    {
                        value: "806920",
                        label: "Bags & Luggage",
                        name_slug: "bags-luggage",
                    },
                ],
            },
            {
                value: "2337936",
                label: "Kid's South Asian Clothing",
                name_slug: "kids-south-asian-clothing",
                children: [
                    {
                        value: "2339088",
                        label: "Girls' South Asian Clothing",
                        name_slug: "girls-south-asian-clothing",
                    },
                    {
                        value: "2338960",
                        label: "Boys' South Asian Clothing",
                        name_slug: "boys-south-asian-clothing",
                    },
                ],
            },
            {
                value: "806024",
                label: "Girls' Footwear",
                name_slug: "girls-footwear",
                children: [
                    {
                        value: "806408",
                        label: "Trainers",
                        name_slug: "trainers",
                    },
                    {
                        value: "806536",
                        label: "Slippers",
                        name_slug: "slippers",
                    },
                    {
                        value: "806280",
                        label: "Sandals & Flip Flops",
                        name_slug: "sandals-flip-flops",
                    },
                    {
                        value: "806664",
                        label: "Flat Shoes",
                        name_slug: "flat-shoes",
                    },
                    {
                        value: "806152",
                        label: "Boots",
                        name_slug: "boots",
                    },
                ],
            },
            {
                value: "803592",
                label: "Girls' Clothes",
                name_slug: "girls-clothes",
                children: [
                    {
                        value: "803848",
                        label: "Underwear",
                        name_slug: "underwear",
                    },
                    {
                        value: "804232",
                        label: "Tops",
                        name_slug: "tops",
                    },
                    {
                        value: "960264",
                        label: "Tights",
                        name_slug: "tights",
                    },
                    {
                        value: "804616",
                        label: "Suits & Sets",
                        name_slug: "suits-sets",
                    },
                    {
                        value: "805000",
                        label: "Socks",
                        name_slug: "socks",
                    },
                    {
                        value: "803976",
                        label: "Sleepwear",
                        name_slug: "sleepwear",
                    },
                    {
                        value: "804872",
                        label: "Skirts",
                        name_slug: "skirts",
                    },
                    {
                        value: "803472",
                        label: "School Uniforms",
                        name_slug: "school-uniforms",
                    },
                    {
                        value: "804744",
                        label: "Dresses",
                        name_slug: "dresses",
                    },
                    {
                        value: "803720",
                        label: "Costumes & Accessories",
                        name_slug: "costumes-accessories",
                    },
                    {
                        value: "804360",
                        label: "Coats & Jackets",
                        name_slug: "coats-jackets",
                    },
                    {
                        value: "804488",
                        label: "Bottoms",
                        name_slug: "bottoms",
                    },
                ],
            },
            {
                value: "805128",
                label: "Boys' Footwear",
                name_slug: "boys-footwear",
                children: [
                    {
                        value: "805512",
                        label: "Trainers",
                        name_slug: "trainers",
                    },
                    {
                        value: "805640",
                        label: "Slippers",
                        name_slug: "slippers",
                    },
                    {
                        value: "805384",
                        label: "Sandals & Flip Flops",
                        name_slug: "sandals-flip-flops",
                    },
                    {
                        value: "805768",
                        label: "Formal Shoes",
                        name_slug: "formal-shoes",
                    },
                    {
                        value: "805896",
                        label: "Flat Shoes",
                        name_slug: "flat-shoes",
                    },
                    {
                        value: "805256",
                        label: "Boots",
                        name_slug: "boots",
                    },
                ],
            },
            {
                value: "802312",
                label: "Boys' Clothes",
                name_slug: "boys-clothes",
                children: [
                    {
                        value: "802568",
                        label: "Underwear",
                        name_slug: "underwear",
                    },
                    {
                        value: "802952",
                        label: "Tops",
                        name_slug: "tops",
                    },
                    {
                        value: "803336",
                        label: "Suits & Sets",
                        name_slug: "suits-sets",
                    },
                    {
                        value: "803464",
                        label: "Socks",
                        name_slug: "socks",
                    },
                    {
                        value: "802696",
                        label: "Sleepwear",
                        name_slug: "sleepwear",
                    },
                    {
                        value: "803600",
                        label: "School Uniforms",
                        name_slug: "school-uniforms",
                    },
                    {
                        value: "802440",
                        label: "Costumes & Accessories",
                        name_slug: "costumes-accessories",
                    },
                    {
                        value: "803080",
                        label: "Coats & Jackets",
                        name_slug: "coats-jackets",
                    },
                    {
                        value: "803208",
                        label: "Boys' Bottoms",
                        name_slug: "boys-bottoms",
                    },
                ],
            },
        ],
    },
    {
        value: "605196",
        label: "Automotive & Motorcycle",
        name_slug: "automotive-motorcycle",
        children: [
            {
                value: "940680",
                label: "Quads, Motorhomes & Boats",
                name_slug: "quads-motorhomes-boats",
                children: [
                    {
                        value: "944136",
                        label: "Watercraft Parts & Accessories",
                        name_slug: "watercraft-parts-accessories",
                    },
                    {
                        value: "944264",
                        label: "Transportation & Storage",
                        name_slug: "transportation-storage",
                    },
                    {
                        value: "944520",
                        label: "Snowmobile Parts",
                        name_slug: "snowmobile-parts",
                    },
                    {
                        value: "944392",
                        label: "Salvage Car Parts",
                        name_slug: "salvage-car-parts",
                    },
                    {
                        value: "943496",
                        label: "Quad Bike Parts & Accessories",
                        name_slug: "quad-bike-parts-accessories",
                    },
                    {
                        value: "943752",
                        label: "Motorhome Parts & Accessories",
                        name_slug: "motorhome-parts-accessories",
                    },
                    {
                        value: "1026824",
                        label: "Marine Electronics",
                        name_slug: "marine-electronics",
                    },
                    {
                        value: "944008",
                        label: "Lorry Parts",
                        name_slug: "lorry-parts",
                    },
                    {
                        value: "943880",
                        label: "Electric Vehicle Parts",
                        name_slug: "electric-vehicle-parts",
                    },
                    {
                        value: "943624",
                        label: "Boat Parts & Accessories",
                        name_slug: "boat-parts-accessories",
                    },
                ],
            },
            {
                value: "847504",
                label: "Motorcycles",
                name_slug: "motorcycles",
                children: [
                    {
                        value: "847632",
                        label: "Manual Transmission Motorcycles",
                        name_slug: "manual-transmission-motorcycles",
                    },
                    {
                        value: "847888",
                        label: "Electric Motorcycles",
                        name_slug: "electric-motorcycles",
                    },
                    {
                        value: "847760",
                        label: "Automatic Transmission Motorcycles",
                        name_slug: "automatic-transmission-motorcycles",
                    },
                ],
            },
            {
                value: "809616",
                label: "Motorcycle Parts",
                name_slug: "motorcycle-parts",
                children: [
                    {
                        value: "816784",
                        label: "Wheels, Rims & Accessories",
                        name_slug: "wheels-rims-accessories",
                    },
                    {
                        value: "816400",
                        label: "Tires & Accessories",
                        name_slug: "tires-accessories",
                    },
                    {
                        value: "815760",
                        label: "Sparkplug",
                        name_slug: "sparkplug",
                    },
                    {
                        value: "816272",
                        label: "Shocks, Struts & Suspension",
                        name_slug: "shocks-struts-suspension",
                    },
                    {
                        value: "1003016",
                        label: "Motorcycle Oil",
                        name_slug: "motorcycle-oil",
                    },
                    {
                        value: "945928",
                        label: "Motorcycle Filters",
                        name_slug: "motorcycle-filters",
                    },
                    {
                        value: "1003272",
                        label: "Motorcycle Antifreeze & Lubricant",
                        name_slug: "motorcycle-antifreeze-lubricant",
                    },
                    {
                        value: "817168",
                        label: "Mirrors & Accessories",
                        name_slug: "mirrors-accessories",
                    },
                    {
                        value: "816016",
                        label: "Lighting",
                        name_slug: "lighting",
                    },
                    {
                        value: "817040",
                        label: "Horns & Accessories",
                        name_slug: "horns-accessories",
                    },
                    {
                        value: "946056",
                        label: "Frames & Fittings",
                        name_slug: "frames-fittings",
                    },
                    {
                        value: "815888",
                        label: "Exhaust & Emissions",
                        name_slug: "exhaust-emissions",
                    },
                    {
                        value: "816144",
                        label: "Drivetrain, Transmission & Clutches",
                        name_slug: "drivetrain-transmission-clutches",
                    },
                    {
                        value: "816912",
                        label: "Cables & Tubes",
                        name_slug: "cables-tubes",
                    },
                    {
                        value: "816528",
                        label: "Brake System",
                        name_slug: "brake-system",
                    },
                    {
                        value: "816656",
                        label: "Batteries & Accessories",
                        name_slug: "batteries-accessories",
                    },
                ],
            },
            {
                value: "940936",
                label: "Motorcycle Accessories",
                name_slug: "motorcycle-accessories",
                children: [
                    {
                        value: "815120",
                        label: "Seat & Seat Covers",
                        name_slug: "seat-seat-covers",
                    },
                    {
                        value: "946312",
                        label: "Protective Gear",
                        name_slug: "protective-gear",
                    },
                    {
                        value: "854416",
                        label: "Mud Flaps & Splash Guards",
                        name_slug: "mud-flaps-splash-guards",
                    },
                    {
                        value: "1003400",
                        label: "Motorcycle Sticker & Films",
                        name_slug: "motorcycle-sticker-films",
                    },
                    {
                        value: "1002888",
                        label: "Motorcycle Clothing & Hoods",
                        name_slug: "motorcycle-clothing-hoods",
                    },
                    {
                        value: "946184",
                        label: "Motorcycle Accessories",
                        name_slug: "motorcycle-accessories",
                    },
                    {
                        value: "815248",
                        label: "Locks & Security",
                        name_slug: "locks-security",
                    },
                    {
                        value: "854288",
                        label: "Jackets & Raincoats",
                        name_slug: "jackets-raincoats",
                    },
                    {
                        value: "815632",
                        label: "Helmets",
                        name_slug: "helmets",
                    },
                    {
                        value: "854544",
                        label: "Handlebars & Grips",
                        name_slug: "handlebars-grips",
                    },
                    {
                        value: "815504",
                        label: "Carpets",
                        name_slug: "carpets",
                    },
                    {
                        value: "815376",
                        label: "Boxes &Cases",
                        name_slug: "boxes-cases",
                    },
                ],
            },
            {
                value: "940808",
                label: "Car Washing & Maintenance",
                name_slug: "car-washing-maintenance",
                children: [
                    {
                        value: "945416",
                        label: "Window Repair",
                        name_slug: "window-repair",
                    },
                    {
                        value: "945160",
                        label: "Water Guns & Snow Foam Lances",
                        name_slug: "water-guns-snow-foam-lances",
                    },
                    {
                        value: "944648",
                        label: "Polishing Machines & Accessories",
                        name_slug: "polishing-machines-accessories",
                    },
                    {
                        value: "945544",
                        label: "Paint Care",
                        name_slug: "paint-care",
                    },
                    {
                        value: "944776",
                        label: "Paint & Window Repair Tools",
                        name_slug: "paint-window-repair-tools",
                    },
                    {
                        value: "851600",
                        label: "Oils",
                        name_slug: "oils",
                    },
                    {
                        value: "944904",
                        label: "Interior Care",
                        name_slug: "interior-care",
                    },
                    {
                        value: "945672",
                        label: "Engine Care",
                        name_slug: "engine-care",
                    },
                    {
                        value: "945288",
                        label: "Cleaning & Care Fluids",
                        name_slug: "cleaning-care-fluids",
                    },
                    {
                        value: "945800",
                        label: "Car Washers",
                        name_slug: "car-washers",
                    },
                    {
                        value: "945032",
                        label: "Car Wash Accessories",
                        name_slug: "car-wash-accessories",
                    },
                ],
            },
            {
                value: "940296",
                label: "Car Repair Tools",
                name_slug: "car-repair-tools",
                children: [
                    {
                        value: "941832",
                        label: "Tire Repair & Fitting Tools",
                        name_slug: "tire-repair-fitting-tools",
                    },
                    {
                        value: "941320",
                        label: "Sheet Metal Tools",
                        name_slug: "sheet-metal-tools",
                    },
                    {
                        value: "941704",
                        label: "Engine & Transmission Repair Tools",
                        name_slug: "engine-transmission-repair-tools",
                    },
                    {
                        value: "941192",
                        label: "Diagnostic Tools",
                        name_slug: "diagnostic-tools",
                    },
                    {
                        value: "941064",
                        label: "Code Readers & Scanners",
                        name_slug: "code-readers-scanners",
                    },
                    {
                        value: "941576",
                        label: "Car Inspection Tools",
                        name_slug: "car-inspection-tools",
                    },
                    {
                        value: "942088",
                        label: "Car Body Repair Tools",
                        name_slug: "car-body-repair-tools",
                    },
                    {
                        value: "941448",
                        label: "Car Battery Repair Tools",
                        name_slug: "car-battery-repair-tools",
                    },
                    {
                        value: "941960",
                        label: "Assembly & Disassembly Tools",
                        name_slug: "assembly-disassembly-tools",
                    },
                ],
            },
            {
                value: "940424",
                label: "Car Lights",
                name_slug: "car-lights",
                children: [
                    {
                        value: "942600",
                        label: "Wires",
                        name_slug: "wires",
                    },
                    {
                        value: "942344",
                        label: "Light Bars & Work Lights",
                        name_slug: "light-bars-work-lights",
                    },
                    {
                        value: "942984",
                        label: "Indicator Lights",
                        name_slug: "indicator-lights",
                    },
                    {
                        value: "943240",
                        label: "Headlight Bulbs (Xenon)",
                        name_slug: "headlight-bulbs-xenon",
                    },
                    {
                        value: "942472",
                        label: "Headlight Bulbs (LED)",
                        name_slug: "headlight-bulbs-led",
                    },
                    {
                        value: "943368",
                        label: "Headlight Bulbs (Halogen)",
                        name_slug: "headlight-bulbs-halogen",
                    },
                    {
                        value: "946440",
                        label: "Fog Lights",
                        name_slug: "fog-lights",
                    },
                    {
                        value: "942216",
                        label: "Decorative Lights",
                        name_slug: "decorative-lights",
                    },
                    {
                        value: "942728",
                        label: "Covers",
                        name_slug: "covers",
                    },
                    {
                        value: "942856",
                        label: "Bases",
                        name_slug: "bases",
                    },
                ],
            },
            {
                value: "930184",
                label: "Car Interior Accessories",
                name_slug: "car-interior-accessories",
                children: [
                    {
                        value: "605213",
                        label: "Stowing & Tidying",
                        name_slug: "stowing-tidying",
                    },
                    {
                        value: "850832",
                        label: "Steering Wheel Covers",
                        name_slug: "steering-wheel-covers",
                    },
                    {
                        value: "850960",
                        label: "Steering Locks & Security",
                        name_slug: "steering-locks-security",
                    },
                    {
                        value: "850704",
                        label: "Seat Cushions",
                        name_slug: "seat-cushions",
                    },
                    {
                        value: "932744",
                        label: "Rear Racks & Accessories",
                        name_slug: "rear-racks-accessories",
                    },
                    {
                        value: "851088",
                        label: "Pedals & Gear Sticks",
                        name_slug: "pedals-gear-sticks",
                    },
                    {
                        value: "932488",
                        label: "Neck Pillows",
                        name_slug: "neck-pillows",
                    },
                    {
                        value: "605215",
                        label: "Mounts & Holders",
                        name_slug: "mounts-holders",
                    },
                    {
                        value: "932616",
                        label: "Interior Stickers",
                        name_slug: "interior-stickers",
                    },
                    {
                        value: "932872",
                        label: "Interior Moldings",
                        name_slug: "interior-moldings",
                    },
                    {
                        value: "933128",
                        label: "Fasteners & Clips",
                        name_slug: "fasteners-clips",
                    },
                    {
                        value: "842384",
                        label: "Escape Tools",
                        name_slug: "escape-tools",
                    },
                    {
                        value: "605201",
                        label: "Decoration",
                        name_slug: "decoration",
                    },
                    {
                        value: "700684",
                        label: "Car Mats",
                        name_slug: "car-mats",
                    },
                    {
                        value: "933000",
                        label: "Car Key Cases",
                        name_slug: "car-key-cases",
                    },
                    {
                        value: "842256",
                        label: "Car Fragrance",
                        name_slug: "car-fragrance",
                    },
                    {
                        value: "605219",
                        label: "Anti-Slip Mats",
                        name_slug: "anti-slip-mats",
                    },
                ],
            },
            {
                value: "930056",
                label: "Car Exterior Accessories",
                name_slug: "car-exterior-accessories",
                children: [
                    {
                        value: "931848",
                        label: "Window Tints",
                        name_slug: "window-tints",
                    },
                    {
                        value: "931976",
                        label: "Window Films & Solar Protection",
                        name_slug: "window-films-solar-protection",
                    },
                    {
                        value: "1010952",
                        label: "Towing Products & Winches",
                        name_slug: "towing-products-winches",
                    },
                    {
                        value: "605242",
                        label: "Sunshades",
                        name_slug: "sunshades",
                    },
                    {
                        value: "851728",
                        label: "Side Window Deflectors & Visors",
                        name_slug: "side-window-deflectors-visors",
                    },
                    {
                        value: "931464",
                        label: "Side Mirror Folding Kits",
                        name_slug: "side-mirror-folding-kits",
                    },
                    {
                        value: "932360",
                        label: "Reflective Strips",
                        name_slug: "reflective-strips",
                    },
                    {
                        value: "932104",
                        label: "Number Plates",
                        name_slug: "number-plates",
                    },
                    {
                        value: "841232",
                        label: "Mud Flaps & Splash Guards",
                        name_slug: "mud-flaps-splash-guards",
                    },
                    {
                        value: "841360",
                        label: "Horns & Accessories",
                        name_slug: "horns-accessories",
                    },
                    {
                        value: "851216",
                        label: "Decoration",
                        name_slug: "decoration",
                    },
                    {
                        value: "841488",
                        label: "Chrome Trim & Accessories",
                        name_slug: "chrome-trim-accessories",
                    },
                    {
                        value: "932232",
                        label: "Car Tax Disc Holders",
                        name_slug: "car-tax-disc-holders",
                    },
                    {
                        value: "931720",
                        label: "Car Stickers",
                        name_slug: "car-stickers",
                    },
                    {
                        value: "841616",
                        label: "Car Roof Racks",
                        name_slug: "car-roof-racks",
                    },
                    {
                        value: "931592",
                        label: "Car Covers & Shelters",
                        name_slug: "car-covers-shelters",
                    },
                    {
                        value: "841104",
                        label: "Antenna Toppers",
                        name_slug: "antenna-toppers",
                    },
                ],
            },
            {
                value: "929928",
                label: "Car Electronics",
                name_slug: "car-electronics",
                children: [
                    {
                        value: "930440",
                        label: "Video Surveillance",
                        name_slug: "video-surveillance",
                    },
                    {
                        value: "851472",
                        label: "USB Chargers",
                        name_slug: "usb-chargers",
                    },
                    {
                        value: "892816",
                        label: "Toll Readers",
                        name_slug: "toll-readers",
                    },
                    {
                        value: "930312",
                        label: "Intelligent Systems",
                        name_slug: "intelligent-systems",
                    },
                    {
                        value: "1026568",
                        label: "Installation Accessories & Harnesses",
                        name_slug: "installation-accessories-harnesses",
                    },
                    {
                        value: "931080",
                        label: "GPS",
                        name_slug: "gps",
                    },
                    {
                        value: "851344",
                        label: "FM & Bluetooth Transmitters",
                        name_slug: "fm-bluetooth-transmitters",
                    },
                    {
                        value: "930696",
                        label: "Electronic Accessories",
                        name_slug: "electronic-accessories",
                    },
                    {
                        value: "930952",
                        label: "Car Video Players",
                        name_slug: "car-video-players",
                    },
                    {
                        value: "931208",
                        label: "Car Electrical Appliances",
                        name_slug: "car-electrical-appliances",
                    },
                    {
                        value: "842512",
                        label: "Car Cameras",
                        name_slug: "car-cameras",
                    },
                    {
                        value: "931336",
                        label: "Car Audio",
                        name_slug: "car-audio",
                    },
                    {
                        value: "1026440",
                        label: "CB Radios & Scanners",
                        name_slug: "cb-radios-scanners",
                    },
                    {
                        value: "1026696",
                        label: "Aviation Electronics",
                        name_slug: "aviation-electronics",
                    },
                    {
                        value: "930568",
                        label: "Alarm Systems & Security",
                        name_slug: "alarm-systems-security",
                    },
                ],
            },
            {
                value: "2315664",
                label: "Car",
                name_slug: "car",
                children: [
                    {
                        value: "2322320",
                        label: "Sedan Car",
                        name_slug: "sedan-car",
                    },
                    {
                        value: "2322448",
                        label: "SUV & MPV Car",
                        name_slug: "suv-mpv-car",
                    },
                    {
                        value: "2322064",
                        label: "Electric Car",
                        name_slug: "electric-car",
                    },
                    {
                        value: "2322192",
                        label: "Commercial Car",
                        name_slug: "commercial-car",
                    },
                ],
            },
            {
                value: "809488",
                label: "Auto Replacement Parts",
                name_slug: "auto-replacement-parts",
                children: [
                    {
                        value: "813328",
                        label: "Windshield Wipers & Washers",
                        name_slug: "windshield-wipers-washers",
                    },
                    {
                        value: "813584",
                        label: "Wheels, Rims & Accessories",
                        name_slug: "wheels-rims-accessories",
                    },
                    {
                        value: "813712",
                        label: "Tires & Accessories",
                        name_slug: "tires-accessories",
                    },
                    {
                        value: "813840",
                        label: "Shocks, Struts & Suspension",
                        name_slug: "shocks-struts-suspension",
                    },
                    {
                        value: "813968",
                        label: "Radiators, Engine Cooling & Climate Control",
                        name_slug: "radiators-engine-cooling-climate-control",
                    },
                    {
                        value: "814864",
                        label: "Ignition",
                        name_slug: "ignition",
                    },
                    {
                        value: "814736",
                        label: "Fuel System",
                        name_slug: "fuel-system",
                    },
                    {
                        value: "813456",
                        label: "Exhaust & Emissions",
                        name_slug: "exhaust-emissions",
                    },
                    {
                        value: "814352",
                        label: "Engine Parts",
                        name_slug: "engine-parts",
                    },
                    {
                        value: "814096",
                        label: "Drivetrain, Transmission & Clutches",
                        name_slug: "drivetrain-transmission-clutches",
                    },
                    {
                        value: "814480",
                        label: "Brake System",
                        name_slug: "brake-system",
                    },
                    {
                        value: "813200",
                        label: "Body, Frame & Bumpers",
                        name_slug: "body-frame-bumpers",
                    },
                    {
                        value: "814608",
                        label: "Belts, Hoses & Pulleys",
                        name_slug: "belts-hoses-pulleys",
                    },
                    {
                        value: "814224",
                        label: "Bearing & Seals",
                        name_slug: "bearing-seals",
                    },
                    {
                        value: "814992",
                        label: "Batteries & Accessories",
                        name_slug: "batteries-accessories",
                    },
                ],
            },
        ],
    },
    {
        value: "602118",
        label: "Pet Supplies",
        name_slug: "pet-supplies",
        children: [
            {
                value: "822792",
                label: "Small Animal Supplies",
                name_slug: "small-animal-supplies",
                children: [
                    {
                        value: "823048",
                        label: "Toys",
                        name_slug: "toys",
                    },
                    {
                        value: "981768",
                        label: "Small Pet Food",
                        name_slug: "small-pet-food",
                    },
                    {
                        value: "981640",
                        label: "Small Pet Clothing",
                        name_slug: "small-pet-clothing",
                    },
                    {
                        value: "823944",
                        label: "Odor & Stain Removers",
                        name_slug: "odor-stain-removers",
                    },
                    {
                        value: "822920",
                        label: "Houses & Habitats",
                        name_slug: "houses-habitats",
                    },
                    {
                        value: "823816",
                        label: "Health Supplies",
                        name_slug: "health-supplies",
                    },
                    {
                        value: "823560",
                        label: "Grooming Supplies",
                        name_slug: "grooming-supplies",
                    },
                    {
                        value: "823304",
                        label: "Feeding Supplies",
                        name_slug: "feeding-supplies",
                    },
                    {
                        value: "823432",
                        label: "Exercise Wheels",
                        name_slug: "exercise-wheels",
                    },
                    {
                        value: "823176",
                        label: "Collars, Harnesses & Leads",
                        name_slug: "collars-harnesses-leads",
                    },
                    {
                        value: "823688",
                        label: "Carriers",
                        name_slug: "carriers",
                    },
                ],
            },
            {
                value: "821000",
                label: "Reptile & Amphibian Supplies",
                name_slug: "reptile-amphibian-supplies",
                children: [
                    {
                        value: "821256",
                        label: "Terrariums & Shipping Supplies",
                        name_slug: "terrariums-shipping-supplies",
                    },
                    {
                        value: "821512",
                        label: "Temperature Products",
                        name_slug: "temperature-products",
                    },
                    {
                        value: "805392",
                        label: "Reptile Health Supplies",
                        name_slug: "reptile-health-supplies",
                    },
                    {
                        value: "982152",
                        label: "Reptile Food",
                        name_slug: "reptile-food",
                    },
                    {
                        value: "821640",
                        label: "Lighting",
                        name_slug: "lighting",
                    },
                    {
                        value: "821768",
                        label: "Feeding Tools",
                        name_slug: "feeding-tools",
                    },
                    {
                        value: "821128",
                        label: "Decorations",
                        name_slug: "decorations",
                    },
                    {
                        value: "821384",
                        label: "Cleaning Tools",
                        name_slug: "cleaning-tools",
                    },
                ],
            },
            {
                value: "2315152",
                label: "Pet",
                name_slug: "pet",
                children: [
                    {
                        value: "2316688",
                        label: "Small Animal",
                        name_slug: "small-animal",
                    },
                    {
                        value: "2316944",
                        label: "Fish & Aquatic Animal",
                        name_slug: "fish-aquatic-animal",
                    },
                    {
                        value: "2316816",
                        label: "Farm Animal & Poultry",
                        name_slug: "farm-animal-poultry",
                    },
                    {
                        value: "2316432",
                        label: "Dog",
                        name_slug: "dog",
                    },
                    {
                        value: "2317072",
                        label: "Cat",
                        name_slug: "cat",
                    },
                    {
                        value: "2316560",
                        label: "Birds",
                        name_slug: "birds",
                    },
                ],
            },
            {
                value: "819848",
                label: "Fish & Aquatic Supplies",
                name_slug: "fish-aquatic-supplies",
                children: [
                    {
                        value: "820488",
                        label: "Water Treatment",
                        name_slug: "water-treatment",
                    },
                    {
                        value: "820360",
                        label: "Temperature Control",
                        name_slug: "temperature-control",
                    },
                    {
                        value: "820616",
                        label: "Pumps & Filters",
                        name_slug: "pumps-filters",
                    },
                    {
                        value: "855568",
                        label: "Nutrition & Health Care Supplies",
                        name_slug: "nutrition-health-care-supplies",
                    },
                    {
                        value: "820104",
                        label: "Lighting",
                        name_slug: "lighting",
                    },
                    {
                        value: "820872",
                        label: "Feeding Tools",
                        name_slug: "feeding-tools",
                    },
                    {
                        value: "819976",
                        label: "Decorations",
                        name_slug: "decorations",
                    },
                    {
                        value: "820744",
                        label: "Cleaning Tools",
                        name_slug: "cleaning-tools",
                    },
                    {
                        value: "820232",
                        label: "Aquariums & Tanks",
                        name_slug: "aquariums-tanks",
                    },
                    {
                        value: "981896",
                        label: "Aquarium Pet Food",
                        name_slug: "aquarium-pet-food",
                    },
                    {
                        value: "602165",
                        label: "Aquarium Medications",
                        name_slug: "aquarium-medications",
                    },
                ],
            },
            {
                value: "1001992",
                label: "Farm Animal & Poultry Supplies",
                name_slug: "farm-animal-poultry-supplies",
                children: [
                    {
                        value: "1002248",
                        label: "Toys",
                        name_slug: "toys",
                    },
                    {
                        value: "1002120",
                        label: "Grooming Supplies",
                        name_slug: "grooming-supplies",
                    },
                    {
                        value: "1002760",
                        label: "Food",
                        name_slug: "food",
                    },
                    {
                        value: "1002376",
                        label: "Feeding Tools",
                        name_slug: "feeding-tools",
                    },
                    {
                        value: "805264",
                        label: "Farm Animal Health Supplies",
                        name_slug: "farm-animal-health-supplies",
                    },
                    {
                        value: "1002504",
                        label: "Ear Tags",
                        name_slug: "ear-tags",
                    },
                    {
                        value: "1003528",
                        label: "Carriers & Leads",
                        name_slug: "carriers-leads",
                    },
                    {
                        value: "1002632",
                        label: "Cages & Accessories",
                        name_slug: "cages-accessories",
                    },
                ],
            },
            {
                value: "815624",
                label: "Dog & Cat Litter",
                name_slug: "dog-cat-litter",
                children: [
                    {
                        value: "816264",
                        label: "Urine Detectors",
                        name_slug: "urine-detectors",
                    },
                    {
                        value: "805136",
                        label: "Toilet Training Systems",
                        name_slug: "toilet-training-systems",
                    },
                    {
                        value: "816008",
                        label: "Poop Bags & Scoopers",
                        name_slug: "poop-bags-scoopers",
                    },
                    {
                        value: "816136",
                        label: "Odor & Stain Removers",
                        name_slug: "odor-stain-removers",
                    },
                    {
                        value: "815752",
                        label: "Litter Trays & Boxes",
                        name_slug: "litter-trays-boxes",
                    },
                    {
                        value: "815880",
                        label: "Diapers, Pads & Trays",
                        name_slug: "diapers-pads-trays",
                    },
                ],
            },
            {
                value: "818184",
                label: "Dog & Cat Healthcare",
                name_slug: "dog-cat-healthcare",
                children: [
                    {
                        value: "818568",
                        label: "Vitamins & Supplements",
                        name_slug: "vitamins-supplements",
                    },
                    {
                        value: "804880",
                        label: "Recovery Collars & Support Braces",
                        name_slug: "recovery-collars-support-braces",
                    },
                    {
                        value: "818440",
                        label: "Medication",
                        name_slug: "medication",
                    },
                    {
                        value: "818312",
                        label: "Flea & Tick Treatments",
                        name_slug: "flea-tick-treatments",
                    },
                ],
            },
            {
                value: "816392",
                label: "Dog & Cat Grooming",
                name_slug: "dog-cat-grooming",
                children: [
                    {
                        value: "817416",
                        label: "Styptic Gels & Powders",
                        name_slug: "styptic-gels-powders",
                    },
                    {
                        value: "816520",
                        label: "Shampoos & Conditioners",
                        name_slug: "shampoos-conditioners",
                    },
                    {
                        value: "817800",
                        label: "Oral Care",
                        name_slug: "oral-care",
                    },
                    {
                        value: "818056",
                        label: "Hair Removal Products",
                        name_slug: "hair-removal-products",
                    },
                    {
                        value: "816904",
                        label: "Hair Dryers",
                        name_slug: "hair-dryers",
                    },
                    {
                        value: "817032",
                        label: "Grooming Wipes",
                        name_slug: "grooming-wipes",
                    },
                    {
                        value: "817160",
                        label: "Grooming Scissors",
                        name_slug: "grooming-scissors",
                    },
                    {
                        value: "817288",
                        label: "Grooming Clippers",
                        name_slug: "grooming-clippers",
                    },
                    {
                        value: "817928",
                        label: "Eye Care",
                        name_slug: "eye-care",
                    },
                    {
                        value: "817672",
                        label: "Ear Care",
                        name_slug: "ear-care",
                    },
                    {
                        value: "843280",
                        label: "Deodorizing Sprays & Colognes",
                        name_slug: "deodorizing-sprays-colognes",
                    },
                    {
                        value: "816776",
                        label: "Combs & Brushes",
                        name_slug: "combs-brushes",
                    },
                    {
                        value: "817544",
                        label: "Claw Care",
                        name_slug: "claw-care",
                    },
                    {
                        value: "816648",
                        label: "Bath Accessories",
                        name_slug: "bath-accessories",
                    },
                ],
            },
            {
                value: "812808",
                label: "Dog & Cat Furniture",
                name_slug: "dog-cat-furniture",
                children: [
                    {
                        value: "813704",
                        label: "Stairs & Ramps",
                        name_slug: "stairs-ramps",
                    },
                    {
                        value: "813320",
                        label: "Scratching Pads & Posts",
                        name_slug: "scratching-pads-posts",
                    },
                    {
                        value: "813832",
                        label: "Playpens",
                        name_slug: "playpens",
                    },
                    {
                        value: "813064",
                        label: "Houses",
                        name_slug: "houses",
                    },
                    {
                        value: "813448",
                        label: "Cat Hammocks",
                        name_slug: "cat-hammocks",
                    },
                    {
                        value: "813576",
                        label: "Cat & Dog Flaps",
                        name_slug: "cat-dog-flaps",
                    },
                    {
                        value: "813192",
                        label: "Cages & Crates",
                        name_slug: "cages-crates",
                    },
                    {
                        value: "812936",
                        label: "Beds, Sofas & Mats",
                        name_slug: "beds-sofas-mats",
                    },
                ],
            },
            {
                value: "812168",
                label: "Dog & Cat Food",
                name_slug: "dog-cat-food",
                children: [
                    {
                        value: "812424",
                        label: "Dog Treats",
                        name_slug: "dog-treats",
                    },
                    {
                        value: "812296",
                        label: "Dog Food",
                        name_slug: "dog-food",
                    },
                    {
                        value: "812680",
                        label: "Cat Treats",
                        name_slug: "cat-treats",
                    },
                    {
                        value: "812552",
                        label: "Cat Food",
                        name_slug: "cat-food",
                    },
                ],
            },
            {
                value: "813960",
                label: "Dog & Cat Clothing",
                name_slug: "dog-cat-clothing",
                children: [
                    {
                        value: "814344",
                        label: "Sweaters & Hoodies",
                        name_slug: "sweaters-hoodies",
                    },
                    {
                        value: "814216",
                        label: "Shirts & Vests",
                        name_slug: "shirts-vests",
                    },
                    {
                        value: "814728",
                        label: "Raincoats",
                        name_slug: "raincoats",
                    },
                    {
                        value: "814984",
                        label: "Neck Accessories",
                        name_slug: "neck-accessories",
                    },
                    {
                        value: "814472",
                        label: "Lifejackets",
                        name_slug: "lifejackets",
                    },
                    {
                        value: "815368",
                        label: "Hats",
                        name_slug: "hats",
                    },
                    {
                        value: "815240",
                        label: "Hair Accessories",
                        name_slug: "hair-accessories",
                    },
                    {
                        value: "815112",
                        label: "Eyewear",
                        name_slug: "eyewear",
                    },
                    {
                        value: "814600",
                        label: "Dresses",
                        name_slug: "dresses",
                    },
                    {
                        value: "815496",
                        label: "Costumes",
                        name_slug: "costumes",
                    },
                    {
                        value: "814088",
                        label: "Coats",
                        name_slug: "coats",
                    },
                    {
                        value: "814856",
                        label: "Boots & Paw Protectors",
                        name_slug: "boots-paw-protectors",
                    },
                ],
            },
            {
                value: "818696",
                label: "Dog & Cat Accessories",
                name_slug: "dog-cat-accessories",
                children: [
                    {
                        value: "818952",
                        label: "Training & Behavior Aids",
                        name_slug: "training-behavior-aids",
                    },
                    {
                        value: "819592",
                        label: "Memorials",
                        name_slug: "memorials",
                    },
                    {
                        value: "819336",
                        label: "Feeding Supplies",
                        name_slug: "feeding-supplies",
                    },
                    {
                        value: "819080",
                        label: "Dog Toys",
                        name_slug: "dog-toys",
                    },
                    {
                        value: "818824",
                        label: "Collars, Harnesses & Leads",
                        name_slug: "collars-harnesses-leads",
                    },
                    {
                        value: "819208",
                        label: "Cat Toys",
                        name_slug: "cat-toys",
                    },
                    {
                        value: "819464",
                        label: "Carriers & Travel Supplies",
                        name_slug: "carriers-travel-supplies",
                    },
                    {
                        value: "819720",
                        label: "Cameras & Monitors",
                        name_slug: "cameras-monitors",
                    },
                ],
            },
            {
                value: "821896",
                label: "Bird Supplies",
                name_slug: "bird-supplies",
                children: [
                    {
                        value: "822536",
                        label: "Training Aids",
                        name_slug: "training-aids",
                    },
                    {
                        value: "822408",
                        label: "Swings & Perches",
                        name_slug: "swings-perches",
                    },
                    {
                        value: "822152",
                        label: "Grooming Supplies",
                        name_slug: "grooming-supplies",
                    },
                    {
                        value: "822664",
                        label: "Feeding Tools",
                        name_slug: "feeding-tools",
                    },
                    {
                        value: "822024",
                        label: "Cages & Accessories",
                        name_slug: "cages-accessories",
                    },
                    {
                        value: "822280",
                        label: "Bird Toys",
                        name_slug: "bird-toys",
                    },
                    {
                        value: "805008",
                        label: "Bird Healthcare",
                        name_slug: "bird-healthcare",
                    },
                    {
                        value: "982024",
                        label: "Bird Food",
                        name_slug: "bird-food",
                    },
                ],
            },
        ],
    },
    {
        value: "600942",
        label: "Household Appliances",
        name_slug: "household-appliances",
        children: [
            {
                value: "2109200",
                label: "Refurbished Household Appliances",
                name_slug: "refurbished-household-appliances",
                children: [
                    {
                        value: "2159632",
                        label: "Refurbished Smart Home Systems",
                        name_slug: "refurbished-smart-home-systems",
                    },
                    {
                        value: "2159760",
                        label: "Refurbished Large Home Appliances",
                        name_slug: "refurbished-large-home-appliances",
                    },
                    {
                        value: "2159888",
                        label: "Refurbished Kitchen Appliances",
                        name_slug: "refurbished-kitchen-appliances",
                    },
                    {
                        value: "2160016",
                        label: "Refurbished Home Appliances",
                        name_slug: "refurbished-home-appliances",
                    },
                ],
            },
            {
                value: "845064",
                label: "Large Home Appliances",
                name_slug: "large-home-appliances",
                children: [
                    {
                        value: "850056",
                        label: "Water Heaters",
                        name_slug: "water-heaters",
                    },
                    {
                        value: "850184",
                        label: "Washing Machines & Dryers",
                        name_slug: "washing-machines-dryers",
                    },
                    {
                        value: "600852",
                        label: "Television",
                        name_slug: "television",
                    },
                    {
                        value: "852368",
                        label: "Streaming Media Devices",
                        name_slug: "streaming-media-devices",
                    },
                    {
                        value: "850312",
                        label: "Refrigerators & Freezers",
                        name_slug: "refrigerators-freezers",
                    },
                    {
                        value: "850440",
                        label: "Range Hoods",
                        name_slug: "range-hoods",
                    },
                    {
                        value: "852496",
                        label: "Portable Air Conditioners",
                        name_slug: "portable-air-conditioners",
                    },
                    {
                        value: "850568",
                        label: "Ovens, Ranges & Hobs",
                        name_slug: "ovens-ranges-hobs",
                    },
                    {
                        value: "850824",
                        label: "Large Appliance Parts & Accessories",
                        name_slug: "large-appliance-parts-accessories",
                    },
                    {
                        value: "850696",
                        label: "Dishwashers",
                        name_slug: "dishwashers",
                    },
                    {
                        value: "852624",
                        label: "Beverage Refrigerators",
                        name_slug: "beverage-refrigerators",
                    },
                    {
                        value: "849928",
                        label: "Air Conditioner",
                        name_slug: "air-conditioner",
                    },
                ],
            },
            {
                value: "844168",
                label: "Kitchen Appliances",
                name_slug: "kitchen-appliances",
                children: [
                    {
                        value: "934920",
                        label: "Water Filters",
                        name_slug: "water-filters",
                    },
                    {
                        value: "935048",
                        label: "Water Coolers & Dispensers",
                        name_slug: "water-coolers-dispensers",
                    },
                    {
                        value: "848008",
                        label: "Vacuum Sealers",
                        name_slug: "vacuum-sealers",
                    },
                    {
                        value: "847624",
                        label: "Toasters",
                        name_slug: "toasters",
                    },
                    {
                        value: "983304",
                        label: "Specialty Kitchen Appliances",
                        name_slug: "specialty-kitchen-appliances",
                    },
                    {
                        value: "880016",
                        label: "Soda Makers",
                        name_slug: "soda-makers",
                    },
                    {
                        value: "847752",
                        label: "Rice & Pressure Cookers",
                        name_slug: "rice-pressure-cookers",
                    },
                    {
                        value: "934792",
                        label: "Mixers",
                        name_slug: "mixers",
                    },
                    {
                        value: "848136",
                        label: "Microwave Ovens",
                        name_slug: "microwave-ovens",
                    },
                    {
                        value: "935432",
                        label: "Kitchen Appliance Parts",
                        name_slug: "kitchen-appliance-parts",
                    },
                    {
                        value: "848520",
                        label: "Juicers & Blenders",
                        name_slug: "juicers-blenders",
                    },
                    {
                        value: "977800",
                        label: "Induction Hobs",
                        name_slug: "induction-hobs",
                    },
                    {
                        value: "880400",
                        label: "Ice Makers",
                        name_slug: "ice-makers",
                    },
                    {
                        value: "935304",
                        label: "Fryers",
                        name_slug: "fryers",
                    },
                    {
                        value: "983944",
                        label: "Food Waste Disposers",
                        name_slug: "food-waste-disposers",
                    },
                    {
                        value: "935176",
                        label: "Food Processors",
                        name_slug: "food-processors",
                    },
                    {
                        value: "848392",
                        label: "Electric Kettles",
                        name_slug: "electric-kettles",
                    },
                    {
                        value: "978312",
                        label: "Electric Hot Pots",
                        name_slug: "electric-hot-pots",
                    },
                    {
                        value: "977928",
                        label: "Electric Grills",
                        name_slug: "electric-grills",
                    },
                    {
                        value: "847880",
                        label: "Electric Food Steamers",
                        name_slug: "electric-food-steamers",
                    },
                    {
                        value: "852240",
                        label: "Electric & Gas Stoves",
                        name_slug: "electric-gas-stoves",
                    },
                    {
                        value: "848264",
                        label: "Countertop Ovens",
                        name_slug: "countertop-ovens",
                    },
                    {
                        value: "934536",
                        label: "Coffee & Tea Machines & Accessories",
                        name_slug: "coffee-tea-machines-accessories",
                    },
                    {
                        value: "934664",
                        label: "Bread Makers",
                        name_slug: "bread-makers",
                    },
                ],
            },
            {
                value: "844808",
                label: "Home Appliances",
                name_slug: "home-appliances",
                children: [
                    {
                        value: "601102",
                        label: "Vacuums & Floor Care",
                        name_slug: "vacuums-floor-care",
                    },
                    {
                        value: "983560",
                        label: "Lint Removers",
                        name_slug: "lint-removers",
                    },
                    {
                        value: "601100",
                        label: "Irons",
                        name_slug: "irons",
                    },
                    {
                        value: "601092",
                        label: "Humidifiers",
                        name_slug: "humidifiers",
                    },
                    {
                        value: "601106",
                        label: "Household Appliance Parts & Accessories",
                        name_slug: "household-appliance-parts-accessories",
                    },
                    {
                        value: "984456",
                        label: "Home Sterilizers",
                        name_slug: "home-sterilizers",
                    },
                    {
                        value: "601095",
                        label: "Heaters",
                        name_slug: "heaters",
                    },
                    {
                        value: "984072",
                        label: "Hand Dryers",
                        name_slug: "hand-dryers",
                    },
                    {
                        value: "601104",
                        label: "Fans",
                        name_slug: "fans",
                    },
                    {
                        value: "934408",
                        label: "Electronic Mosquito Killers",
                        name_slug: "electronic-mosquito-killers",
                    },
                    {
                        value: "601116",
                        label: "Electric Window Cleaners",
                        name_slug: "electric-window-cleaners",
                    },
                    {
                        value: "801040",
                        label: "Electric Spin Scrubbers",
                        name_slug: "electric-spin-scrubbers",
                    },
                    {
                        value: "990984",
                        label: "Electric Shoe Polishers",
                        name_slug: "electric-shoe-polishers",
                    },
                    {
                        value: "934152",
                        label: "Electric Mops",
                        name_slug: "electric-mops",
                    },
                    {
                        value: "983432",
                        label: "Electric Blankets",
                        name_slug: "electric-blankets",
                    },
                    {
                        value: "601108",
                        label: "Dehumidifiers",
                        name_slug: "dehumidifiers",
                    },
                    {
                        value: "601107",
                        label: "Clothes Steamers",
                        name_slug: "clothes-steamers",
                    },
                    {
                        value: "934280",
                        label: "Clothes & Shoe Dryers",
                        name_slug: "clothes-shoe-dryers",
                    },
                    {
                        value: "979080",
                        label: "Answering Machines",
                        name_slug: "answering-machines",
                    },
                    {
                        value: "601090",
                        label: "Air Purifiers",
                        name_slug: "air-purifiers",
                    },
                    {
                        value: "880656",
                        label: "Air Cooler",
                        name_slug: "air-cooler",
                    },
                ],
            },
            {
                value: "845320",
                label: "Commercial Appliances",
                name_slug: "commercial-appliances",
                children: [
                    {
                        value: "851464",
                        label: "Refrigeration Equipment",
                        name_slug: "refrigeration-equipment",
                    },
                    {
                        value: "850952",
                        label: "Laundry Equipment",
                        name_slug: "laundry-equipment",
                    },
                    {
                        value: "2318224",
                        label: "Food Warmer",
                        name_slug: "food-warmer",
                    },
                    {
                        value: "851592",
                        label: "Food Processing Equipment",
                        name_slug: "food-processing-equipment",
                    },
                    {
                        value: "851336",
                        label: "Fan & Exhaust Equipment",
                        name_slug: "fan-exhaust-equipment",
                    },
                    {
                        value: "851208",
                        label: "Commercial Stoves",
                        name_slug: "commercial-stoves",
                    },
                    {
                        value: "851720",
                        label: "Commercial Appliance Parts",
                        name_slug: "commercial-appliance-parts",
                    },
                    {
                        value: "851080",
                        label: "Cleaning Equipment",
                        name_slug: "cleaning-equipment",
                    },
                ],
            },
        ],
    },
    {
        value: "600154",
        label: "Textiles & Soft Furnishings",
        name_slug: "textiles-soft-furnishings",
        children: [
            {
                value: "809992",
                label: "Household Textiles",
                name_slug: "household-textiles",
                children: [
                    {
                        value: "810376",
                        label: "Sofa Covers",
                        name_slug: "sofa-covers",
                    },
                    {
                        value: "600204",
                        label: "Kitchen Linens",
                        name_slug: "kitchen-linens",
                    },
                    {
                        value: "2149520",
                        label: "Inflatable Beds, Pillows & Accessories",
                        name_slug: "inflatable-beds-pillows-accessories",
                    },
                    {
                        value: "2149648",
                        label: "Dust cover & Fabric storage",
                        name_slug: "dust-cover-fabric-storage",
                    },
                    {
                        value: "700661",
                        label: "Cushions & Accessories",
                        name_slug: "cushions-accessories",
                    },
                    {
                        value: "810504",
                        label: "Curtain & Blind Accessories",
                        name_slug: "curtain-blind-accessories",
                    },
                    {
                        value: "600203",
                        label: "Chair Covers",
                        name_slug: "chair-covers",
                    },
                    {
                        value: "600221",
                        label: "Carpets & Rugs",
                        name_slug: "carpets-rugs",
                    },
                ],
            },
            {
                value: "811016",
                label: "Fabrics & Sewing Supplies",
                name_slug: "fabrics-sewing-supplies",
                children: [
                    {
                        value: "811784",
                        label: "Thread",
                        name_slug: "thread",
                    },
                    {
                        value: "811144",
                        label: "Textiles & Fabrics",
                        name_slug: "textiles-fabrics",
                    },
                    {
                        value: "600252",
                        label: "Sewing Tool Kits",
                        name_slug: "sewing-tool-kits",
                    },
                    {
                        value: "811656",
                        label: "Sewing Machines",
                        name_slug: "sewing-machines",
                    },
                    {
                        value: "600251",
                        label: "Sewing Craft Kits",
                        name_slug: "sewing-craft-kits",
                    },
                    {
                        value: "811528",
                        label: "Sewing Accessories & Haberdashery",
                        name_slug: "sewing-accessories-haberdashery",
                    },
                    {
                        value: "811912",
                        label: "Needles",
                        name_slug: "needles",
                    },
                    {
                        value: "2149776",
                        label: "Knitting",
                        name_slug: "knitting",
                    },
                    {
                        value: "2149904",
                        label: "Felt & sets",
                        name_slug: "felt-sets",
                    },
                    {
                        value: "2150032",
                        label: "Embroidery & sets",
                        name_slug: "embroidery-sets",
                    },
                    {
                        value: "2150160",
                        label: "Crochet",
                        name_slug: "crochet",
                    },
                ],
            },
            {
                value: "808328",
                label: "Bedding and Linens",
                name_slug: "bedding-and-linens",
                children: [
                    {
                        value: "600165",
                        label: "Sheets & Pillowcases",
                        name_slug: "sheets-pillowcases",
                    },
                    {
                        value: "700652",
                        label: "Quilts",
                        name_slug: "quilts",
                    },
                    {
                        value: "700653",
                        label: "Pillows & Bed Wedges",
                        name_slug: "pillows-bed-wedges",
                    },
                    {
                        value: "809736",
                        label: "Mosquito Nets",
                        name_slug: "mosquito-nets",
                    },
                    {
                        value: "809480",
                        label: "Mattress & Mattress Pads/ Toppers/Protectors",
                        name_slug: "mattress-mattress-pads-toppersprotectors",
                    },
                    {
                        value: "808840",
                        label: "Duvets & Sets",
                        name_slug: "duvets-sets",
                    },
                    {
                        value: "809608",
                        label: "Duvet Covers & Sets",
                        name_slug: "duvet-covers-sets",
                    },
                    {
                        value: "994952",
                        label: "Cooling Mats & Pads",
                        name_slug: "cooling-mats-pads",
                    },
                    {
                        value: "809864",
                        label: "Childrens' Bedding",
                        name_slug: "childrens-bedding",
                    },
                    {
                        value: "600157",
                        label: "Blankets & Throws",
                        name_slug: "blankets-throws",
                    },
                    {
                        value: "809096",
                        label: "Bedspreads & Coverlets",
                        name_slug: "bedspreads-coverlets",
                    },
                    {
                        value: "808584",
                        label: "Bedding Sets Collections",
                        name_slug: "bedding-sets-collections",
                    },
                    {
                        value: "807184",
                        label: "Bedding Accessories",
                        name_slug: "bedding-accessories",
                    },
                    {
                        value: "809352",
                        label: "Bed Skirts",
                        name_slug: "bed-skirts",
                    },
                ],
            },
        ],
    },
    {
        value: "604968",
        label: "Home Improvement",
        name_slug: "home-improvement",
        children: [
            {
                value: "808208",
                label: "Solar & Wind Power",
                name_slug: "solar-wind-power",
                children: [
                    {
                        value: "808848",
                        label: "Wind Turbines",
                        name_slug: "wind-turbines",
                    },
                    {
                        value: "808720",
                        label: "Solar Power Systems",
                        name_slug: "solar-power-systems",
                    },
                    {
                        value: "808464",
                        label: "Solar Panels",
                        name_slug: "solar-panels",
                    },
                    {
                        value: "808336",
                        label: "Power Inverters",
                        name_slug: "power-inverters",
                    },
                    {
                        value: "808592",
                        label: "Charge Controllers & Accessories",
                        name_slug: "charge-controllers-accessories",
                    },
                ],
            },
            {
                value: "872840",
                label: "Smart Home Systems",
                name_slug: "smart-home-systems",
                children: [
                    {
                        value: "896520",
                        label: "Temperature Control Systems",
                        name_slug: "temperature-control-systems",
                    },
                    {
                        value: "896776",
                        label: "Smart Motion Sensors",
                        name_slug: "smart-motion-sensors",
                    },
                    {
                        value: "896392",
                        label: "Smart Home Controls",
                        name_slug: "smart-home-controls",
                    },
                    {
                        value: "896648",
                        label: "Automatic Curtain Control Systems",
                        name_slug: "automatic-curtain-control-systems",
                    },
                ],
            },
            {
                value: "873224",
                label: "Security & Safety",
                name_slug: "security-safety",
                children: [
                    {
                        value: "899208",
                        label: "Work Safety Equipment",
                        name_slug: "work-safety-equipment",
                    },
                    {
                        value: "898952",
                        label: "Security Alarms",
                        name_slug: "security-alarms",
                    },
                    {
                        value: "899464",
                        label: "Emergency Kits",
                        name_slug: "emergency-kits",
                    },
                    {
                        value: "899080",
                        label: "Doorbells & Intercoms",
                        name_slug: "doorbells-intercoms",
                    },
                ],
            },
            {
                value: "872456",
                label: "Lights & Lighting",
                name_slug: "lights-lighting",
                children: [
                    {
                        value: "894344",
                        label: "Professional Lighting",
                        name_slug: "professional-lighting",
                    },
                    {
                        value: "893960",
                        label: "Portable Lighting",
                        name_slug: "portable-lighting",
                    },
                    {
                        value: "894088",
                        label: "Outdoor Lighting",
                        name_slug: "outdoor-lighting",
                    },
                    {
                        value: "894216",
                        label: "Novelty Lighting",
                        name_slug: "novelty-lighting",
                    },
                    {
                        value: "893576",
                        label: "Lighting Accessories",
                        name_slug: "lighting-accessories",
                    },
                    {
                        value: "893832",
                        label: "Indoor Lighting",
                        name_slug: "indoor-lighting",
                    },
                    {
                        value: "894472",
                        label: "Commercial Lighting",
                        name_slug: "commercial-lighting",
                    },
                    {
                        value: "893704",
                        label: "Bulbs, Tubes & Strips",
                        name_slug: "bulbs-tubes-strips",
                    },
                ],
            },
            {
                value: "872712",
                label: "Kitchen Fixtures",
                name_slug: "kitchen-fixtures",
                children: [
                    {
                        value: "896008",
                        label: "Water Filtration Devices",
                        name_slug: "water-filtration-devices",
                    },
                    {
                        value: "895624",
                        label: "Kitchen Taps",
                        name_slug: "kitchen-taps",
                    },
                    {
                        value: "895752",
                        label: "Kitchen Sinks",
                        name_slug: "kitchen-sinks",
                    },
                    {
                        value: "896264",
                        label: "Kitchen Fixture Sets",
                        name_slug: "kitchen-fixture-sets",
                    },
                    {
                        value: "896136",
                        label: "Kitchen Fixture Accessories",
                        name_slug: "kitchen-fixture-accessories",
                    },
                    {
                        value: "895880",
                        label: "Kitchen Cabinets",
                        name_slug: "kitchen-cabinets",
                    },
                ],
            },
            {
                value: "873352",
                label: "Garden Supplies",
                name_slug: "garden-supplies",
                children: [
                    {
                        value: "900104",
                        label: "Watering & Irrigation",
                        name_slug: "watering-irrigation",
                    },
                    {
                        value: "802960",
                        label: "Raised Beds",
                        name_slug: "raised-beds",
                    },
                    {
                        value: "802704",
                        label: "Pools, Hot Tubs & Supplies",
                        name_slug: "pools-hot-tubs-supplies",
                    },
                    {
                        value: "899720",
                        label: "Plant Care & Support",
                        name_slug: "plant-care-support",
                    },
                    {
                        value: "899848",
                        label: "Pest Control",
                        name_slug: "pest-control",
                    },
                    {
                        value: "802576",
                        label: "Patio Heaters & Fire Pits",
                        name_slug: "patio-heaters-fire-pits",
                    },
                    {
                        value: "853776",
                        label: "Live Plants",
                        name_slug: "live-plants",
                    },
                    {
                        value: "803088",
                        label: "Greenhouses & Seed Starters",
                        name_slug: "greenhouses-seed-starters",
                    },
                    {
                        value: "980232",
                        label: "Garden Soil",
                        name_slug: "garden-soil",
                    },
                    {
                        value: "900232",
                        label: "Garden Pots & Planters",
                        name_slug: "garden-pots-planters",
                    },
                    {
                        value: "899976",
                        label: "Garden Decor",
                        name_slug: "garden-decor",
                    },
                    {
                        value: "900360",
                        label: "Garden Buildings",
                        name_slug: "garden-buildings",
                    },
                    {
                        value: "883984",
                        label: "Fresh Flowers",
                        name_slug: "fresh-flowers",
                    },
                    {
                        value: "979976",
                        label: "Flower & Plant Seeds",
                        name_slug: "flower-plant-seeds",
                    },
                    {
                        value: "899592",
                        label: "Beekeeping Supplies",
                        name_slug: "beekeeping-supplies",
                    },
                ],
            },
            {
                value: "872584",
                label: "Electrical Equipment & Supplies",
                name_slug: "electrical-equipment-supplies",
                children: [
                    {
                        value: "895368",
                        label: "Wires & Cables",
                        name_slug: "wires-cables",
                    },
                    {
                        value: "895496",
                        label: "Transformers",
                        name_slug: "transformers",
                    },
                    {
                        value: "894728",
                        label: "Switches & Accessories",
                        name_slug: "switches-accessories",
                    },
                    {
                        value: "894856",
                        label: "Relays & Breakers",
                        name_slug: "relays-breakers",
                    },
                    {
                        value: "894984",
                        label: "Power Supplies",
                        name_slug: "power-supplies",
                    },
                    {
                        value: "983176",
                        label: "Power Savers",
                        name_slug: "power-savers",
                    },
                    {
                        value: "895112",
                        label: "Motors, Generators & Accessories",
                        name_slug: "motors-generators-accessories",
                    },
                    {
                        value: "895240",
                        label: "Electrical Sockets & Accessories",
                        name_slug: "electrical-sockets-accessories",
                    },
                    {
                        value: "2318736",
                        label: "Electrical Components",
                        name_slug: "electrical-components",
                    },
                    {
                        value: "894600",
                        label: "Connectors & Terminals",
                        name_slug: "connectors-terminals",
                    },
                ],
            },
            {
                value: "872968",
                label: "Building Supplies",
                name_slug: "building-supplies",
                children: [
                    {
                        value: "802832",
                        label: "Wallpaper Tools",
                        name_slug: "wallpaper-tools",
                    },
                    {
                        value: "897160",
                        label: "Wallpaper & Wall Trim",
                        name_slug: "wallpaper-wall-trim",
                    },
                    {
                        value: "853904",
                        label: "Wall Paint",
                        name_slug: "wall-paint",
                    },
                    {
                        value: "897672",
                        label: "Trollies",
                        name_slug: "trollies",
                    },
                    {
                        value: "897416",
                        label: "Roofing & Flooring",
                        name_slug: "roofing-flooring",
                    },
                    {
                        value: "897288",
                        label: "Paint Supplies & Tools",
                        name_slug: "paint-supplies-tools",
                    },
                    {
                        value: "897544",
                        label: "Ladders",
                        name_slug: "ladders",
                    },
                    {
                        value: "896904",
                        label: "Heating, Cooling & Ventilation",
                        name_slug: "heating-cooling-ventilation",
                    },
                    {
                        value: "897032",
                        label: "Doors, Gates & Windows",
                        name_slug: "doors-gates-windows",
                    },
                    {
                        value: "2317200",
                        label: "Building Material",
                        name_slug: "building-material",
                    },
                ],
            },
            {
                value: "873096",
                label: "Bathroom Fixtures",
                name_slug: "bathroom-fixtures",
                children: [
                    {
                        value: "898440",
                        label: "Toilets & Toilet Parts",
                        name_slug: "toilets-toilet-parts",
                    },
                    {
                        value: "897800",
                        label: "Shower Equipment",
                        name_slug: "shower-equipment",
                    },
                    {
                        value: "897928",
                        label: "Hooks & Bars",
                        name_slug: "hooks-bars",
                    },
                    {
                        value: "898312",
                        label: "Bidets & Bidet Parts",
                        name_slug: "bidets-bidet-parts",
                    },
                    {
                        value: "979336",
                        label: "Bathtubs",
                        name_slug: "bathtubs",
                    },
                    {
                        value: "898184",
                        label: "Bathroom Taps",
                        name_slug: "bathroom-taps",
                    },
                    {
                        value: "898056",
                        label: "Bathroom Sinks",
                        name_slug: "bathroom-sinks",
                    },
                    {
                        value: "979464",
                        label: "Bathroom Safety Bars & Seats",
                        name_slug: "bathroom-safety-bars-seats",
                    },
                    {
                        value: "898568",
                        label: "Bathroom Mirrors",
                        name_slug: "bathroom-mirrors",
                    },
                    {
                        value: "898824",
                        label: "Bathroom Fixture Sets",
                        name_slug: "bathroom-fixture-sets",
                    },
                    {
                        value: "898696",
                        label: "Bathroom Fixture Accessories",
                        name_slug: "bathroom-fixture-accessories",
                    },
                ],
            },
        ],
    },
    {
        value: "604579",
        label: "Tools & Hardware",
        name_slug: "tools-hardware",
        children: [
            {
                value: "872200",
                label: "Tool Organizers",
                name_slug: "tool-organizers",
                children: [
                    {
                        value: "887176",
                        label: "Tool Racks & Bars",
                        name_slug: "tool-racks-bars",
                    },
                    {
                        value: "887048",
                        label: "Tool Cases & Boxes",
                        name_slug: "tool-cases-boxes",
                    },
                    {
                        value: "886920",
                        label: "Tool Bags",
                        name_slug: "tool-bags",
                    },
                ],
            },
            {
                value: "872072",
                label: "Soldering Equipment",
                name_slug: "soldering-equipment",
                children: [
                    {
                        value: "886792",
                        label: "Welding Accessories",
                        name_slug: "welding-accessories",
                    },
                    {
                        value: "886664",
                        label: "Welders",
                        name_slug: "welders",
                    },
                    {
                        value: "886536",
                        label: "Soldering Stations",
                        name_slug: "soldering-stations",
                    },
                    {
                        value: "886408",
                        label: "Electric Soldering Irons",
                        name_slug: "electric-soldering-irons",
                    },
                ],
            },
            {
                value: "980488",
                label: "Pumps & Plumbing",
                name_slug: "pumps-plumbing",
                children: [
                    {
                        value: "982792",
                        label: "Valves & Parts",
                        name_slug: "valves-parts",
                    },
                    {
                        value: "982536",
                        label: "Pumps, Parts & Accessories",
                        name_slug: "pumps-parts-accessories",
                    },
                    {
                        value: "982664",
                        label: "Pipes & Fittings",
                        name_slug: "pipes-fittings",
                    },
                ],
            },
            {
                value: "871560",
                label: "Power Tools",
                name_slug: "power-tools",
                children: [
                    {
                        value: "994056",
                        label: "Wood Routers",
                        name_slug: "wood-routers",
                    },
                    {
                        value: "882568",
                        label: "Spray Guns",
                        name_slug: "spray-guns",
                    },
                    {
                        value: "801296",
                        label: "Specialty Power Tools",
                        name_slug: "specialty-power-tools",
                    },
                    {
                        value: "980360",
                        label: "Pressure Washers",
                        name_slug: "pressure-washers",
                    },
                    {
                        value: "883080",
                        label: "Power Tool Sets",
                        name_slug: "power-tool-sets",
                    },
                    {
                        value: "882952",
                        label: "Power Tool Accessories",
                        name_slug: "power-tool-accessories",
                    },
                    {
                        value: "882184",
                        label: "Polishers",
                        name_slug: "polishers",
                    },
                    {
                        value: "882440",
                        label: "Nail Guns",
                        name_slug: "nail-guns",
                    },
                    {
                        value: "882696",
                        label: "Heat Guns",
                        name_slug: "heat-guns",
                    },
                    {
                        value: "882824",
                        label: "Glue Guns",
                        name_slug: "glue-guns",
                    },
                    {
                        value: "882312",
                        label: "Electric Wrenches",
                        name_slug: "electric-wrenches",
                    },
                    {
                        value: "881672",
                        label: "Electric Screwdrivers",
                        name_slug: "electric-screwdrivers",
                    },
                    {
                        value: "881800",
                        label: "Electric Saws",
                        name_slug: "electric-saws",
                    },
                    {
                        value: "881544",
                        label: "Electric Drills",
                        name_slug: "electric-drills",
                    },
                    {
                        value: "881928",
                        label: "Blowers",
                        name_slug: "blowers",
                    },
                    {
                        value: "882056",
                        label: "Angle Grinders",
                        name_slug: "angle-grinders",
                    },
                    {
                        value: "980616",
                        label: "Air Compressors",
                        name_slug: "air-compressors",
                    },
                ],
            },
            {
                value: "871816",
                label: "Measuring Tools",
                name_slug: "measuring-tools",
                children: [
                    {
                        value: "884872",
                        label: "Temperature Measuring Instruments",
                        name_slug: "temperature-measuring-instruments",
                    },
                    {
                        value: "884744",
                        label: "Pressure Measuring Instruments",
                        name_slug: "pressure-measuring-instruments",
                    },
                    {
                        value: "885128",
                        label: "Physical Measuring Instruments",
                        name_slug: "physical-measuring-instruments",
                    },
                    {
                        value: "884616",
                        label: "Optical Instruments",
                        name_slug: "optical-instruments",
                    },
                    {
                        value: "885000",
                        label: "Hand Measuring Tools",
                        name_slug: "hand-measuring-tools",
                    },
                    {
                        value: "885256",
                        label: "Electrical Measuring Instruments",
                        name_slug: "electrical-measuring-instruments",
                    },
                ],
            },
            {
                value: "2315280",
                label: "Industrial Automation",
                name_slug: "industrial-automation",
                children: [
                    {
                        value: "2317968",
                        label: "Switched-Mode Power Supply (SMPS)",
                        name_slug: "switched-mode-power-supply-smps",
                    },
                    {
                        value: "2317840",
                        label: "Push Button",
                        name_slug: "push-button",
                    },
                    {
                        value: "2317712",
                        label: "Programmable Logic Controllers (PLC)",
                        name_slug: "programmable-logic-controllers-plc",
                    },
                    {
                        value: "2323728",
                        label: "Pilot Light",
                        name_slug: "pilot-light",
                    },
                    {
                        value: "2317584",
                        label: "Human Machine Interface",
                        name_slug: "human-machine-interface",
                    },
                    {
                        value: "2317456",
                        label: "Gas Sensor",
                        name_slug: "gas-sensor",
                    },
                    {
                        value: "2317328",
                        label: "Encoder",
                        name_slug: "encoder",
                    },
                    {
                        value: "2323856",
                        label: "Contactor",
                        name_slug: "contactor",
                    },
                    {
                        value: "2323984",
                        label: "Capacitor",
                        name_slug: "capacitor",
                    },
                ],
            },
            {
                value: "872328",
                label: "Hardware",
                name_slug: "hardware",
                children: [
                    {
                        value: "887432",
                        label: "Window Hardware",
                        name_slug: "window-hardware",
                    },
                    {
                        value: "887944",
                        label: "Ropes, Chains & Pulleys",
                        name_slug: "ropes-chains-pulleys",
                    },
                    {
                        value: "888072",
                        label: "Padlocks & Hasps",
                        name_slug: "padlocks-hasps",
                    },
                    {
                        value: "887688",
                        label: "Mechanical Hardware",
                        name_slug: "mechanical-hardware",
                    },
                    {
                        value: "993928",
                        label: "Magnets",
                        name_slug: "magnets",
                    },
                    {
                        value: "887304",
                        label: "Furniture Hardware",
                        name_slug: "furniture-hardware",
                    },
                    {
                        value: "887816",
                        label: "Fasteners & Hooks",
                        name_slug: "fasteners-hooks",
                    },
                    {
                        value: "887560",
                        label: "Door Hardware",
                        name_slug: "door-hardware",
                    },
                    {
                        value: "888328",
                        label: "Clamps",
                        name_slug: "clamps",
                    },
                    {
                        value: "888200",
                        label: "Adhesives, Tapes & Sealers",
                        name_slug: "adhesives-tapes-sealers",
                    },
                    {
                        value: "983048",
                        label: "Abrasive & Finishing Products",
                        name_slug: "abrasive-finishing-products",
                    },
                ],
            },
            {
                value: "871688",
                label: "Hand Tools",
                name_slug: "hand-tools",
                children: [
                    {
                        value: "884104",
                        label: "Wrenches",
                        name_slug: "wrenches",
                    },
                    {
                        value: "981000",
                        label: "Watch Repair Tools",
                        name_slug: "watch-repair-tools",
                    },
                    {
                        value: "884488",
                        label: "Tool Kits",
                        name_slug: "tool-kits",
                    },
                    {
                        value: "802448",
                        label: "Specialty Hand Tools",
                        name_slug: "specialty-hand-tools",
                    },
                    {
                        value: "883976",
                        label: "Screwdrivers",
                        name_slug: "screwdrivers",
                    },
                    {
                        value: "883848",
                        label: "Scissors",
                        name_slug: "scissors",
                    },
                    {
                        value: "883720",
                        label: "Saws",
                        name_slug: "saws",
                    },
                    {
                        value: "883592",
                        label: "Pliers",
                        name_slug: "pliers",
                    },
                    {
                        value: "802064",
                        label: "Multitools & Accessories",
                        name_slug: "multitools-accessories",
                    },
                    {
                        value: "802320",
                        label: "Masonry & Tiling Tools",
                        name_slug: "masonry-tiling-tools",
                    },
                    {
                        value: "883464",
                        label: "Knives",
                        name_slug: "knives",
                    },
                    {
                        value: "883208",
                        label: "Industrial Tweezers",
                        name_slug: "industrial-tweezers",
                    },
                    {
                        value: "980872",
                        label: "Industrial Scales",
                        name_slug: "industrial-scales",
                    },
                    {
                        value: "980744",
                        label: "Hand Tool Accessories",
                        name_slug: "hand-tool-accessories",
                    },
                    {
                        value: "801168",
                        label: "Hand Riveters",
                        name_slug: "hand-riveters",
                    },
                    {
                        value: "883336",
                        label: "Hammers",
                        name_slug: "hammers",
                    },
                    {
                        value: "802192",
                        label: "Cutting Tools",
                        name_slug: "cutting-tools",
                    },
                    {
                        value: "884232",
                        label: "Chisels",
                        name_slug: "chisels",
                    },
                    {
                        value: "884360",
                        label: "Axes",
                        name_slug: "axes",
                    },
                ],
            },
            {
                value: "871944",
                label: "Garden Tools",
                name_slug: "garden-tools",
                children: [
                    {
                        value: "801424",
                        label: "Specialty Garden Tools",
                        name_slug: "specialty-garden-tools",
                    },
                    {
                        value: "885640",
                        label: "Spades & Shovels",
                        name_slug: "spades-shovels",
                    },
                    {
                        value: "801808",
                        label: "Snow Removal Tools",
                        name_slug: "snow-removal-tools",
                    },
                    {
                        value: "885768",
                        label: "Pruning Tools",
                        name_slug: "pruning-tools",
                    },
                    {
                        value: "801552",
                        label: "Metal Detectors",
                        name_slug: "metal-detectors",
                    },
                    {
                        value: "885512",
                        label: "Leaf Blowers & Vacuums",
                        name_slug: "leaf-blowers-vacuums",
                    },
                    {
                        value: "979848",
                        label: "Lawn Mowers",
                        name_slug: "lawn-mowers",
                    },
                    {
                        value: "885896",
                        label: "Hoes & Rakes",
                        name_slug: "hoes-rakes",
                    },
                    {
                        value: "885384",
                        label: "Grass Trimmers",
                        name_slug: "grass-trimmers",
                    },
                    {
                        value: "801936",
                        label: "Gardening Tool Accessories",
                        name_slug: "gardening-tool-accessories",
                    },
                    {
                        value: "886152",
                        label: "Gardening Gloves & Protective Gear",
                        name_slug: "gardening-gloves-protective-gear",
                    },
                    {
                        value: "886280",
                        label: "Garden Cleaning Tools",
                        name_slug: "garden-cleaning-tools",
                    },
                    {
                        value: "886024",
                        label: "Forks & Scoops",
                        name_slug: "forks-scoops",
                    },
                    {
                        value: "801680",
                        label: "Chainsaws",
                        name_slug: "chainsaws",
                    },
                ],
            },
        ],
    },
    {
        value: "801928",
        label: "Books, Magazines & Audio",
        name_slug: "books-magazines-audio",
        children: [
            {
                value: "997384",
                label: "Video & Music",
                name_slug: "video-music",
                children: [
                    {
                        value: "997768",
                        label: "Vinyl",
                        name_slug: "vinyl",
                    },
                    {
                        value: "2344976",
                        label: "VHS",
                        name_slug: "vhs",
                    },
                    {
                        value: "2344848",
                        label: "DVDs",
                        name_slug: "dvds",
                    },
                    {
                        value: "997512",
                        label: "Cassette Tapes",
                        name_slug: "cassette-tapes",
                    },
                    {
                        value: "997640",
                        label: "CDs",
                        name_slug: "cds",
                    },
                ],
            },
            {
                value: "990216",
                label: "Science & Technology",
                name_slug: "science-technology",
                children: [
                    {
                        value: "927880",
                        label: "Natural Sciences",
                        name_slug: "natural-sciences",
                    },
                    {
                        value: "928904",
                        label: "Medical",
                        name_slug: "medical",
                    },
                    {
                        value: "991240",
                        label: "Industrial Technology",
                        name_slug: "industrial-technology",
                    },
                    {
                        value: "929544",
                        label: "Computers & Networking",
                        name_slug: "computers-networking",
                    },
                    {
                        value: "990856",
                        label: "Architecture",
                        name_slug: "architecture",
                    },
                    {
                        value: "991112",
                        label: "Agriculture, Forestry & Fishery",
                        name_slug: "agriculture-forestry-fishery",
                    },
                ],
            },
            {
                value: "985736",
                label: "Magazines & Newspapers",
                name_slug: "magazines-newspapers",
                children: [
                    {
                        value: "986632",
                        label: "Teenager",
                        name_slug: "teenager",
                    },
                    {
                        value: "986120",
                        label: "Lifestyle",
                        name_slug: "lifestyle",
                    },
                    {
                        value: "986376",
                        label: "Fashion",
                        name_slug: "fashion",
                    },
                    {
                        value: "985864",
                        label: "Business",
                        name_slug: "business",
                    },
                ],
            },
            {
                value: "986760",
                label: "Literature & Art",
                name_slug: "literature-art",
                children: [
                    {
                        value: "926344",
                        label: "Photography & Video",
                        name_slug: "photography-video",
                    },
                    {
                        value: "987144",
                        label: "Performing Arts",
                        name_slug: "performing-arts",
                    },
                    {
                        value: "989192",
                        label: "Painting & Design",
                        name_slug: "painting-design",
                    },
                    {
                        value: "987016",
                        label: "Novel",
                        name_slug: "novel",
                    },
                    {
                        value: "987400",
                        label: "Music",
                        name_slug: "music",
                    },
                    {
                        value: "926856",
                        label: "Literature",
                        name_slug: "literature",
                    },
                    {
                        value: "989064",
                        label: "Film & Television Arts",
                        name_slug: "film-television-arts",
                    },
                    {
                        value: "926472",
                        label: "Biographies & Memoirs",
                        name_slug: "biographies-memoirs",
                    },
                ],
            },
            {
                value: "992392",
                label: "Lifestyle & Hobbies",
                name_slug: "lifestyle-hobbies",
                children: [
                    {
                        value: "929032",
                        label: "Travel & Maps",
                        name_slug: "travel-maps",
                    },
                    {
                        value: "992776",
                        label: "Sports & Fitness",
                        name_slug: "sports-fitness",
                    },
                    {
                        value: "928392",
                        label: "Recipes & Cooking",
                        name_slug: "recipes-cooking",
                    },
                    {
                        value: "992648",
                        label: "Maternity & Antenatal Education",
                        name_slug: "maternity-antenatal-education",
                    },
                    {
                        value: "929416",
                        label: "Horoscopes",
                        name_slug: "horoscopes",
                    },
                    {
                        value: "928648",
                        label: "Health, Fitness & Dieting",
                        name_slug: "health-fitness-dieting",
                    },
                    {
                        value: "2318352",
                        label: "Game & Entertainment",
                        name_slug: "game-entertainment",
                    },
                    {
                        value: "992520",
                        label: "Fashion & Beauty",
                        name_slug: "fashion-beauty",
                    },
                    {
                        value: "928520",
                        label: "Crafts & DIY",
                        name_slug: "crafts-diy",
                    },
                    {
                        value: "929288",
                        label: "Comics & Manga",
                        name_slug: "comics-manga",
                    },
                    {
                        value: "2318096",
                        label: "Automotive",
                        name_slug: "automotive",
                    },
                ],
            },
            {
                value: "927112",
                label: "Humanities & Social Sciences",
                name_slug: "humanities-social-sciences",
                children: [
                    {
                        value: "927624",
                        label: "Religion & Philosophy",
                        name_slug: "religion-philosophy",
                    },
                    {
                        value: "927496",
                        label: "Psychology & Relationships",
                        name_slug: "psychology-relationships",
                    },
                    {
                        value: "927752",
                        label: "Politics, Law & Social Sciences",
                        name_slug: "politics-law-social-sciences",
                    },
                    {
                        value: "928264",
                        label: "Parenting & Family",
                        name_slug: "parenting-family",
                    },
                    {
                        value: "928008",
                        label: "History & Culture",
                        name_slug: "history-culture",
                    },
                    {
                        value: "928136",
                        label: "Career & Self-Help",
                        name_slug: "career-self-help",
                    },
                ],
            },
            {
                value: "992904",
                label: "Education & Schooling",
                name_slug: "education-schooling",
                children: [
                    {
                        value: "926984",
                        label: "Textbooks",
                        name_slug: "textbooks",
                    },
                    {
                        value: "929160",
                        label: "Language & Dictionaries",
                        name_slug: "language-dictionaries",
                    },
                    {
                        value: "993032",
                        label: "Counseling Books",
                        name_slug: "counseling-books",
                    },
                ],
            },
            {
                value: "989320",
                label: "Economics & Management",
                name_slug: "economics-management",
                children: [
                    {
                        value: "989576",
                        label: "Finance & Investment",
                        name_slug: "finance-investment",
                    },
                    {
                        value: "989448",
                        label: "Economics",
                        name_slug: "economics",
                    },
                    {
                        value: "926600",
                        label: "Business & Management",
                        name_slug: "business-management",
                    },
                ],
            },
            {
                value: "989704",
                label: "Children's & Infants' Books",
                name_slug: "childrens-infants-books",
                children: [
                    {
                        value: "990088",
                        label: "Picture Books",
                        name_slug: "picture-books",
                    },
                    {
                        value: "989832",
                        label: "Early Learning & Soft books",
                        name_slug: "early-learning-soft-books",
                    },
                    {
                        value: "997256",
                        label: "Children's Science & Technology",
                        name_slug: "childrens-science-technology",
                    },
                    {
                        value: "926728",
                        label: "Children's Literature & Art",
                        name_slug: "childrens-literature-art",
                    },
                    {
                        value: "997128",
                        label: "Children's Humanities & Social Sciences",
                        name_slug: "childrens-humanities-social-sciences",
                    },
                    {
                        value: "989960",
                        label: "Activity Books",
                        name_slug: "activity-books",
                    },
                ],
            },
        ],
    },
    {
        value: "700645",
        label: "Health",
        name_slug: "health",
        children: [
            {
                value: "2315536",
                label: "Vaporizer",
                name_slug: "vaporizer",
                children: [
                    {
                        value: "2321808",
                        label: "Vaporizer Package",
                        name_slug: "vaporizer-package",
                    },
                    {
                        value: "2321936",
                        label: "Vape Tools & Kits",
                        name_slug: "vape-tools-kits",
                    },
                    {
                        value: "2321680",
                        label: "Vape MOD",
                        name_slug: "vape-mod",
                    },
                    {
                        value: "2321424",
                        label: "Vape Cotton",
                        name_slug: "vape-cotton",
                    },
                    {
                        value: "2321040",
                        label: "Vape Coils",
                        name_slug: "vape-coils",
                    },
                    {
                        value: "2320912",
                        label: "Vape Chargers",
                        name_slug: "vape-chargers",
                    },
                    {
                        value: "2320784",
                        label: "Vape Case",
                        name_slug: "vape-case",
                    },
                    {
                        value: "2320656",
                        label: "Vape Atomizer",
                        name_slug: "vape-atomizer",
                    },
                    {
                        value: "2321296",
                        label: "Vape Accessories",
                        name_slug: "vape-accessories",
                    },
                    {
                        value: "2321552",
                        label: "Liquid Vapes",
                        name_slug: "liquid-vapes",
                    },
                    {
                        value: "2321168",
                        label: "E-Cigarettes",
                        name_slug: "e-cigarettes",
                    },
                ],
            },
            {
                value: "924552",
                label: "Sexual Wellness",
                name_slug: "sexual-wellness",
                children: [
                    {
                        value: "925960",
                        label: "Performance Enhancers",
                        name_slug: "performance-enhancers",
                    },
                    {
                        value: "925704",
                        label: "Lubricants",
                        name_slug: "lubricants",
                    },
                    {
                        value: "925576",
                        label: "Contraception",
                        name_slug: "contraception",
                    },
                ],
            },
            {
                value: "2315408",
                label: "Prescription Medication",
                name_slug: "prescription-medication",
                children: [
                    {
                        value: "2320528",
                        label: "Urinary Tract & Prostate Drugs",
                        name_slug: "urinary-tract-prostate-drugs",
                    },
                    {
                        value: "2319632",
                        label: "Nervous System & Brain Disorder Drugs",
                        name_slug: "nervous-system-brain-disorder-drugs",
                    },
                    {
                        value: "2320400",
                        label: "Mouth Drugs",
                        name_slug: "mouth-drugs",
                    },
                    {
                        value: "2318864",
                        label: "Menstrual Medicine",
                        name_slug: "menstrual-medicine",
                    },
                    {
                        value: "2319760",
                        label: "Hypertension Drugs",
                        name_slug: "hypertension-drugs",
                    },
                    {
                        value: "2319888",
                        label: "Heart Drugs",
                        name_slug: "heart-drugs",
                    },
                    {
                        value: "2319504",
                        label: "Fertility, Hormone & Contraception Drugs",
                        name_slug: "fertility-hormone-contraception-drugs",
                    },
                    {
                        value: "2320272",
                        label: "Eye Drugs",
                        name_slug: "eye-drugs",
                    },
                    {
                        value: "2319376",
                        label: "Diabetes Drugs",
                        name_slug: "diabetes-drugs",
                    },
                    {
                        value: "2320144",
                        label: "Cholesterol Drugs",
                        name_slug: "cholesterol-drugs",
                    },
                    {
                        value: "2320016",
                        label: "Cancer Drugs",
                        name_slug: "cancer-drugs",
                    },
                    {
                        value: "2319248",
                        label: "Antiviral Drugs",
                        name_slug: "antiviral-drugs",
                    },
                    {
                        value: "2319120",
                        label: "Antimalarial Drugs",
                        name_slug: "antimalarial-drugs",
                    },
                    {
                        value: "2318992",
                        label: "Anti-inflammatory Drugs",
                        name_slug: "anti-inflammatory-drugs",
                    },
                ],
            },
            {
                value: "949384",
                label: "OTC Medications & Treatments",
                name_slug: "otc-medications-treatments",
                children: [
                    {
                        value: "950280",
                        label: "Scars & Stretchmarks",
                        name_slug: "scars-stretchmarks",
                    },
                    {
                        value: "949512",
                        label: "Pain Relief",
                        name_slug: "pain-relief",
                    },
                    {
                        value: "949896",
                        label: "Eczema, Psoriasis and Rosacea Care",
                        name_slug: "eczema-psoriasis-and-rosacea-care",
                    },
                    {
                        value: "949768",
                        label: "Digestion & Nausea",
                        name_slug: "digestion-nausea",
                    },
                    {
                        value: "950536",
                        label: "Cuts & Wounds",
                        name_slug: "cuts-wounds",
                    },
                    {
                        value: "949640",
                        label: "Coughs & Colds",
                        name_slug: "coughs-colds",
                    },
                    {
                        value: "950152",
                        label: "Baby & Child Medicine",
                        name_slug: "baby-child-medicine",
                    },
                    {
                        value: "950408",
                        label: "Antifungals",
                        name_slug: "antifungals",
                    },
                    {
                        value: "950024",
                        label: "Allergies, Sinus & Asthma",
                        name_slug: "allergies-sinus-asthma",
                    },
                ],
            },
            {
                value: "700646",
                label: "Nutrition & Wellness",
                name_slug: "nutrition-wellness",
                children: [
                    {
                        value: "700647",
                        label: "Weight Management Supplements",
                        name_slug: "weight-management-supplements",
                    },
                    {
                        value: "700650",
                        label: "Vitamins, Minerals & Wellness Supplements",
                        name_slug: "vitamins-minerals-wellness-supplements",
                    },
                    {
                        value: "2160400",
                        label: "Herbal Supplements",
                        name_slug: "herbal-supplements",
                    },
                    {
                        value: "700649",
                        label: "Fitness Supplements",
                        name_slug: "fitness-supplements",
                    },
                    {
                        value: "700648",
                        label: "Beauty Supplement",
                        name_slug: "beauty-supplement",
                    },
                ],
            },
            {
                value: "924424",
                label: "Medical Supplies",
                name_slug: "medical-supplies",
                children: [
                    {
                        value: "925192",
                        label: "Wheelchairs",
                        name_slug: "wheelchairs",
                    },
                    {
                        value: "1003912",
                        label: "Walking Sticks",
                        name_slug: "walking-sticks",
                    },
                    {
                        value: "926216",
                        label: "Thermometers",
                        name_slug: "thermometers",
                    },
                    {
                        value: "806032",
                        label: "Smoking Cessation",
                        name_slug: "smoking-cessation",
                    },
                    {
                        value: "805776",
                        label: "Sleep & Snoring",
                        name_slug: "sleep-snoring",
                    },
                    {
                        value: "805904",
                        label: "Respiratory Aids & Accessories",
                        name_slug: "respiratory-aids-accessories",
                    },
                    {
                        value: "950664",
                        label: "Pill Dispensers",
                        name_slug: "pill-dispensers",
                    },
                    {
                        value: "947208",
                        label: "PPE Masks",
                        name_slug: "ppe-masks",
                    },
                    {
                        value: "924680",
                        label: "Medical Masks",
                        name_slug: "medical-masks",
                    },
                    {
                        value: "1003656",
                        label: "Laboratory Tools",
                        name_slug: "laboratory-tools",
                    },
                    {
                        value: "925448",
                        label: "Hearing Aids",
                        name_slug: "hearing-aids",
                    },
                    {
                        value: "925064",
                        label: "Health Monitors & Tests",
                        name_slug: "health-monitors-tests",
                    },
                    {
                        value: "924936",
                        label: "First Aid Supplies",
                        name_slug: "first-aid-supplies",
                    },
                    {
                        value: "875656",
                        label: "Family Planning Tests",
                        name_slug: "family-planning-tests",
                    },
                    {
                        value: "1004040",
                        label: "Electric Stimulators",
                        name_slug: "electric-stimulators",
                    },
                    {
                        value: "824848",
                        label: "Disinfectant Wipes",
                        name_slug: "disinfectant-wipes",
                    },
                    {
                        value: "2160272",
                        label: "Breast Care Patches & Pads",
                        name_slug: "breast-care-patches-pads",
                    },
                    {
                        value: "925320",
                        label: "Braces & Supports",
                        name_slug: "braces-supports",
                    },
                    {
                        value: "2355472",
                        label: "Body Compression Devices",
                        name_slug: "body-compression-devices",
                    },
                    {
                        value: "924808",
                        label: "Bathroom Scales",
                        name_slug: "bathroom-scales",
                    },
                ],
            },
            {
                value: "1025416",
                label: "Funeral",
                name_slug: "funeral",
                children: [
                    {
                        value: "1026056",
                        label: "Urns",
                        name_slug: "urns",
                    },
                    {
                        value: "1025928",
                        label: "Caskets",
                        name_slug: "caskets",
                    },
                ],
            },
            {
                value: "950792",
                label: "Alternative Medications & Treatments",
                name_slug: "alternative-medications-treatments",
                children: [
                    {
                        value: "950920",
                        label: "Herbal Medicine",
                        name_slug: "herbal-medicine",
                    },
                    {
                        value: "951176",
                        label: "Essential Oils for Aromatherapy",
                        name_slug: "essential-oils-for-aromatherapy",
                    },
                    {
                        value: "805520",
                        label: "Alternative Therapy",
                        name_slug: "alternative-therapy",
                    },
                    {
                        value: "951048",
                        label: "Acupuncture",
                        name_slug: "acupuncture",
                    },
                ],
            },
        ],
    },
    {
        value: "953224",
        label: "Jewelry Accessories & Derivatives",
        name_slug: "jewelry-accessories-derivatives",
        children: [
            {
                value: "955144",
                label: "Silver",
                name_slug: "silver",
                children: [
                    {
                        value: "957320",
                        label: "Silver Rings",
                        name_slug: "silver-rings",
                    },
                    {
                        value: "957192",
                        label: "Silver Necklaces & Pendants",
                        name_slug: "silver-necklaces-pendants",
                    },
                    {
                        value: "957704",
                        label: "Silver Jewelry Sets",
                        name_slug: "silver-jewelry-sets",
                    },
                    {
                        value: "957576",
                        label: "Silver Earrings",
                        name_slug: "silver-earrings",
                    },
                    {
                        value: "957960",
                        label: "Silver Decorations",
                        name_slug: "silver-decorations",
                    },
                    {
                        value: "957832",
                        label: "Silver Clothes Accessories",
                        name_slug: "silver-clothes-accessories",
                    },
                    {
                        value: "957448",
                        label: "Silver Bracelets & Anklets",
                        name_slug: "silver-bracelets-anklets",
                    },
                    {
                        value: "2158864",
                        label: "Silver Body Jewelry",
                        name_slug: "silver-body-jewelry",
                    },
                    {
                        value: "958088",
                        label: "Semi-finished Silver",
                        name_slug: "semi-finished-silver",
                    },
                ],
            },
            {
                value: "964232",
                label: "Semiprecious Stones",
                name_slug: "semiprecious-stones",
                children: [
                    {
                        value: "973192",
                        label: "Semiprecious Stone Rings",
                        name_slug: "semiprecious-stone-rings",
                    },
                    {
                        value: "973064",
                        label: "Semiprecious Stone Necklaces & Pendants",
                        name_slug: "semiprecious-stone-necklaces-pendants",
                    },
                    {
                        value: "973576",
                        label: "Semiprecious Stone Jewelry Sets",
                        name_slug: "semiprecious-stone-jewelry-sets",
                    },
                    {
                        value: "973448",
                        label: "Semiprecious Stone Earrings",
                        name_slug: "semiprecious-stone-earrings",
                    },
                    {
                        value: "973704",
                        label: "Semiprecious Stone Clothes Accessories",
                        name_slug: "semiprecious-stone-clothes-accessories",
                    },
                    {
                        value: "973320",
                        label: "Semiprecious Stone Bracelets & Anklets",
                        name_slug: "semiprecious-stone-bracelets-anklets",
                    },
                    {
                        value: "2158992",
                        label: "Semiprecious Stone Body Jewelry",
                        name_slug: "semiprecious-stone-body-jewelry",
                    },
                    {
                        value: "973832",
                        label: "Semi-finished Semiprecious Stones",
                        name_slug: "semi-finished-semiprecious-stones",
                    },
                ],
            },
            {
                value: "964104",
                label: "Ruby, Sapphire & Emerald",
                name_slug: "ruby-sapphire-emerald",
                children: [
                    {
                        value: "972936",
                        label: "Semi-finished Ruby, Sapphire & Emerald",
                        name_slug: "semi-finished-ruby-sapphire-emerald",
                    },
                    {
                        value: "2159120",
                        label: "Ruby, Sapphire & Emerald Watches & Accessories",
                        name_slug: "ruby-sapphire-emerald-watches-accessories",
                    },
                    {
                        value: "972296",
                        label: "Ruby, Sapphire & Emerald Rings",
                        name_slug: "ruby-sapphire-emerald-rings",
                    },
                    {
                        value: "972168",
                        label: "Ruby, Sapphire & Emerald Necklaces & Pendants",
                        name_slug: "ruby-sapphire-emerald-necklaces-pendants",
                    },
                    {
                        value: "972680",
                        label: "Ruby, Sapphire & Emerald Jewelry Sets",
                        name_slug: "ruby-sapphire-emerald-jewelry-sets",
                    },
                    {
                        value: "972552",
                        label: "Ruby, Sapphire & Emerald Earrings",
                        name_slug: "ruby-sapphire-emerald-earrings",
                    },
                    {
                        value: "972808",
                        label: "Ruby, Sapphire & Emerald Clothes Accessories",
                        name_slug: "ruby-sapphire-emerald-clothes-accessories",
                    },
                    {
                        value: "972424",
                        label: "Ruby, Sapphire & Emerald Bracelets & Anklets",
                        name_slug: "ruby-sapphire-emerald-bracelets-anklets",
                    },
                ],
            },
            {
                value: "954888",
                label: "Platinum, Carat Gold",
                name_slug: "platinum-carat-gold",
                children: [
                    {
                        value: "955656",
                        label: "Platinum & Carat Gold Rings",
                        name_slug: "platinum-carat-gold-rings",
                    },
                    {
                        value: "955528",
                        label: "Platinum & Carat Gold Necklaces & Pendants",
                        name_slug: "platinum-carat-gold-necklaces-pendants",
                    },
                    {
                        value: "956040",
                        label: "Platinum & Carat Gold Jewelry Sets",
                        name_slug: "platinum-carat-gold-jewelry-sets",
                    },
                    {
                        value: "955912",
                        label: "Platinum & Carat Gold Earrings",
                        name_slug: "platinum-carat-gold-earrings",
                    },
                    {
                        value: "956168",
                        label: "Platinum & Carat Gold Clothes Accessories",
                        name_slug: "platinum-carat-gold-clothes-accessories",
                    },
                    {
                        value: "955784",
                        label: "Platinum & Carat Gold Bracelets & Anklets",
                        name_slug: "platinum-carat-gold-bracelets-anklets",
                    },
                    {
                        value: "2159248",
                        label: "Platinum & Carat Gold Body Jewelry",
                        name_slug: "platinum-carat-gold-body-jewelry",
                    },
                ],
            },
            {
                value: "964488",
                label: "Pearl",
                name_slug: "pearl",
                children: [
                    {
                        value: "975496",
                        label: "Semi-finished Pearls",
                        name_slug: "semi-finished-pearls",
                    },
                    {
                        value: "974728",
                        label: "Pearl Rings",
                        name_slug: "pearl-rings",
                    },
                    {
                        value: "974600",
                        label: "Pearl Necklaces & Pendants",
                        name_slug: "pearl-necklaces-pendants",
                    },
                    {
                        value: "975112",
                        label: "Pearl Jewelry Sets",
                        name_slug: "pearl-jewelry-sets",
                    },
                    {
                        value: "974984",
                        label: "Pearl Earrings",
                        name_slug: "pearl-earrings",
                    },
                    {
                        value: "975368",
                        label: "Pearl Decorations",
                        name_slug: "pearl-decorations",
                    },
                    {
                        value: "975240",
                        label: "Pearl Clothes Accessories",
                        name_slug: "pearl-clothes-accessories",
                    },
                    {
                        value: "974856",
                        label: "Pearl Bracelets & Anklets",
                        name_slug: "pearl-bracelets-anklets",
                    },
                ],
            },
            {
                value: "961800",
                label: "Non-natural Crystal",
                name_slug: "non-natural-crystal",
                children: [
                    {
                        value: "971272",
                        label: "Semi-finished Non-natural Crystal",
                        name_slug: "semi-finished-non-natural-crystal",
                    },
                    {
                        value: "965000",
                        label: "Non-natural Crystal Rings",
                        name_slug: "non-natural-crystal-rings",
                    },
                    {
                        value: "964872",
                        label: "Non-natural Crystal Necklaces & Pendants",
                        name_slug: "non-natural-crystal-necklaces-pendants",
                    },
                    {
                        value: "970888",
                        label: "Non-natural Crystal Jewelry Sets",
                        name_slug: "non-natural-crystal-jewelry-sets",
                    },
                    {
                        value: "965256",
                        label: "Non-natural Crystal Earrings",
                        name_slug: "non-natural-crystal-earrings",
                    },
                    {
                        value: "971144",
                        label: "Non-natural Crystal Decorations",
                        name_slug: "non-natural-crystal-decorations",
                    },
                    {
                        value: "971016",
                        label: "Non-natural Crystal Clothes Accessories",
                        name_slug: "non-natural-crystal-clothes-accessories",
                    },
                    {
                        value: "965128",
                        label: "Non-natural Crystal Bracelets & Anklets",
                        name_slug: "non-natural-crystal-bracelets-anklets",
                    },
                ],
            },
            {
                value: "955400",
                label: "Natural Crystal",
                name_slug: "natural-crystal",
                children: [
                    {
                        value: "960136",
                        label: "Semi-finished Natural Crystal",
                        name_slug: "semi-finished-natural-crystal",
                    },
                    {
                        value: "959368",
                        label: "Natural Crystal Rings",
                        name_slug: "natural-crystal-rings",
                    },
                    {
                        value: "959240",
                        label: "Natural Crystal Necklaces & Pendants",
                        name_slug: "natural-crystal-necklaces-pendants",
                    },
                    {
                        value: "959752",
                        label: "Natural Crystal Jewelry Sets",
                        name_slug: "natural-crystal-jewelry-sets",
                    },
                    {
                        value: "959624",
                        label: "Natural Crystal Earrings",
                        name_slug: "natural-crystal-earrings",
                    },
                    {
                        value: "960008",
                        label: "Natural Crystal Decorations",
                        name_slug: "natural-crystal-decorations",
                    },
                    {
                        value: "959880",
                        label: "Natural Crystal Clothes Accessories",
                        name_slug: "natural-crystal-clothes-accessories",
                    },
                    {
                        value: "959496",
                        label: "Natural Crystal Bracelets & Anklets",
                        name_slug: "natural-crystal-bracelets-anklets",
                    },
                ],
            },
            {
                value: "964744",
                label: "Mellite",
                name_slug: "mellite",
                children: [
                    {
                        value: "977544",
                        label: "Semi-finished Mellite",
                        name_slug: "semi-finished-mellite",
                    },
                    {
                        value: "976776",
                        label: "Mellite Rings",
                        name_slug: "mellite-rings",
                    },
                    {
                        value: "976648",
                        label: "Mellite Necklaces & Pendants",
                        name_slug: "mellite-necklaces-pendants",
                    },
                    {
                        value: "977160",
                        label: "Mellite Jewelry Sets",
                        name_slug: "mellite-jewelry-sets",
                    },
                    {
                        value: "977032",
                        label: "Mellite Earrings",
                        name_slug: "mellite-earrings",
                    },
                    {
                        value: "977416",
                        label: "Mellite Decorations",
                        name_slug: "mellite-decorations",
                    },
                    {
                        value: "977288",
                        label: "Mellite Clothes Accessories",
                        name_slug: "mellite-clothes-accessories",
                    },
                    {
                        value: "976904",
                        label: "Mellite Bracelets & Anklets",
                        name_slug: "mellite-bracelets-anklets",
                    },
                ],
            },
            {
                value: "963848",
                label: "Jade",
                name_slug: "jade",
                children: [
                    {
                        value: "972040",
                        label: "Semi-finished Jade",
                        name_slug: "semi-finished-jade",
                    },
                    {
                        value: "959112",
                        label: "Jade Rings",
                        name_slug: "jade-rings",
                    },
                    {
                        value: "958984",
                        label: "Jade Necklaces & Pendants",
                        name_slug: "jade-necklaces-pendants",
                    },
                    {
                        value: "971656",
                        label: "Jade Jewelry Sets",
                        name_slug: "jade-jewelry-sets",
                    },
                    {
                        value: "971528",
                        label: "Jade Earrings",
                        name_slug: "jade-earrings",
                    },
                    {
                        value: "971912",
                        label: "Jade Decorations",
                        name_slug: "jade-decorations",
                    },
                    {
                        value: "971784",
                        label: "Jade Clothes Accessories",
                        name_slug: "jade-clothes-accessories",
                    },
                    {
                        value: "971400",
                        label: "Jade Bracelets & Anklets",
                        name_slug: "jade-bracelets-anklets",
                    },
                ],
            },
            {
                value: "955016",
                label: "Gold",
                name_slug: "gold",
                children: [
                    {
                        value: "970760",
                        label: "Semi-finished Gold",
                        name_slug: "semi-finished-gold",
                    },
                    {
                        value: "890512",
                        label: "Mahr",
                        name_slug: "mahr",
                    },
                    {
                        value: "2159376",
                        label: "Gold Watches & Accessories",
                        name_slug: "gold-watches-accessories",
                    },
                    {
                        value: "956552",
                        label: "Gold Rings",
                        name_slug: "gold-rings",
                    },
                    {
                        value: "956424",
                        label: "Gold Necklaces & Pendants",
                        name_slug: "gold-necklaces-pendants",
                    },
                    {
                        value: "956936",
                        label: "Gold Jewelry Sets",
                        name_slug: "gold-jewelry-sets",
                    },
                    {
                        value: "956808",
                        label: "Gold Earrings",
                        name_slug: "gold-earrings",
                    },
                    {
                        value: "970632",
                        label: "Gold Decorations",
                        name_slug: "gold-decorations",
                    },
                    {
                        value: "957064",
                        label: "Gold Clothes Accessories",
                        name_slug: "gold-clothes-accessories",
                    },
                    {
                        value: "956680",
                        label: "Gold Bracelets & Anklets",
                        name_slug: "gold-bracelets-anklets",
                    },
                ],
            },
            {
                value: "955272",
                label: "Diamond",
                name_slug: "diamond",
                children: [
                    {
                        value: "890640",
                        label: "Mahr",
                        name_slug: "mahr",
                    },
                    {
                        value: "2159504",
                        label: "Diamond Watches & Accessories",
                        name_slug: "diamond-watches-accessories",
                    },
                    {
                        value: "958344",
                        label: "Diamond Rings",
                        name_slug: "diamond-rings",
                    },
                    {
                        value: "956296",
                        label: "Diamond Necklaces & Pendants",
                        name_slug: "diamond-necklaces-pendants",
                    },
                    {
                        value: "958728",
                        label: "Diamond Jewelry Sets",
                        name_slug: "diamond-jewelry-sets",
                    },
                    {
                        value: "958600",
                        label: "Diamond Earrings",
                        name_slug: "diamond-earrings",
                    },
                    {
                        value: "958856",
                        label: "Diamond Clothes Accessories",
                        name_slug: "diamond-clothes-accessories",
                    },
                    {
                        value: "958472",
                        label: "Diamond Bracelets & Anklets",
                        name_slug: "diamond-bracelets-anklets",
                    },
                ],
            },
            {
                value: "964360",
                label: "Artificial Gemstones",
                name_slug: "artificial-gemstones",
                children: [
                    {
                        value: "973960",
                        label: "Artificial Gemstone Rings",
                        name_slug: "artificial-gemstone-rings",
                    },
                    {
                        value: "958216",
                        label: "Artificial Gemstone Necklaces & Pendants",
                        name_slug: "artificial-gemstone-necklaces-pendants",
                    },
                    {
                        value: "974344",
                        label: "Artificial Gemstone Jewelry Sets",
                        name_slug: "artificial-gemstone-jewelry-sets",
                    },
                    {
                        value: "974216",
                        label: "Artificial Gemstone Earrings",
                        name_slug: "artificial-gemstone-earrings",
                    },
                    {
                        value: "974472",
                        label: "Artificial Gemstone Clothes Accessories",
                        name_slug: "artificial-gemstone-clothes-accessories",
                    },
                    {
                        value: "974088",
                        label: "Artificial Gemstone Bracelets & Anklets",
                        name_slug: "artificial-gemstone-bracelets-anklets",
                    },
                ],
            },
            {
                value: "964616",
                label: "Amber",
                name_slug: "amber",
                children: [
                    {
                        value: "976520",
                        label: "Semi-finished Amber",
                        name_slug: "semi-finished-amber",
                    },
                    {
                        value: "975752",
                        label: "Amber Rings",
                        name_slug: "amber-rings",
                    },
                    {
                        value: "975624",
                        label: "Amber Necklaces & Pendants",
                        name_slug: "amber-necklaces-pendants",
                    },
                    {
                        value: "976136",
                        label: "Amber Jewelry Sets",
                        name_slug: "amber-jewelry-sets",
                    },
                    {
                        value: "976008",
                        label: "Amber Earrings",
                        name_slug: "amber-earrings",
                    },
                    {
                        value: "976392",
                        label: "Amber Decorations",
                        name_slug: "amber-decorations",
                    },
                    {
                        value: "976264",
                        label: "Amber Clothes Accessories",
                        name_slug: "amber-clothes-accessories",
                    },
                    {
                        value: "975880",
                        label: "Amber Bracelets & Anklets",
                        name_slug: "amber-bracelets-anklets",
                    },
                ],
            },
        ],
    },
    {
        value: "604453",
        label: "Furniture",
        name_slug: "furniture",
        children: [
            {
                value: "871176",
                label: "Outdoor Furniture",
                name_slug: "outdoor-furniture",
                children: [
                    {
                        value: "878728",
                        label: "Stools & Benches",
                        name_slug: "stools-benches",
                    },
                    {
                        value: "877960",
                        label: "Patio Umbrellas",
                        name_slug: "patio-umbrellas",
                    },
                    {
                        value: "878088",
                        label: "Patio Swings",
                        name_slug: "patio-swings",
                    },
                    {
                        value: "878472",
                        label: "Outdoor Tables",
                        name_slug: "outdoor-tables",
                    },
                    {
                        value: "877448",
                        label: "Outdoor Sofas",
                        name_slug: "outdoor-sofas",
                    },
                    {
                        value: "878856",
                        label: "Outdoor Shelves",
                        name_slug: "outdoor-shelves",
                    },
                    {
                        value: "878344",
                        label: "Outdoor Furniture Sets",
                        name_slug: "outdoor-furniture-sets",
                    },
                    {
                        value: "877704",
                        label: "Outdoor Chairs",
                        name_slug: "outdoor-chairs",
                    },
                ],
            },
            {
                value: "871048",
                label: "Indoor Furniture",
                name_slug: "indoor-furniture",
                children: [
                    {
                        value: "876936",
                        label: "Wardrobes",
                        name_slug: "wardrobes",
                    },
                    {
                        value: "875912",
                        label: "Tables & Desks",
                        name_slug: "tables-desks",
                    },
                    {
                        value: "877192",
                        label: "TV Stands & Bedside Tables",
                        name_slug: "tv-stands-bedside-tables",
                    },
                    {
                        value: "876168",
                        label: "Stools & Benches",
                        name_slug: "stools-benches",
                    },
                    {
                        value: "604468",
                        label: "Sofas",
                        name_slug: "sofas",
                    },
                    {
                        value: "604497",
                        label: "Shelves & Racks",
                        name_slug: "shelves-racks",
                    },
                    {
                        value: "806800",
                        label: "Room Dividers",
                        name_slug: "room-dividers",
                    },
                    {
                        value: "876424",
                        label: "Mattresses",
                        name_slug: "mattresses",
                    },
                    {
                        value: "806928",
                        label: "Makeup Vanities",
                        name_slug: "makeup-vanities",
                    },
                    {
                        value: "877064",
                        label: "Indoor Furniture Sets",
                        name_slug: "indoor-furniture-sets",
                    },
                    {
                        value: "880912",
                        label: "Gaming Furniture",
                        name_slug: "gaming-furniture",
                    },
                    {
                        value: "876680",
                        label: "Cupboards & Cabinets",
                        name_slug: "cupboards-cabinets",
                    },
                    {
                        value: "807056",
                        label: "Coat Racks",
                        name_slug: "coat-racks",
                    },
                    {
                        value: "876040",
                        label: "Chairs",
                        name_slug: "chairs",
                    },
                    {
                        value: "876296",
                        label: "Beds",
                        name_slug: "beds",
                    },
                    {
                        value: "979720",
                        label: "Bed Frames & Headboards",
                        name_slug: "bed-frames-headboards",
                    },
                ],
            },
            {
                value: "604459",
                label: "Furniture Parts",
                name_slug: "furniture-parts",
                children: [],
            },
            {
                value: "871432",
                label: "Commercial Furniture",
                name_slug: "commercial-furniture",
                children: [
                    {
                        value: "881160",
                        label: "School Furniture",
                        name_slug: "school-furniture",
                    },
                    {
                        value: "880904",
                        label: "Salon Furniture",
                        name_slug: "salon-furniture",
                    },
                    {
                        value: "881288",
                        label: "Restaurant Furniture",
                        name_slug: "restaurant-furniture",
                    },
                    {
                        value: "881416",
                        label: "Office Furniture",
                        name_slug: "office-furniture",
                    },
                    {
                        value: "881032",
                        label: "Hotel Furniture",
                        name_slug: "hotel-furniture",
                    },
                ],
            },
            {
                value: "871304",
                label: "Children's Furniture",
                name_slug: "childrens-furniture",
                children: [
                    {
                        value: "880392",
                        label: "Wardrobes",
                        name_slug: "wardrobes",
                    },
                    {
                        value: "880264",
                        label: "Tables & Desks",
                        name_slug: "tables-desks",
                    },
                    {
                        value: "879752",
                        label: "Stools & Benches",
                        name_slug: "stools-benches",
                    },
                    {
                        value: "879368",
                        label: "Sofas",
                        name_slug: "sofas",
                    },
                    {
                        value: "933512",
                        label: "Shelves & Racks",
                        name_slug: "shelves-racks",
                    },
                    {
                        value: "880648",
                        label: "Mattresses",
                        name_slug: "mattresses",
                    },
                    {
                        value: "880136",
                        label: "Furniture Sets",
                        name_slug: "furniture-sets",
                    },
                    {
                        value: "879624",
                        label: "Chairs",
                        name_slug: "chairs",
                    },
                    {
                        value: "879880",
                        label: "Cabinets",
                        name_slug: "cabinets",
                    },
                    {
                        value: "880520",
                        label: "Bedside Tables",
                        name_slug: "bedside-tables",
                    },
                    {
                        value: "879240",
                        label: "Beds",
                        name_slug: "beds",
                    },
                ],
            },
        ],
    },
    {
        value: "951432",
        label: "Collectibles",
        name_slug: "collectibles",
        children: [
            {
                value: "810000",
                label: "Trading Cards & Accessories",
                name_slug: "trading-cards-accessories",
                children: [
                    {
                        value: "824080",
                        label: "Trading Card Accessories",
                        name_slug: "trading-card-accessories",
                    },
                    {
                        value: "937864",
                        label: "Sports Trading Cards",
                        name_slug: "sports-trading-cards",
                    },
                    {
                        value: "823952",
                        label: "Non-sports Trading Cards",
                        name_slug: "non-sports-trading-cards",
                    },
                    {
                        value: "2337168",
                        label: "Live-Opened Sports Trading Cards",
                        name_slug: "live-opened-sports-trading-cards",
                    },
                    {
                        value: "2337296",
                        label: "Live-Opened Non-Sports Trading Cards",
                        name_slug: "live-opened-non-sports-trading-cards",
                    },
                ],
            },
            {
                value: "937736",
                label: "Sports Collectibles",
                name_slug: "sports-collectibles",
                children: [
                    {
                        value: "938376",
                        label: "Trophies",
                        name_slug: "trophies",
                    },
                    {
                        value: "2162960",
                        label: "Ticket Stubs",
                        name_slug: "ticket-stubs",
                    },
                    {
                        value: "2163088",
                        label: "Stickers",
                        name_slug: "stickers",
                    },
                    {
                        value: "2336912",
                        label: "Sports Stickers",
                        name_slug: "sports-stickers",
                    },
                    {
                        value: "2163216",
                        label: "Sports Collectibles Accessories",
                        name_slug: "sports-collectibles-accessories",
                    },
                    {
                        value: "2163344",
                        label: "Signs",
                        name_slug: "signs",
                    },
                    {
                        value: "938888",
                        label: "Shoes",
                        name_slug: "shoes",
                    },
                    {
                        value: "2163472",
                        label: "Shirts",
                        name_slug: "shirts",
                    },
                    {
                        value: "939528",
                        label: "Publications",
                        name_slug: "publications",
                    },
                    {
                        value: "939400",
                        label: "Prints & Posters",
                        name_slug: "prints-posters",
                    },
                    {
                        value: "2163600",
                        label: "Plaques",
                        name_slug: "plaques",
                    },
                    {
                        value: "938120",
                        label: "Photographs",
                        name_slug: "photographs",
                    },
                    {
                        value: "2163728",
                        label: "Patches",
                        name_slug: "patches",
                    },
                    {
                        value: "2163856",
                        label: "Mystery Boxes",
                        name_slug: "mystery-boxes",
                    },
                    {
                        value: "2163984",
                        label: "Memorabilia Breaks",
                        name_slug: "memorabilia-breaks",
                    },
                    {
                        value: "2164112",
                        label: "Lithographs",
                        name_slug: "lithographs",
                    },
                    {
                        value: "2164240",
                        label: "Key Chains",
                        name_slug: "key-chains",
                    },
                    {
                        value: "937992",
                        label: "Jerseys",
                        name_slug: "jerseys",
                    },
                    {
                        value: "2164368",
                        label: "Hockey Pucks",
                        name_slug: "hockey-pucks",
                    },
                    {
                        value: "938760",
                        label: "Headwear",
                        name_slug: "headwear",
                    },
                    {
                        value: "939144",
                        label: "Golf Clubs",
                        name_slug: "golf-clubs",
                    },
                    {
                        value: "938632",
                        label: "Gloves",
                        name_slug: "gloves",
                    },
                    {
                        value: "939272",
                        label: "Flags & Banners",
                        name_slug: "flags-banners",
                    },
                    {
                        value: "938504",
                        label: "Figurines",
                        name_slug: "figurines",
                    },
                    {
                        value: "2164496",
                        label: "Cups & Mugs",
                        name_slug: "cups-mugs",
                    },
                    {
                        value: "2164624",
                        label: "Cereal Boxes",
                        name_slug: "cereal-boxes",
                    },
                    {
                        value: "939016",
                        label: "Books",
                        name_slug: "books",
                    },
                    {
                        value: "2164752",
                        label: "Bats",
                        name_slug: "bats",
                    },
                    {
                        value: "938248",
                        label: "Balls",
                        name_slug: "balls",
                    },
                ],
            },
            {
                value: "953352",
                label: "Entertainment",
                name_slug: "entertainment",
                children: [
                    {
                        value: "2164880",
                        label: "Stickers",
                        name_slug: "stickers",
                    },
                    {
                        value: "2165008",
                        label: "Retro Video Games and Accessories",
                        name_slug: "retro-video-games-and-accessories",
                    },
                    {
                        value: "954120",
                        label: "Prints & Posters",
                        name_slug: "prints-posters",
                    },
                    {
                        value: "2165136",
                        label: "Postcards",
                        name_slug: "postcards",
                    },
                    {
                        value: "953736",
                        label: "Postage Stamps",
                        name_slug: "postage-stamps",
                    },
                    {
                        value: "2165264",
                        label: "Plushies",
                        name_slug: "plushies",
                    },
                    {
                        value: "953992",
                        label: "Plates",
                        name_slug: "plates",
                    },
                    {
                        value: "2165392",
                        label: "Pinbacks",
                        name_slug: "pinbacks",
                    },
                    {
                        value: "2165520",
                        label: "Photographic Images",
                        name_slug: "photographic-images",
                    },
                    {
                        value: "843152",
                        label: "Photocards",
                        name_slug: "photocards",
                    },
                    {
                        value: "2337040",
                        label: "Non-Sports Stickers",
                        name_slug: "non-sports-stickers",
                    },
                    {
                        value: "2165648",
                        label: "Music, Movies and TV Shows",
                        name_slug: "music-movies-and-tv-shows",
                    },
                    {
                        value: "953864",
                        label: "Model Cars & Diecast Toys",
                        name_slug: "model-cars-diecast-toys",
                    },
                    {
                        value: "2165776",
                        label: "Mixed Lots",
                        name_slug: "mixed-lots",
                    },
                    {
                        value: "2324112",
                        label: "Light Stick",
                        name_slug: "light-stick",
                    },
                    {
                        value: "953608",
                        label: "Figurines, Statues & Bobbleheads",
                        name_slug: "figurines-statues-bobbleheads",
                    },
                    {
                        value: "2165904",
                        label: "Fantasy Games",
                        name_slug: "fantasy-games",
                    },
                    {
                        value: "2166032",
                        label: "Entertainment Collectibles Accessoires",
                        name_slug: "entertainment-collectibles-accessoires",
                    },
                    {
                        value: "2313872",
                        label: "Comics & Manga",
                        name_slug: "comics-manga",
                    },
                    {
                        value: "2166160",
                        label: "Collectible Keychains",
                        name_slug: "collectible-keychains",
                    },
                    {
                        value: "2166288",
                        label: "Collectible Cups and Mugs",
                        name_slug: "collectible-cups-and-mugs",
                    },
                    {
                        value: "2166416",
                        label: "Collectible Bags",
                        name_slug: "collectible-bags",
                    },
                    {
                        value: "2166544",
                        label: "Collectible Backpacks",
                        name_slug: "collectible-backpacks",
                    },
                    {
                        value: "953480",
                        label: "CDs, DVDs, & Vinyl Records",
                        name_slug: "cds-dvds-vinyl-records",
                    },
                    {
                        value: "2166672",
                        label: "Building Kits",
                        name_slug: "building-kits",
                    },
                    {
                        value: "2166800",
                        label: "Blind box",
                        name_slug: "blind-box",
                    },
                    {
                        value: "2166928",
                        label: "Animation Art & Merchandise",
                        name_slug: "animation-art-merchandise",
                    },
                ],
            },
            {
                value: "809872",
                label: "Cultural Items",
                name_slug: "cultural-items",
                children: [
                    {
                        value: "823696",
                        label: "Seal Carvings",
                        name_slug: "seal-carvings",
                    },
                    {
                        value: "2167056",
                        label: "Rocks, Fossils & Minerals",
                        name_slug: "rocks-fossils-minerals",
                    },
                    {
                        value: "823568",
                        label: "Rare Stone & Stone Carvings",
                        name_slug: "rare-stone-stone-carvings",
                    },
                    {
                        value: "823056",
                        label: "Pottery",
                        name_slug: "pottery",
                    },
                    {
                        value: "822800",
                        label: "Porcelain",
                        name_slug: "porcelain",
                    },
                    {
                        value: "823312",
                        label: "Paintings",
                        name_slug: "paintings",
                    },
                    {
                        value: "822928",
                        label: "Jianzhan",
                        name_slug: "jianzhan",
                    },
                    {
                        value: "823824",
                        label: "Incense Burners & Spices",
                        name_slug: "incense-burners-spices",
                    },
                    {
                        value: "823184",
                        label: "Calligraphy",
                        name_slug: "calligraphy",
                    },
                    {
                        value: "823440",
                        label: "Art",
                        name_slug: "art",
                    },
                ],
            },
            {
                value: "952712",
                label: "Collectible Coins & Money",
                name_slug: "collectible-coins-money",
                children: [
                    {
                        value: "2167184",
                        label: "Stocks, Bonds, & Scripophily",
                        name_slug: "stocks-bonds-scripophily",
                    },
                    {
                        value: "2167312",
                        label: "Publications and Supplies",
                        name_slug: "publications-and-supplies",
                    },
                    {
                        value: "2167440",
                        label: "Exonumia",
                        name_slug: "exonumia",
                    },
                    {
                        value: "952840",
                        label: "Coins & Bullion",
                        name_slug: "coins-bullion",
                    },
                    {
                        value: "952968",
                        label: "Banknotes",
                        name_slug: "banknotes",
                    },
                ],
            },
        ],
    },
    {
        value: "834312",
        label: "Virtual Products",
        name_slug: "virtual-products",
        children: [
            {
                value: "893968",
                label: "Top-Up",
                name_slug: "top-up",
                children: [
                    {
                        value: "894096",
                        label: "Electricity",
                        name_slug: "electricity",
                    },
                    {
                        value: "894224",
                        label: "E-Money",
                        name_slug: "e-money",
                    },
                ],
            },
            {
                value: "996360",
                label: "Telecommunications",
                name_slug: "telecommunications",
                children: [
                    {
                        value: "834440",
                        label: "Mobile Top-ups",
                        name_slug: "mobile-top-ups",
                    },
                    {
                        value: "996104",
                        label: "Mobile Data",
                        name_slug: "mobile-data",
                    },
                ],
            },
        ],
    },
    {
        value: "856720",
        label: "Pre-Owned",
        name_slug: "pre-owned",
        children: [
            {
                value: "857616",
                label: "Womenswear",
                name_slug: "womenswear",
                children: [
                    {
                        value: "862096",
                        label: "Women's Tops",
                        name_slug: "womens-tops",
                    },
                    {
                        value: "862352",
                        label: "Women's Swimwear & Beachwear",
                        name_slug: "womens-swimwear-beachwear",
                    },
                    {
                        value: "861968",
                        label: "Women's Suits & Overalls",
                        name_slug: "womens-suits-overalls",
                    },
                    {
                        value: "862736",
                        label: "Women's Sportswear",
                        name_slug: "womens-sportswear",
                    },
                    {
                        value: "862224",
                        label: "Women's Lingerie, Nightwear & Loungewear",
                        name_slug: "womens-lingerie-nightwear-loungewear",
                    },
                    {
                        value: "862608",
                        label: "Women's Jumpers, Cardigans & Hoodies",
                        name_slug: "womens-jumpers-cardigans-hoodies",
                    },
                    {
                        value: "862480",
                        label: "Women's Jackets & Coats",
                        name_slug: "womens-jackets-coats",
                    },
                    {
                        value: "861840",
                        label: "Women's Dresses",
                        name_slug: "womens-dresses",
                    },
                    {
                        value: "861712",
                        label: "Women's Bottoms",
                        name_slug: "womens-bottoms",
                    },
                ],
            },
            {
                value: "865296",
                label: "Watches",
                name_slug: "watches",
                children: [
                    {
                        value: "865808",
                        label: "Watch Accessories",
                        name_slug: "watch-accessories",
                    },
                    {
                        value: "859152",
                        label: "Smart Watches",
                        name_slug: "smart-watches",
                    },
                    {
                        value: "865424",
                        label: "Quartz Watches",
                        name_slug: "quartz-watches",
                    },
                    {
                        value: "865552",
                        label: "Manual Watches",
                        name_slug: "manual-watches",
                    },
                    {
                        value: "2337424",
                        label: "Luxury Watches",
                        name_slug: "luxury-watches",
                    },
                    {
                        value: "865680",
                        label: "Automatic Watches",
                        name_slug: "automatic-watches",
                    },
                ],
            },
            {
                value: "2335888",
                label: "Sports Accessories",
                name_slug: "sports-accessories",
                children: [
                    {
                        value: "2336400",
                        label: "Resistance Bands",
                        name_slug: "resistance-bands",
                    },
                    {
                        value: "2336272",
                        label: "Golf Tees & Markers",
                        name_slug: "golf-tees-markers",
                    },
                    {
                        value: "2336144",
                        label: "Golf Clubs",
                        name_slug: "golf-clubs",
                    },
                    {
                        value: "2336016",
                        label: "Golf Balls",
                        name_slug: "golf-balls",
                    },
                    {
                        value: "2336528",
                        label: "Foam Rollers",
                        name_slug: "foam-rollers",
                    },
                    {
                        value: "2336784",
                        label: "Fishing Accessories",
                        name_slug: "fishing-accessories",
                    },
                    {
                        value: "2336656",
                        label: "Cycling Accessories",
                        name_slug: "cycling-accessories",
                    },
                ],
            },
            {
                value: "857744",
                label: "Refurbished Phones & Electronics",
                name_slug: "refurbished-phones-electronics",
                children: [
                    {
                        value: "862992",
                        label: "Tablets",
                        name_slug: "tablets",
                    },
                    {
                        value: "893200",
                        label: "Servers",
                        name_slug: "servers",
                    },
                    {
                        value: "862864",
                        label: "Mobile Phones",
                        name_slug: "mobile-phones",
                    },
                    {
                        value: "880528",
                        label: "Laptops",
                        name_slug: "laptops",
                    },
                    {
                        value: "892944",
                        label: "Desktop Computers",
                        name_slug: "desktop-computers",
                    },
                    {
                        value: "893072",
                        label: "All-in-One Desktops",
                        name_slug: "all-in-one-desktops",
                    },
                ],
            },
            {
                value: "857488",
                label: "Menswear",
                name_slug: "menswear",
                children: [
                    {
                        value: "860432",
                        label: "Men's Tops",
                        name_slug: "mens-tops",
                    },
                    {
                        value: "860560",
                        label: "Men's Swimwear & Beachwear",
                        name_slug: "mens-swimwear-beachwear",
                    },
                    {
                        value: "860304",
                        label: "Men's Suits & Overalls",
                        name_slug: "mens-suits-overalls",
                    },
                    {
                        value: "860944",
                        label: "Men's Sportswear",
                        name_slug: "mens-sportswear",
                    },
                    {
                        value: "860816",
                        label: "Men's Jumpers, Cardigans & Hoodies",
                        name_slug: "mens-jumpers-cardigans-hoodies",
                    },
                    {
                        value: "860688",
                        label: "Men's Jackets & Coats",
                        name_slug: "mens-jackets-coats",
                    },
                    {
                        value: "860176",
                        label: "Men's Bottoms",
                        name_slug: "mens-bottoms",
                    },
                ],
            },
            {
                value: "864656",
                label: "Luggage & Travel",
                name_slug: "luggage-travel",
                children: [
                    {
                        value: "864784",
                        label: "Travel Bags",
                        name_slug: "travel-bags",
                    },
                    {
                        value: "864912",
                        label: "Toiletry Bags",
                        name_slug: "toiletry-bags",
                    },
                    {
                        value: "859408",
                        label: "Luggage Accessories",
                        name_slug: "luggage-accessories",
                    },
                    {
                        value: "859280",
                        label: "Luggage",
                        name_slug: "luggage",
                    },
                ],
            },
            {
                value: "857360",
                label: "Footwear",
                name_slug: "footwear",
                children: [
                    {
                        value: "861456",
                        label: "Women's Flats",
                        name_slug: "womens-flats",
                    },
                    {
                        value: "861328",
                        label: "Sneakers",
                        name_slug: "sneakers",
                    },
                    {
                        value: "865040",
                        label: "Sandals",
                        name_slug: "sandals",
                    },
                    {
                        value: "861072",
                        label: "Men's Dress Shoes",
                        name_slug: "mens-dress-shoes",
                    },
                    {
                        value: "861200",
                        label: "High Heels",
                        name_slug: "high-heels",
                    },
                    {
                        value: "861584",
                        label: "Footwear Accessories",
                        name_slug: "footwear-accessories",
                    },
                    {
                        value: "865168",
                        label: "Boots",
                        name_slug: "boots",
                    },
                ],
            },
            {
                value: "857104",
                label: "Fashion Accessories",
                name_slug: "fashion-accessories",
                children: [
                    {
                        value: "858896",
                        label: "Sunglasses",
                        name_slug: "sunglasses",
                    },
                    {
                        value: "1025800",
                        label: "Scarves & Shawls",
                        name_slug: "scarves-shawls",
                    },
                    {
                        value: "2337552",
                        label: "Luxury Jewelry",
                        name_slug: "luxury-jewelry",
                    },
                    {
                        value: "858512",
                        label: "Hats",
                        name_slug: "hats",
                    },
                    {
                        value: "859024",
                        label: "Hair Accessories",
                        name_slug: "hair-accessories",
                    },
                    {
                        value: "858384",
                        label: "Gloves",
                        name_slug: "gloves",
                    },
                    {
                        value: "858768",
                        label: "Frames & Glasses",
                        name_slug: "frames-glasses",
                    },
                    {
                        value: "858640",
                        label: "Costume Jewellery & Accessories",
                        name_slug: "costume-jewellery-accessories",
                    },
                    {
                        value: "858256",
                        label: "Belts",
                        name_slug: "belts",
                    },
                ],
            },
            {
                value: "856976",
                label: "Collectible Trading Cards",
                name_slug: "collectible-trading-cards",
                children: [
                    {
                        value: "858000",
                        label: "Trading Cards Accessories",
                        name_slug: "trading-cards-accessories",
                    },
                    {
                        value: "1024392",
                        label: "Sports Trading Cards Raw Single",
                        name_slug: "sports-trading-cards-raw-single",
                    },
                    {
                        value: "863632",
                        label: "Sports Trading Cards Packs & Boxes",
                        name_slug: "sports-trading-cards-packs-boxes",
                    },
                    {
                        value: "858128",
                        label: "Sports Trading Cards Graded Singles",
                        name_slug: "sports-trading-cards-graded-singles",
                    },
                    {
                        value: "863760",
                        label: "Sports Trading Card Breaks",
                        name_slug: "sports-trading-card-breaks",
                    },
                    {
                        value: "1024520",
                        label: "Non-Sports Trading Cards Raw Singles",
                        name_slug: "non-sports-trading-cards-raw-singles",
                    },
                    {
                        value: "857872",
                        label: "Non-Sports Trading Cards Graded Singles",
                        name_slug: "non-sports-trading-cards-graded-singles",
                    },
                    {
                        value: "863376",
                        label: "Non-Sports Trading Card Packs & Boxes",
                        name_slug: "non-sports-trading-card-packs-boxes",
                    },
                    {
                        value: "863504",
                        label: "Non-Sports Trading Card Breaks",
                        name_slug: "non-sports-trading-card-breaks",
                    },
                ],
            },
            {
                value: "2315792",
                label: "Car & Motorcycles",
                name_slug: "car-motorcycles",
                children: [
                    {
                        value: "2323600",
                        label: "Sport Motorcycle",
                        name_slug: "sport-motorcycle",
                    },
                    {
                        value: "2322960",
                        label: "Sedan Car",
                        name_slug: "sedan-car",
                    },
                    {
                        value: "2323088",
                        label: "SUV & MPV Car",
                        name_slug: "suv-mpv-car",
                    },
                    {
                        value: "2323216",
                        label: "Manual Transmission Motorcycles",
                        name_slug: "manual-transmission-motorcycles",
                    },
                    {
                        value: "2322576",
                        label: "Hatchback & City Car",
                        name_slug: "hatchback-city-car",
                    },
                    {
                        value: "2323344",
                        label: "Electric Motorcycles",
                        name_slug: "electric-motorcycles",
                    },
                    {
                        value: "2322704",
                        label: "Electric Car",
                        name_slug: "electric-car",
                    },
                    {
                        value: "2322832",
                        label: "Commercial Car",
                        name_slug: "commercial-car",
                    },
                    {
                        value: "2323472",
                        label: "Automatic Transmission Motorcycles",
                        name_slug: "automatic-transmission-motorcycles",
                    },
                ],
            },
            {
                value: "2339600",
                label: "Books",
                name_slug: "books",
                children: [
                    {
                        value: "2339984",
                        label: "Rare & Collectible Books",
                        name_slug: "rare-collectible-books",
                    },
                    {
                        value: "2339728",
                        label: "Non-graded Books",
                        name_slug: "non-graded-books",
                    },
                    {
                        value: "2339856",
                        label: "Graded Comic Books",
                        name_slug: "graded-comic-books",
                    },
                ],
            },
            {
                value: "857232",
                label: "Bags",
                name_slug: "bags",
                children: [
                    {
                        value: "864144",
                        label: "Tote Bags",
                        name_slug: "tote-bags",
                    },
                    {
                        value: "871440",
                        label: "Top Handle Bags",
                        name_slug: "top-handle-bags",
                    },
                    {
                        value: "860048",
                        label: "Small Leather Goods",
                        name_slug: "small-leather-goods",
                    },
                    {
                        value: "859792",
                        label: "Shoulder Bags",
                        name_slug: "shoulder-bags",
                    },
                    {
                        value: "859920",
                        label: "Professional & Technology Bags",
                        name_slug: "professional-technology-bags",
                    },
                    {
                        value: "864016",
                        label: "Mini Bags",
                        name_slug: "mini-bags",
                    },
                    {
                        value: "859664",
                        label: "Messenger Bags",
                        name_slug: "messenger-bags",
                    },
                    {
                        value: "863888",
                        label: "Crossbody Bags",
                        name_slug: "crossbody-bags",
                    },
                    {
                        value: "864272",
                        label: "Clutches & Wristlets",
                        name_slug: "clutches-wristlets",
                    },
                    {
                        value: "871568",
                        label: "Bucket Bags",
                        name_slug: "bucket-bags",
                    },
                    {
                        value: "864528",
                        label: "Belt Bags",
                        name_slug: "belt-bags",
                    },
                    {
                        value: "859536",
                        label: "Bag Accessories",
                        name_slug: "bag-accessories",
                    },
                    {
                        value: "864400",
                        label: "Backpacks",
                        name_slug: "backpacks",
                    },
                ],
            },
        ],
    },
    {
        value: "0",
        label: "Other",
        name_slug: "other",
        children: [],
    },
];

export const INFLUENCER_CATEGORIES = [
    {
        id: "",
        label: "All",
        name_slug: "all",
        value: "All",
    },
    {
        id: "Public Figure",
        label: "Public Figure",
        name_slug: "public-figure",
        value: "Public Figure",
    },
    {
        id: "Entertainment",
        label: "Entertainment",
        name_slug: "entertainment",
        value: "Entertainment",
    },
    {
        id: "Beauty",
        label: "Beauty",
        name_slug: "beauty",
        value: "Beauty",
    },
    {
        id: "Personal Blog",
        label: "Personal Blog",
        name_slug: "personal-blog",
        value: "Personal Blog",
    },
    {
        id: "Art",
        label: "Art",
        name_slug: "art",
        value: "Art",
    },
    {
        id: "Music/Dance",
        label: "Music/Dance",
        name_slug: "musicdance",
        value: "Music/Dance",
    },
    {
        id: "Fashion",
        label: "Fashion",
        name_slug: "fashion",
        value: "Fashion",
    },
    {
        id: "Media",
        label: "Media",
        name_slug: "media",
        value: "Media",
    },
    {
        id: "Sports",
        label: "Sports",
        name_slug: "sports",
        value: "Sports",
    },
    {
        id: "Pets",
        label: "Pets",
        name_slug: "pets",
        value: "Pets",
    },
    {
        id: "Education",
        label: "Education",
        name_slug: "education",
        value: "Education",
    },
    {
        id: "Baby",
        label: "Baby",
        name_slug: "baby",
        value: "Baby",
    },
    {
        id: "Food",
        label: "Food",
        name_slug: "food",
        value: "Food",
    },
    {
        id: "Clothing",
        label: "Clothing",
        name_slug: "clothing",
        value: "Clothing",
    },
    {
        id: "Gaming",
        label: "Gaming",
        name_slug: "gaming",
        value: "Gaming",
    },
    {
        id: "Home",
        label: "Home",
        name_slug: "home",
        value: "Home",
    },
    {
        id: "Shopping",
        label: "Shopping",
        name_slug: "shopping",
        value: "Shopping",
    },
    {
        id: "Outdoor",
        label: "Outdoor",
        name_slug: "outdoor",
        value: "Outdoor",
    },
    {
        id: "Brand",
        label: "Brand",
        name_slug: "brand",
        value: "Brand",
    },
    {
        id: "Health",
        label: "Health",
        name_slug: "health",
        value: "Health",
    },
    {
        id: "Auto",
        label: "Auto",
        name_slug: "auto",
        value: "Auto",
    },
    {
        id: "Tech",
        label: "Tech",
        name_slug: "tech",
        value: "Tech",
    },
    {
        id: "Electron",
        label: "Electron",
        name_slug: "electron",
        value: "Electron",
    },
    {
        id: "Movie",
        label: "Movie",
        name_slug: "movie",
        value: "Movie",
    },
    {
        id: "Life",
        label: "Life",
        name_slug: "life",
        value: "Life",
    },
    {
        id: "Travel",
        label: "Travel",
        name_slug: "travel",
        value: "Travel",
    },
    {
        id: "Finance",
        label: "Finance",
        name_slug: "finance",
        value: "Finance",
    },
    {
        id: "Government",
        label: "Government",
        name_slug: "government",
        value: "Government",
    },
    {
        id: "Service",
        label: "Service",
        name_slug: "service",
        value: "Service",
    },
];

export const MORE_FILTERS = {
    total_sold_count: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: ">100",
            name: ">100",
            key: ">100",
        },
        {
            id: ">500",
            name: ">500",
            key: ">500",
        },
        {
            id: ">1000",
            name: ">1K",
            key: ">1000",
        },
        {
            id: ">5000",
            name: ">5K",
            key: ">5000",
        },
        {
            id: ">10000",
            name: ">10K",
            key: ">10000",
        },
    ],
    sales: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: ">100",
            name: ">100",
            key: ">100",
        },
        {
            id: ">500",
            name: ">500",
            key: ">500",
        },
        {
            id: ">1000",
            name: ">1K",
            key: ">1000",
        },
        {
            id: ">5000",
            name: ">5K",
            key: ">5000",
        },
        {
            id: ">10000",
            name: ">10K",
            key: ">10000",
        },
    ],
    total_sale_cnt: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: ">100",
            name: ">100",
            key: ">100",
        },
        {
            id: ">500",
            name: ">500",
            key: ">500",
        },
        {
            id: ">1000",
            name: ">1K",
            key: ">1000",
        },
        {
            id: ">5000",
            name: ">5K",
            key: ">5000",
        },
        {
            id: ">10000",
            name: ">10K",
            key: ">10000",
        },
    ],
    gmv: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: "<1000",
            name: "<$1K",
            key: "<1000",
        },
        {
            id: "1000-10000",
            name: "$1K-$10K",
            key: "1000-10000",
        },
        {
            id: "10000-100000",
            name: "$10K-$100k",
            key: "10000-100000",
        },
        {
            id: "100000-1000000",
            name: "$100K-$1M",
            key: "100000-1000000",
        },
        {
            id: "1000000-10000000",
            name: "$1M-$10M",
            key: "1000000-10000000",
        },
        {
            id: ">10000000",
            name: ">=$10M",
            key: ">10000000",
        },
    ],
    gmv_amt_30d: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: "<1000",
            name: "<$1K",
            key: "<1000",
        },
        {
            id: "1000-10000",
            name: "$1K-$10K",
            key: "1000-10000",
        },
        {
            id: "10000-100000",
            name: "$10K-$100k",
            key: "10000-100000",
        },
        {
            id: "100000-1000000",
            name: "$100K-$1M",
            key: "100000-1000000",
        },
        {
            id: "1000000-10000000",
            name: "$1M-$10M",
            key: "1000000-10000000",
        },
        {
            id: ">10000000",
            name: ">=$10M",
            key: ">10000000",
        },
    ],
    price: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: "<1",
            name: "<$1",
            key: "<1",
        },
        {
            id: "1-5",
            name: "$1-$5",
            key: "1-5",
        },
        {
            id: "5-10",
            name: "$5-$10",
            key: "5-10",
        },
        {
            id: "10-20",
            name: "$10-$20",
            key: "10-20",
        },
        {
            id: "20-100",
            name: "$20-$100",
            key: "20-100",
        },
        {
            id: ">100",
            name: ">=$100",
            key: ">100",
        },
    ],
    related_influencers: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: "1-5",
            name: "1-5",
            key: "1-5",
        },
        {
            id: "5-100",
            name: "5-100",
            key: "5-100",
        },
        {
            id: "100-500",
            name: "100-500",
            key: "100-500",
        },
        {
            id: "500-1000",
            name: "500-1000",
            key: "500-1000",
        },
        {
            id: ">1000",
            name: ">=1000",
            key: ">1000",
        },
    ],
    videos_count: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: "<10",
            name: "<10",
            key: "<10",
        },
        {
            id: "10-100",
            name: "10-100",
            key: "10-100",
        },
        {
            id: "100-500",
            name: "100-500",
            key: "100-500",
        },
        {
            id: "500-1000",
            name: "500-1000",
            key: "500-1000",
        },
        {
            id: "1000-5000",
            name: "1K-5K",
            key: "1K-5K",
        },
        {
            id: ">5000",
            name: ">=5K",
            key: ">5000",
        },
    ],
    views_count: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: "<10000",
            name: "<10K",
            key: "<10K",
        },
        {
            id: "10000-100000",
            name: "10K-100K",
            key: "10K-100K",
        },
        {
            id: "100000-1000000",
            name: "100K-1M",
            key: "100K-1M",
        },
        {
            id: "1000000-5000000",
            name: "1M-5M",
            key: "1M-5M",
        },
        {
            id: "5000000-10000000",
            name: "5M-10M",
            key: "5M-10M",
        },
        {
            id: ">10000000",
            name: ">=10M",
            key: ">10000000",
        },
    ],
    likes_count: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: "<10000",
            name: "<10K",
            key: "<10000",
        },
        {
            id: "10000-100000",
            name: "10K-100K",
            key: "10000-100000",
        },
        {
            id: "100000-1000000",
            name: "100K-1M",
            key: "100000-1000000",
        },
        {
            id: "1000000-5000000",
            name: "1M-5M",
            key: "1000000-5000000",
        },
        {
            id: "5000000-10000000",
            name: "5M-10M",
            key: "5000000-10000000",
        },
        {
            id: ">10000000",
            name: ">=10M",
            key: ">10000000",
        },
    ],
    comments_count: [
        {
            "id": "",
            "name": "Unlimited",
            "key": "unlimited"
        },
        {
            "id": "<10000",
            "name": "<10K",
            "key": "<10000"
        },
        {
            "id": "10000-100000",
            "name": "10K-100K",
            "key": "10000-100000"
        },
        {
            "id": "100000-1000000",
            "name": "100K-1M",
            "key": "100000-1000000"
        },
        {
            "id": "1000000-5000000",
            "name": "1M-5M",
            "key": "1000000-5000000"
        },
        {
            "id": "5000000-10000000",
            "name": "5M-10M",
            "key": "5000000-10000000"
        },
        {
            "id": ">10000000",
            "name": ">=10M",
            "key": ">10000000"
        }
    ],
    shares_count: [
        {
            "id": "",
            "name": "Unlimited",
            "key": "unlimited"
        },
        {
            "id": "<10000",
            "name": "<10K",
            "key": "<10000"
        },
        {
            "id": "10000-100000",
            "name": "10K-100K",
            "key": "10000-100000"
        },
        {
            "id": "100000-1000000",
            "name": "100K-1M",
            "key": "100000-1000000"
        },
        {
            "id": "1000000-5000000",
            "name": "1M-5M",
            "key": "1000000-5000000"
        },
        {
            "id": "5000000-10000000",
            "name": "5M-10M",
            "key": "5000000-10000000"
        },
        {
            "id": ">10000000",
            "name": ">=10M",
            "key": ">10000000"
        }
    ],
    duration: [
        {
            "id": "",
            "name": "Unlimited",
            "key": "unlimited"
        },
        {
            "id": "<10",
            "name": "<10s",
            "key": "<10s"
        },
        {
            "id": "10-30",
            "name": "10s-30s",
            "key": "10s-30s"
        },
        {
            "id": "30-60",
            "name": "30s-60s",
            "key": "30s-60s"
        },
        {
            "id": ">60",
            "name": ">=60s",
            "key": ">60s"
        }
    ],
    is_sale: [
        {
            "id": "",
            "name": "Unlimited",
            "key": "unlimited",
            "name_slug": "unlimited"
        },
        {
            "id": "0",
            "name": "No",
            "key": "no",
            "name_slug": "no-product-in-video"
        },
        {
            "id": "1",
            "name": "Yes",
            "key": "yes",
            "name_slug": "product-in-video"
        }
    ],
    is_latest: [
        {
            "id": "",
            "name": "No Choose",
            "key": "unlimited",
            "name_slug": "unlimited"
        },
        {
            "id": "0",
            "name": "No",
            "key": "no",
            "name_slug": "no-product-in-video"
        },
        {
            "id": "1",
            "name": "Yes",
            "key": "yes",
            "name_slug": "product-in-video"
        }
    ],
    commission_rate: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: "1-5",
            name: "1%-5%",
            key: "1-5",
        },
        {
            id: "5-10",
            name: "5%-10%",
            key: "5-10",
        },
        {
            id: "10-20",
            name: "10%-20%",
            key: "10-20",
        },
        {
            id: "20-30",
            name: "20%-30%",
            key: "20-30",
        },
        {
            id: "30-40",
            name: "30%-40%",
            key: "30-40",
        },
        {
            id: "40-50",
            name: "40%-50%",
            key: "40-50",
        },
        {
            id: ">50",
            name: ">=50%",
            key: ">50",
        },
    ],
    product_rating: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: "<4.0",
            name: "<4.0",
            key: "<4.0",
        },
        {
            id: "4.0-4.2",
            name: "4.0-4.2",
            key: "4.0-4.2",
        },
        {
            id: "4.2-4.6",
            name: "4.2-4.6",
            key: "4.2-4.6",
        },
        {
            id: "4.6-4.8",
            name: "4.6-4.8",
            key: "4.6-4.8",
        },
        {
            id: "4.8-5.0",
            name: "4.8-5.0",
            key: "4.8-5.0",
        },
        {
            id: ">5.0",
            name: "5.0",
            key: ">5.0",
        },
    ],
    review_count: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: "<100",
            name: "<100",
            key: "<100",
        },
        {
            id: "100-1000",
            name: "100-1000",
            key: "100-1000",
        },
        {
            id: "1000-10000",
            name: "1K-10K",
            key: "1000-10000",
        },
        {
            id: "10000-50000",
            name: "10K-50K",
            key: "10K-50K",
        },
        {
            id: ">50000",
            name: ">=50K",
            key: ">50000",
        },
    ],
    total_sale_nd_cnt: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: ">100",
            name: ">100",
            key: ">100",
        },
        {
            id: ">500",
            name: ">500",
            key: ">500",
        },
        {
            id: ">1000",
            name: ">1k",
            key: ">1000",
        },
        {
            id: ">5000",
            name: ">5k",
            key: ">5000",
        },
        {
            id: ">10000",
            name: ">10k",
            key: ">10000",
        },
    ],
    seller_rating: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: "<4.0",
            name: "<4.0",
            key: "<4.0",
        },
        {
            id: "4.0-4.2",
            name: "4.0-4.2",
            key: "4.0-4.2",
        },
        {
            id: "4.2-4.6",
            name: "4.2-4.6",
            key: "4.2-4.6",
        },
        {
            id: "4.6-4.8",
            name: "4.6-4.8",
            key: "4.6-4.8",
        },
        {
            id: "4.8-5.0",
            name: "4.8-5.0",
            key: "4.8-5.0",
        },
        {
            id: ">5.0",
            name: "5.0",
            key: ">5.0",
        },
    ],
    total_sale_gmv_amt: [
        {
            id: "",
            name: "Unlimited",
            key: "unlimited",
        },
        {
            id: "<1000",
            name: "<$1K",
            key: "<1000",
        },
        {
            id: "1000-10000",
            name: "$1K-$10K",
            key: "1000-10000",
        },
        {
            id: "10000-100000",
            name: "$10K-$100k",
            key: "10000-100000",
        },
        {
            id: "100000-1000000",
            name: "$100K-$1M",
            key: "100000-1000000",
        },
        {
            id: "1000000-10000000",
            name: "$1M-$10M",
            key: "1000000-10000000",
        },
        {
            id: ">10000000",
            name: ">=$10M",
            key: ">10000000",
        },
    ],
    dateRange: [
        {
            id: "1",
            name: "Yesterday",
            key: "1",
        },
        {
            id: "7",
            name: "7 days",
            key: "7",
        },
        {
            id: "30",
            name: "30 days",
            key: "30",
        },
        {
            id: "90",
            name: "90 days",
            key: "90",
        },
    ],
    seller_type: [
        {
            id: "",
            name: "Unselected",
            key: "",
        },
        {
            id: "1",
            name: "Local",
            key: "1",
        },
        {
            id: "2",
            name: "Cross Border",
            key: "2",
        },
    ],
    sales_flag: [
        {
            id: "",
            name: "Unselected",
            key: "",
        },
        {
            id: "1",
            name: "Video Selling",
            key: "1",
        },
        {
            id: "2",
            name: "Live Selling",
            key: "2",
        },
    ],
    sales_trend_flag: [
        {
            id: "",
            name: "Unselected",
            key: "",
        },
        {
            id: "1",
            name: "Upward",
            key: "1",
        },
        {
            id: "2",
            name: "Downward",
            key: "2",
        },
    ],
    is_s_shop: [
        {
            id: "",
            name: "Unselected",
            key: "",
        },
        {
            id: "1",
            name: "Yes",
            key: "1",
        },
        {
            id: "0",
            name: "No",
            key: "0",
        },
    ],
    is_free_shipping: [
        {
            id: "",
            name: "Unselected",
            key: "",
        },
        {
            id: "1",
            name: "Yes",
            key: "1",
        },
        {
            id: "0",
            name: "No",
            key: "0",
        },
    ],
    region: [
        {
            id: "",
            name: "Unselected",
            key: "",
        },
        {
            id: "US",
            name: "US",
            key: "US",
        },
        {
            id: "MX",
            name: "Mexico",
            key: "MX",
        },
        {
            id: "BR",
            name: "Brazil",
            key: "BR",
        },
        {
            id: "VN",
            name: "Vietnam",
            key: "VN",
        },
        {
            id: "TH",
            name: "Thailand",
            key: "TH",
        },
        {
            id: "PH",
            name: "Philippines",
            key: "PH",
        },
        {
            id: "MY",
            name: "Malaysia",
            key: "MY",
        },
        {
            id: "ID",
            name: "Indonesia",
            key: "ID",
        },
        {
            id: "SG",
            name: "Singapore",
            key: "SG",
        },
        {
            id: "JP",
            name: "Japan",
            key: "JP",
        },
        {
            id: "GB",
            name: "UK",
            key: "GB",
        },
        {
            id: "ES",
            name: "Spain",
            key: "ES",
        },
        {
            id: "DE",
            name: "Germany",
            key: "DE",
        },
        {
            id: "IT",
            name: "Italy",
            key: "IT",
        },
        {
            id: "FR",
            name: "France",
            key: "FR",
        },
    ],
};

export const heightRow = 120;
